import { useId } from 'react';

// Main icons ************************************************************************************************************************

function Add() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-add b-icon-black"
    >
      <path
        d="M9 5V13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9H13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3077 1H4.69231C2.65311 1 1 2.65311 1 4.69231V13.3077C1 15.347 2.65311 17 4.69231 17H13.3077C15.347 17 17 15.347 17 13.3077V4.69231C17 2.65311 15.347 1 13.3077 1Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AddButton() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-add-button b-icon-main"
    >
      <path
        d="M4.99951 1V9"
        stroke="#ff220d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.999512 5H8.99951"
        stroke="#ff220d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AddButtonAlt() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-add-button-alt b-icon-main"
    >
      <path
        id="Vector"
        d="M6 3.3335V8.66683"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M3.33398 6H8.66732"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M8.87212 0.666748H3.12853C1.76906 0.666748 0.666992 1.76882 0.666992 3.12829V8.87188C0.666992 10.2314 1.76906 11.3334 3.12853 11.3334H8.87212C10.2316 11.3334 11.3337 10.2314 11.3337 8.87188V3.12829C11.3337 1.76882 10.2316 0.666748 8.87212 0.666748Z"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AddTransaction() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-add-transaction b-icon-main"
    >
      <path
        d="M7 3.88892V10.1111"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.88916 7H10.1114"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3505 0.777832H3.64963C2.06358 0.777832 0.777832 2.06358 0.777832 3.64963V10.3505C0.777832 11.9366 2.06358 13.2223 3.64963 13.2223H10.3505C11.9366 13.2223 13.2223 11.9366 13.2223 10.3505V3.64963C13.2223 2.06358 11.9366 0.777832 10.3505 0.777832Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Admin() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-admin b-icon-main"
    >
      <path
        d="M10.0003 10.4972C12.3015 10.4972 14.167 8.63167 14.167 6.33049C14.167 4.0293 12.3015 2.16382 10.0003 2.16382C7.6991 2.16382 5.83362 4.0293 5.83362 6.33049C5.83362 8.63167 7.6991 10.4972 10.0003 10.4972Z"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0093 13.6194L13.0592 16.5694C12.9426 16.6861 12.8343 16.9027 12.8093 17.061L12.6509 18.186C12.5926 18.5944 12.8759 18.8777 13.2843 18.8194L14.4092 18.661C14.5676 18.636 14.7926 18.5277 14.9009 18.411L17.8509 15.4611C18.3592 14.9527 18.6009 14.361 17.8509 13.611C17.1092 12.8694 16.5176 13.111 16.0093 13.6194Z"
        stroke="black"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5846 14.0439C15.8346 14.9439 16.5346 15.6439 17.4346 15.8939"
        stroke="black"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.8418 18.8316C2.8418 15.6066 6.05015 12.9983 10.0002 12.9983C10.8668 12.9983 11.7001 13.1233 12.4751 13.3566"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Alert() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-alert b-icon-gradient"
    >
      <g>
        <linearGradient
          id="SVGID_1"
          gradientUnits="userSpaceOnUse"
          x1="9"
          y1="0"
          x2="9"
          y2="18"
        >
          <stop offset="0" style={{ stopColor: '#F02959' }} />
          <stop offset="0.1023" style={{ stopColor: '#F3284A' }} />
          <stop offset="0.3165" style={{ stopColor: '#F8252F' }} />
          <stop offset="0.5355" style={{ stopColor: '#FC231C' }} />
          <stop offset="0.7604" style={{ stopColor: '#FE2211' }} />
          <stop offset="1" style={{ stopColor: '#FF220D' }} />
        </linearGradient>
        <circle fill="url(#SVGID_1)" cx="9" cy="9" r="9" />
      </g>
      <path
        fill="white"
        d="M10.12,12.84c0,0.33-0.11,0.59-0.32,0.8S9.32,13.94,9,13.94c-0.31,0-0.57-0.1-0.79-0.31s-0.33-0.47-0.33-0.8
		s0.11-0.59,0.33-0.81c0.22-0.21,0.48-0.31,0.79-0.31c0.32,0,0.58,0.11,0.8,0.31C10.01,12.24,10.12,12.51,10.12,12.84z M9.91,6.66
		c0,0.77-0.03,1.48-0.08,2.13c-0.06,0.64-0.13,1.29-0.21,1.95h-1.2c-0.09-0.65-0.17-1.3-0.22-1.95C8.13,8.13,8.1,7.43,8.1,6.66v-2.6
		h1.81V6.66z"
      />
    </svg>
  );
}

function ArrowBackMobile() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-arrow-back-mobile b-icon-black"
    >
      <path
        d="M20 4.43997C19.7467 4.43997 19.4934 4.53331 19.2934 4.73331L10.6 13.4266C9.18671 14.84 9.18671 17.16 10.6 18.5733L19.2934 27.2666C19.68 27.6533 20.32 27.6533 20.7067 27.2666C21.0934 26.88 21.0934 26.24 20.7067 25.8533L12.0134 17.16C11.3734 16.52 11.3734 15.48 12.0134 14.84L20.7067 6.14664C21.0934 5.75998 21.0934 5.11997 20.7067 4.73331C20.5067 4.54664 20.2534 4.43997 20 4.43997Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowBackPanel() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-arrow-back-panel b-icon-black"
    >
      <path
        d="M6.00065 10.0833C6.00065 9.51127 6.2231 8.93921 6.65976 8.50608L12.0315 3.17775C12.2704 2.94075 12.6659 2.94075 12.9048 3.17775C13.1437 3.41474 13.1437 3.80701 12.9048 4.04401L7.53307 9.37234C7.13761 9.76461 7.13761 10.4021 7.53307 10.7943L12.9048 16.1227C13.1437 16.3597 13.1437 16.7519 12.9048 16.9889C12.6659 17.2259 12.2704 17.2259 12.0315 16.9889L6.65976 11.6606C6.2231 11.2275 6.00065 10.6554 6.00065 10.0833Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowButton() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-arrow-button b-icon-main"
    >
      <path
        d="M0.83317 5L9.1665 5"
        stroke="#ff220d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99984 9.16732L9.1665 5.00065L4.99984 0.833984"
        stroke="#ff220d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowDown() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-arrow-down b-icon-black"
    >
      <path
        d="M7.5002 10.6122C7.0627 10.6122 6.6252 10.4435 6.29395 10.1122L2.21895 6.03721C2.0377 5.85596 2.0377 5.55596 2.21895 5.37471C2.4002 5.19346 2.7002 5.19346 2.88145 5.37471L6.95645 9.44971C7.25645 9.74971 7.74395 9.74971 8.04395 9.44971L12.1189 5.37471C12.3002 5.19346 12.6002 5.19346 12.7814 5.37471C12.9627 5.55596 12.9627 5.85596 12.7814 6.03721L8.70645 10.1122C8.3752 10.4435 7.9377 10.6122 7.5002 10.6122Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowDownMobileFilter() {
  return (
    <svg
      width="18"
      height="9"
      viewBox="0 0 18 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-arrow-down-filter-mobile"
    >
      <path
        d="M8.85305 8.5975C8.15305 8.5975 7.45305 8.3275 6.92305 7.7975L0.403047 1.2775C0.113047 0.987499 0.113047 0.5075 0.403047 0.2175C0.693047 -0.0725 1.17305 -0.0725 1.46305 0.2175L7.98305 6.7375C8.46305 7.2175 9.24305 7.2175 9.72305 6.7375L16.243 0.2175C16.533 -0.0725 17.013 -0.0725 17.303 0.2175C17.593 0.5075 17.593 0.987499 17.303 1.2775L10.783 7.7975C10.253 8.3275 9.55305 8.5975 8.85305 8.5975Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowUp() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-arrow-top b-icon-black"
    >
      <path
        d="M7.5,5.2c0.4,0,0.9,0.2,1.2,0.5l4.1,4.1c0.2,0.2,0.2,0.5,0,0.7c-0.2,0.2-0.5,0.2-0.7,0L8,6.4C7.7,6.1,7.3,6.1,7,6.4
	l-4.1,4.1c-0.2,0.2-0.5,0.2-0.7,0C2,10.3,2,10,2.2,9.8l4.1-4.1C6.6,5.4,7.1,5.2,7.5,5.2z"
        fill="black"
      />
    </svg>
  );
}

function ArrowUp2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2952_38785)">
        <path
          d="M0.571326 8L15.4285 8"
          stroke="#6C7786"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4285 12L15.4285 8L11.4285 4"
          stroke="#6C7786"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2952_38785">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(16) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function ArrowDownMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className="b-icon b-icon-arrow-down-mobile b-icon-black"
    >
      <path
        d="M24 29C23.1924 29 22.3848 28.686 21.7733 28.0695L14.2509 20.4859C13.9164 20.1486 13.9164 19.5903 14.2509 19.253C14.5855 18.9157 15.1393 18.9157 15.4739 19.253L22.9963 26.8366C23.55 27.3949 24.45 27.3949 25.0037 26.8366L32.5261 19.253C32.8607 18.9157 33.4145 18.9157 33.7491 19.253C34.0836 19.5903 34.0836 20.1486 33.7491 20.4859L26.2267 28.0695C25.6152 28.686 24.8076 29 24 29Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowRight() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-arrow-right b-icon-black"
    >
      <path
        d="M4.49937 10.335C4.59437 10.335 4.68937 10.3 4.76437 10.225L8.02438 6.96501C8.55437 6.43501 8.55437 5.56501 8.02438 5.03501L4.76437 1.77501C4.61937 1.63001 4.37937 1.63001 4.23438 1.77501C4.08938 1.92001 4.08938 2.16001 4.23438 2.30501L7.49437 5.56501C7.73437 5.80501 7.73437 6.19501 7.49437 6.43501L4.23438 9.69501C4.08938 9.84001 4.08938 10.08 4.23438 10.225C4.30937 10.295 4.40438 10.335 4.49937 10.335Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowLeftMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className="b-icon b-icon-arrow-left-mobile b-icon-black"
    >
      <path
        d="M19 24C19 23.1924 19.314 22.3848 19.9305 21.7733L27.5141 14.2509C27.8514 13.9164 28.4097 13.9164 28.747 14.2509C29.0843 14.5855 29.0843 15.1393 28.747 15.4739L21.1634 22.9962C20.6051 23.55 20.6051 24.45 21.1634 25.0037L28.747 32.5261C29.0843 32.8607 29.0843 33.4145 28.747 33.7491C28.4097 34.0836 27.8514 34.0836 27.5141 33.7491L19.9305 26.2267C19.314 25.6152 19 24.8076 19 24Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowRightMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className="b-icon b-icon-arrow-right-mobile b-icon-black"
    >
      <path
        d="M29 24C29 24.8076 28.686 25.6152 28.0695 26.2267L20.4859 33.7491C20.1486 34.0836 19.5903 34.0836 19.253 33.7491C18.9157 33.4145 18.9157 32.8607 19.253 32.5261L26.8366 25.0038C27.3949 24.45 27.3949 23.55 26.8366 22.9963L19.253 15.4739C18.9157 15.1393 18.9157 14.5855 19.253 14.2509C19.5903 13.9164 20.1486 13.9164 20.4859 14.2509L28.0695 21.7733C28.686 22.3848 29 23.1924 29 24Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowFooter() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
      className="b-icon b-icon-arrow-footer b-icon-black"
    >
      <path
        d="M8 8C7.35391 8 6.70782 7.74877 6.21863 7.2556L0.20075 1.18872C-0.0669166 0.918871 -0.0669166 0.47223 0.20075 0.202384C0.468416 -0.0674615 0.911451 -0.0674615 1.17912 0.202384L7.197 6.26927C7.64003 6.71591 8.35997 6.71591 8.803 6.26927L14.8209 0.202384C15.0885 -0.0674615 15.5316 -0.0674615 15.7992 0.202384C16.0669 0.47223 16.0669 0.918871 15.7992 1.18872L9.78137 7.2556C9.29218 7.74877 8.64609 8 8 8Z"
        fill="black"
      />
    </svg>
  );
}

function AddressCar() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-address-car"
    >
      <path
        d="M12.4993 10.0013V1.66797H4.99935C3.15768 1.66797 1.66602 3.15964 1.66602 5.0013V11.668M12.4993 10.0013C12.4993 10.918 11.7493 11.668 10.8327 11.668H1.66602M12.4993 10.0013V4.16797H14.0327C14.6327 4.16797 15.1827 4.49298 15.4827 5.00964L16.9077 7.5013M1.66602 11.668V14.168C1.66602 15.5513 2.78268 16.668 4.16602 16.668H4.99935M18.3327 11.668V14.168C18.3327 15.5513 17.216 16.668 15.8327 16.668H14.9993M18.3327 11.668H15.8327C15.3743 11.668 14.9993 11.293 14.9993 10.8346V8.33464C14.9993 7.8763 15.3743 7.5013 15.8327 7.5013H16.9077M18.3327 11.668V10.0013L16.9077 7.5013M14.9993 16.668C14.9993 15.7513 14.2493 15.0013 13.3327 15.0013M14.9993 16.668C14.9993 17.5884 14.2532 18.3346 13.3327 18.3346C12.4122 18.3346 11.666 17.5884 11.666 16.668M14.9993 16.668C14.9993 15.7475 14.2532 15.0013 13.3327 15.0013M13.3327 15.0013C12.416 15.0013 11.666 15.7513 11.666 16.668M13.3327 15.0013C12.4122 15.0013 11.666 15.7475 11.666 16.668M11.666 16.668H8.33268M8.33268 16.668C8.33268 15.7513 7.58268 15.0013 6.66602 15.0013M8.33268 16.668C8.33268 17.5884 7.58649 18.3346 6.66602 18.3346C5.74554 18.3346 4.99935 17.5884 4.99935 16.668M8.33268 16.668C8.33268 15.7475 7.58649 15.0013 6.66602 15.0013M6.66602 15.0013C5.74935 15.0013 4.99935 15.7513 4.99935 16.668M6.66602 15.0013C5.74554 15.0013 4.99935 15.7475 4.99935 16.668"
        stroke="url(#paint0_linear_20530_62379)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20530_62379"
          x1="5.92528"
          y1="14.168"
          x2="14.6571"
          y2="3.43516"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function CardAddress() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-address"
    >
      <g clipPath="url(#clip0_10500_52017)">
        <path
          d="M8 1V5.3077"
          stroke="url(#paint0_linear_10500_52017)"
          strokeWidth="1.41347"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 5.30469H15V13.9201C15 14.2057 14.8865 14.4797 14.6846 14.6816C14.4827 14.8835 14.2087 14.997 13.9231 14.997H2.07693C1.7913 14.997 1.51739 14.8835 1.31542 14.6816C1.11346 14.4797 1 14.2057 1 13.9201V5.30469Z"
          stroke="url(#paint1_linear_10500_52017)"
          strokeWidth="1.41347"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 5.3077L2.61539 2.19539C2.78954 1.8446 3.05603 1.54794 3.38621 1.33731C3.71638 1.12668 4.09773 1.01006 4.48924 1H11.5108C11.9115 1.00021 12.3042 1.1122 12.6448 1.32338C12.9853 1.53455 13.2602 1.83655 13.4385 2.19539L15 5.3077"
          stroke="url(#paint2_linear_10500_52017)"
          strokeWidth="1.41347"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 7.67969V12.6464"
          stroke="url(#paint3_linear_10500_52017)"
          strokeWidth="1.41347"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.88492 10.7969L8.00007 12.6817L6.11523 10.7969"
          stroke="url(#paint4_linear_10500_52017)"
          strokeWidth="1.41347"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10500_52017"
          x1="8.25556"
          y1="4.23078"
          x2="9.47197"
          y2="3.88368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10500_52017"
          x1="4.57779"
          y1="12.5739"
          x2="9.01304"
          y2="4.69931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10500_52017"
          x1="4.57779"
          y1="4.23078"
          x2="5.66376"
          y2="-0.107469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10500_52017"
          x1="8.25556"
          y1="11.4047"
          x2="9.49509"
          y2="11.0979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10500_52017"
          x1="7.0786"
          y1="12.2105"
          x2="7.78261"
          y2="10.4797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <clipPath id="clip0_10500_52017">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function CardDetails() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-details"
    >
      <g clipPath="url(#clip0_10500_52032)">
        <path
          d="M11.1423 3.42969H4.85658C4.541 3.42969 4.28516 3.68553 4.28516 4.00112V14.7154C4.28516 15.0309 4.541 15.2868 4.85658 15.2868H11.1423C11.4578 15.2868 11.7137 15.0309 11.7137 14.7154V4.00112C11.7137 3.68553 11.4578 3.42969 11.1423 3.42969Z"
          stroke="url(#paint0_linear_10500_52032)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99888 10.7868C8.78787 10.7868 9.42746 10.1472 9.42746 9.35826C9.42746 8.56928 8.78787 7.92969 7.99888 7.92969C7.2099 7.92969 6.57031 8.56928 6.57031 9.35826C6.57031 10.1472 7.2099 10.7868 7.99888 10.7868Z"
          stroke="url(#paint1_linear_10500_52032)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.17741 5.2394H1.22472C1.07499 5.2394 0.931388 5.17919 0.825512 5.07204C0.719636 4.96487 0.660156 4.81952 0.660156 4.66797V1.2394C0.660156 1.08785 0.719636 0.9425 0.825512 0.835337C0.931388 0.728172 1.07499 0.667969 1.22472 0.667969H14.7742C14.9239 0.667969 15.0674 0.728172 15.1734 0.835337C15.2792 0.9425 15.3388 1.08785 15.3388 1.2394V4.66797C15.3388 4.81952 15.2792 4.96487 15.1734 5.07204C15.0674 5.17919 14.9239 5.2394 14.7742 5.2394H13.8215"
          stroke="url(#paint2_linear_10500_52032)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00028 5.95368C7.92138 5.95368 7.85742 5.88973 7.85742 5.81083C7.85742 5.73193 7.92138 5.66797 8.00028 5.66797"
          stroke="url(#paint3_linear_10500_52032)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 5.95368C8.0789 5.95368 8.14286 5.88973 8.14286 5.81083C8.14286 5.73193 8.0789 5.66797 8 5.66797"
          stroke="url(#paint4_linear_10500_52032)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00028 13.1099C7.92139 13.1099 7.85742 13.0459 7.85742 12.9671C7.85742 12.8881 7.92139 12.8242 8.00028 12.8242"
          stroke="url(#paint5_linear_10500_52032)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 13.1099C8.0789 13.1099 8.14286 13.0459 8.14286 12.9671C8.14286 12.8881 8.0789 12.8242 8 12.8242"
          stroke="url(#paint6_linear_10500_52032)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10500_52032"
          x1="6.18357"
          y1="12.3225"
          x2="12.3178"
          y2="7.59872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10500_52032"
          x1="7.30047"
          y1="10.0725"
          x2="8.79735"
          y2="8.23263"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10500_52032"
          x1="4.41135"
          y1="4.09654"
          x2="5.57615"
          y2="-0.500666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10500_52032"
          x1="7.89393"
          y1="5.88225"
          x2="8.03033"
          y2="5.79842"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10500_52032"
          x1="8.03651"
          y1="5.88225"
          x2="8.17291"
          y2="5.79842"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10500_52032"
          x1="7.89393"
          y1="13.0385"
          x2="8.03033"
          y2="12.9547"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10500_52032"
          x1="8.03651"
          y1="13.0385"
          x2="8.17291"
          y2="12.9547"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <clipPath id="clip0_10500_52032">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function CardFavorite() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
    >
      <defs>
        <linearGradient
          id="favorite-heart-gradient"
          x1="0.75"
          y1="9.82445"
          x2="20.75"
          y2="9.82445"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72717" />
          <stop offset="1" stopColor="#FF007D" />
        </linearGradient>
      </defs>
      <path
        className="card-favorite-path"
        fill="#94A3B8"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.37 18.46C11.03 18.58 10.47 18.58 10.13 18.46C7.23 17.47 0.75 13.34 0.75 6.34C0.75 3.25 3.24 0.75 6.31 0.75C8.13 0.75 9.74 1.63 10.75 2.99C11.76 1.63 13.38 0.75 15.19 0.75C18.26 0.75 20.75 3.25 20.75 6.34C20.75 13.34 14.27 17.47 11.37 18.46Z"
      />
    </svg>
  );
}

function CarouselPrevious() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className="b-icon b-icon-carousel-previous"
    >
      <path
        fill="#292D32"
        d="M7.7,12c0-0.7,0.3-1.4,0.8-1.9L15,3.5c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1l-6.5,6.5
			c-0.5,0.5-0.5,1.3,0,1.7l6.5,6.5c0.3,0.3,0.3,0.8,0,1.1c-0.3,0.3-0.8,0.3-1.1,0l-6.5-6.5C8,13.4,7.7,12.7,7.7,12z"
      />
    </svg>
  );
}

function CarouselNext() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className="b-icon b-icon-carousel-next"
    >
      <path
        fill="#292D32"
        d="M16.3,12c0,0.7-0.3,1.4-0.8,1.9L9,20.5c-0.3,0.3-0.8,0.3-1.1,0c-0.3-0.3-0.3-0.8,0-1.1l6.5-6.5
			c0.5-0.5,0.5-1.3,0-1.7L7.9,4.6c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l6.5,6.5C16,10.6,16.3,11.3,16.3,12z"
      />
    </svg>
  );
}

function Calendar() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-calendar b-icon-black"
    >
      <path
        d="M2.23077 3C1.90434 3 1.5913 3.12826 1.36048 3.35656C1.12967 3.58487 1 3.89451 1 4.21739V15.7826C1 16.1055 1.12967 16.4152 1.36048 16.6434C1.5913 16.8717 1.90434 17 2.23077 17H15.7692C16.0956 17 16.4087 16.8717 16.6395 16.6434C16.8703 16.4152 17 16.1055 17 15.7826V4.21739C17 3.89451 16.8703 3.58487 16.6395 3.35656C16.4087 3.12826 16.0956 3 15.7692 3H13.3077"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 7H17"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 1V5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 1V5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3H11"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CalendarEdit() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-calendar-edit b-icon-black"
    >
      <path
        d="M2.23077 3C1.90434 3 1.5913 3.12826 1.36048 3.35656C1.12967 3.58487 1 3.89451 1 4.21739V15.7826C1 16.1055 1.12967 16.4152 1.36048 16.6434C1.5913 16.8717 1.90434 17 2.23077 17H15.7692C16.0956 17 16.4087 16.8717 16.6395 16.6434C16.8703 16.4152 17 16.1055 17 15.7826V4.21739C17 3.89451 16.8703 3.58487 16.6395 3.35656C16.4087 3.12826 16.0956 3 15.7692 3H13.3077"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 1V5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 1V5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3H11"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 8.88305L7.49123 13.7032L5 14L5.35088 11.8202L10.8479 7L13 8.88305Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CardPlastic() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-plastic"
    >
      <path
        d="M3.33398 14.168H22.5007"
        stroke="url(#paint0_linear_13730_4935)"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1113 26.668H15.5558"
        stroke="url(#paint1_linear_13730_4935)"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 26.668L26.6667 26.668"
        stroke="url(#paint2_linear_13730_4935)"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6673 20.0487V26.8487C36.6673 32.6987 35.184 34.1654 29.2673 34.1654H10.734C4.81732 34.1654 3.33398 32.6987 3.33398 26.8487V13.1487C3.33398 7.2987 4.81732 5.83203 10.734 5.83203H22.5006"
        stroke="url(#paint3_linear_13730_4935)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 10.418H36.6667"
        stroke="url(#paint4_linear_13730_4935)"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M32.084 14.9987V5.83203"
        stroke="url(#paint5_linear_13730_4935)"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13730_4935"
          x1="8.23213"
          y1="14.918"
          x2="8.27748"
          y2="13.8497"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13730_4935"
          x1="12.2471"
          y1="27.418"
          x2="12.4367"
          y2="26.3825"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13730_4935"
          x1="21.7037"
          y1="27.418"
          x2="21.8324"
          y2="26.3635"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_13730_4935"
          x1="11.8525"
          y1="27.082"
          x2="26.0377"
          y2="6.56917"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_13730_4935"
          x1="29.8426"
          y1="11.168"
          x2="29.9368"
          y2="10.1061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_13730_4935"
          x1="32.3395"
          y1="12.707"
          x2="33.6318"
          y2="12.5338"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function CardVirtual() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-virtual"
    >
      <path
        d="M13.1641 30.7891H15.96"
        stroke="url(#paint0_linear_13730_25801)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4608 1.78125H4.99162C3.46236 1.78125 2.22266 3.02096 2.22266 4.55022V35.0089C2.22266 36.5382 3.46236 37.7778 4.99162 37.7778H24.3744C25.9036 37.7778 27.1434 36.5382 27.1434 35.0089V25.3175"
        stroke="url(#paint1_linear_13730_25801)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.998 6.66797H37.9989"
        stroke="url(#paint2_linear_13730_25801)"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 12H30"
        stroke="url(#paint3_linear_13730_25801)"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1673 1.61719H33.5998C36.9427 1.61719 37.7784 2.44352 37.7784 5.73948V13.4488C37.7784 16.7448 36.9427 17.5711 33.6092 17.5711H23.1673C19.8338 17.5805 18.998 16.7542 18.998 13.4582V5.73948C18.998 2.44352 19.8338 1.61719 23.1673 1.61719Z"
        stroke="url(#paint4_linear_13730_25801)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13730_25801"
          x1="13.8786"
          y1="31.5391"
          x2="14.1657"
          y2="30.5524"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13730_25801"
          x1="8.59128"
          y1="28.7787"
          x2="27.6049"
          y2="12.5989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13730_25801"
          x1="23.8538"
          y1="7.41797"
          x2="23.8996"
          y2="6.34973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_13730_25801"
          x1="24.7889"
          y1="12.75"
          x2="24.9116"
          y2="11.6941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_13730_25801"
          x1="23.7975"
          y1="13.5827"
          x2="31.7833"
          y2="2.0279"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function BadgeConfetti() {
  return (
    <svg
      width="160"
      height="124"
      viewBox="0 0 160 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-badge-confetti"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.771 58.6041C123.57 61.2043 126.818 62.8811 130.394 63.0691C130.475 63.0691 131.047 62.4702 131.007 62.5045C131.496 62.0427 131.967 61.5981 132.437 61.1363C132.907 60.674 133.397 60.2122 133.867 59.7504C133.949 59.6647 134.358 59.1687 134.439 59.1687C130.864 58.9807 127.615 57.3039 125.817 54.7031C125.878 54.7888 123.937 56.4656 123.774 56.6365C123.589 56.8073 121.649 58.4332 121.771 58.6041Z"
        fill="url(#paint0_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5586 96.7079C21.9279 97.273 23.3165 97.8219 24.6858 98.387C24.7986 98.435 26.4868 95.5297 26.562 95.562C25.1922 94.9969 23.8041 94.448 22.4348 93.8834C22.322 93.8344 20.615 96.724 20.5586 96.7079Z"
        fill="url(#paint1_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.9434 7.42134C41.7882 7.77988 42.6449 8.12794 43.4904 8.48647C43.5594 8.51728 44.6013 6.67408 44.648 6.69441C43.8024 6.33587 42.9458 5.98781 42.1009 5.62928C42.0313 5.59909 40.9782 7.43181 40.9434 7.42134Z"
        fill="url(#paint2_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.2855 7.82073C65.8504 9.08798 66.3729 10.4229 67.6494 11.2714C67.8527 11.4067 68.8396 11.3163 69.1151 11.3163C69.4629 11.3277 69.7967 11.3277 70.1451 11.339C70.218 11.339 70.522 11.305 70.5803 11.339C69.3039 10.4792 68.7667 9.15565 69.2165 7.88887C69.1582 8.04693 66.3584 7.63997 66.2855 7.82073Z"
        fill="url(#paint3_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.67377 30.5113C10.5533 32.1685 12.5564 33.1309 14.642 32.9172C14.7642 32.8994 15.0913 31.7589 15.1323 31.6339C15.1733 31.5095 15.4799 30.3512 15.5817 30.3512C13.4967 30.5649 11.5142 29.603 10.6141 27.9453C10.7166 28.1239 10.2057 29.0328 10.1238 29.2286C10.0419 29.4602 9.5515 30.2798 9.67377 30.5113Z"
        fill="url(#paint4_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.8175 27.948C44.8674 28.6584 43.8974 29.3536 42.9473 30.064C43.0068 30.0186 45.1643 31.5908 45.2634 31.5151C46.2136 30.8047 47.1836 30.1094 48.1337 29.399C48.0544 29.4445 45.9167 27.8722 45.8175 27.948Z"
        fill="url(#paint5_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.987 28.823C156.037 29.5334 155.067 30.2286 154.117 30.939C154.177 30.8936 156.334 32.4658 156.433 32.3901C157.384 31.6797 158.354 30.9844 159.304 30.274C159.224 30.3195 157.087 28.7472 156.987 28.823Z"
        fill="url(#paint6_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.327 25.5548C114.016 27.203 114.762 28.807 116.397 29.999C116.479 30.0727 118.116 29.4396 118.302 29.3806C118.467 29.3221 120.102 28.6895 120.185 28.7332C118.55 27.556 117.784 25.9377 118.116 24.2891C118.094 24.407 116.418 24.8337 116.21 24.9074C115.962 24.9959 114.368 25.3783 114.327 25.5548Z"
        fill="url(#paint7_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.656 11.4322H139.891C139.996 11.4322 140.06 8.57422 140.102 8.57422H135.867C135.782 8.57422 135.698 11.4322 135.656 11.4322Z"
        fill="url(#paint8_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.8305 1.12811C95.675 0.751908 94.5195 0.376201 93.3634 0C93.4734 0.036582 92.5744 2.11632 92.7214 2.16822L96.1885 3.29633C96.0784 3.25925 96.9867 1.1726 96.8305 1.12811Z"
        fill="url(#paint9_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.02 60.2621C154.68 61.5586 154.496 63.2163 155.512 64.6603C155.582 64.7585 157.083 64.6603 157.268 64.6603C157.453 64.6603 158.955 64.5617 159.025 64.6439C158.008 63.1999 158.216 61.5421 159.533 60.2456C159.441 60.3443 157.985 60.2456 157.776 60.2456C157.522 60.2456 156.159 60.131 156.02 60.2621Z"
        fill="url(#paint10_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.897 82.9446C135.872 83.2901 134.219 84.6353 133.532 86.5265C133.439 86.7627 135.909 87.8899 135.836 88.0897C136.541 86.1991 138.175 84.8539 140.2 84.5084C140.014 84.5448 139.234 83.8355 139.048 83.708C138.863 83.5628 138.157 82.8899 137.897 82.9446Z"
        fill="url(#paint11_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.30353 60.5312C1.5369 61.7134 0.770932 62.895 0.00430999 64.0766C-0.119569 64.2708 2.46891 65.5173 2.36579 65.6795C3.13176 64.4979 3.89838 63.3158 4.66501 62.1341C4.78953 61.9395 2.17965 60.693 2.30353 60.5312Z"
        fill="url(#paint12_linear_26016_50774)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.519 55.9414C29.6956 55.7248 27.8716 55.5074 26.0488 55.3125C25.9667 55.3125 25.5567 58.5447 25.5156 58.5447C27.339 58.7613 29.1625 58.978 30.9865 59.1736C31.0686 59.1953 31.4786 55.9414 31.519 55.9414Z"
        fill="url(#paint13_linear_26016_50774)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_26016_50774"
          x1="121.766"
          y1="63.0691"
          x2="135.626"
          y2="57.8622"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.17" stopColor="#006EFF" />
          <stop offset="1" stopColor="#0DDAD4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_26016_50774"
          x1="20.5586"
          y1="98.3876"
          x2="27.313"
          y2="96.1554"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.17" stopColor="#006EFF" />
          <stop offset="1" stopColor="#0DDAD4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_26016_50774"
          x1="44.648"
          y1="8.48686"
          x2="40.472"
          y2="7.32878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB648" />
          <stop offset="1" stopColor="#F3365E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_26016_50774"
          x1="66.1348"
          y1="11.3459"
          x2="71.2003"
          y2="9.78276"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.17" stopColor="#006EFF" />
          <stop offset="1" stopColor="#0DDAD4" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_26016_50774"
          x1="15.5817"
          y1="32.9467"
          x2="8.82084"
          y2="31.2325"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB648" />
          <stop offset="1" stopColor="#F3365E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_26016_50774"
          x1="48.1337"
          y1="31.5178"
          x2="44.7959"
          y2="26.672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1077FF" />
          <stop offset="1" stopColor="#9E00FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_26016_50774"
          x1="159.304"
          y1="32.3927"
          x2="155.966"
          y2="27.5469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1077FF" />
          <stop offset="1" stopColor="#9E00FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_26016_50774"
          x1="117.222"
          y1="24.2891"
          x2="116.729"
          y2="29.9621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00A8" />
          <stop offset="1" stopColor="#FF9898" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_26016_50774"
          x1="140.102"
          y1="11.4322"
          x2="135.243"
          y2="9.81534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB648" />
          <stop offset="1" stopColor="#F3365E" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_26016_50774"
          x1="96.8486"
          y1="3.29633"
          x2="93.6366"
          y2="-0.74109"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1077FF" />
          <stop offset="1" stopColor="#9E00FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_26016_50774"
          x1="157.198"
          y1="60.1992"
          x2="156.809"
          y2="64.6702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00A8" />
          <stop offset="1" stopColor="#FF9898" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_26016_50774"
          x1="136.865"
          y1="82.9414"
          x2="136.508"
          y2="88.0649"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00A8" />
          <stop offset="1" stopColor="#FF9898" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_26016_50774"
          x1="2.33466"
          y1="60.5312"
          x2="1.82822"
          y2="65.6292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF00A8" />
          <stop offset="1" stopColor="#FF9898" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_26016_50774"
          x1="31.519"
          y1="59.1737"
          x2="27.4685"
          y2="53.8317"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1F7D" />
          <stop offset="1" stopColor="#711CFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function Cards() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-cards b-icon-black"
    >
      <path
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.8,2.6h8.3c2.7,0,3.3,0.7,3.3,3.3v6.2c0,2.6-0.7,3.3-3.3,3.3H4.8c-2.7,0-3.3-0.7-3.3-3.3V5.9
		C1.5,3.3,2.2,2.6,4.8,2.6z"
      />
      <path
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M1.5,6.4h15"
      />
      <path
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M4.5,11.4H6"
      />
      <path
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M8.9,11.4h3"
      />
      <path
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.8,2.6h8.3c2.7,0,3.3,0.7,3.3,3.3v6.2c0,2.6-0.7,3.3-3.3,3.3H4.8c-2.7,0-3.3-0.7-3.3-3.3V5.9
			C1.5,3.3,2.2,2.6,4.8,2.6z"
      />
    </svg>
  );
}

function CardTransactionTopup() {
  return (
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-transaction-topup"
    >
      <path
        fill="#7FD0D6"
        fillOpacity="0.2"
        d="M9.8,0h24.4C39.6,0,44,4.4,44,9.8v24.4c0,5.4-4.4,9.8-9.8,9.8H9.8C4.4,44,0,39.6,0,34.2
	V9.8C0,4.4,4.4,0,9.8,0z"
      />
      <path
        fill="none"
        stroke="#31B39C"
        strokeWidth="1.9637"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.5,31.3
		c4.9,0,8.8-3.9,8.8-8.8s-3.9-8.8-8.8-8.8s-8.8,3.9-8.8,8.8S16.7,31.3,21.5,31.3z"
      />
      <path
        fill="none"
        stroke="#31B39C"
        strokeWidth="1.9637"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.5,18.4v8.2"
      />
      <path
        fill="none"
        stroke="#31B39C"
        strokeWidth="1.9637"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.4,22.5h8.2"
      />
    </svg>
  );
}

function CardTransactionBlue() {
  return (
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-transaction-blue"
    >
      <path
        fill="#F0F7FF"
        d="M9.8,0h24.4C39.6,0,44,4.4,44,9.8v24.4c0,5.4-4.4,9.8-9.8,9.8H9.8C4.4,44,0,39.6,0,34.2V9.8
   C0,4.4,4.4,0,9.8,0z"
      />
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
   M13.7,19.1h16.7"
      />
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
   M17,24.6h1.7"
      />
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="
   M21.9,24.6h3.3"
      />
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.4,14.9h9.3
   c3,0,3.7,0.7,3.7,3.7v6.8c0,2.9-0.7,3.7-3.7,3.7h-9.3c-3,0-3.7-0.7-3.7-3.6v-6.9C13.7,15.7,14.4,14.9,17.4,14.9z"
      />
    </svg>
  );
}

function CardTransactionCultural() {
  return (
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-transaction-cultural"
    >
      <path
        fill="#FFBD3D"
        fillOpacity="0.1"
        d="M5,0h34c2.8,0,5,2.2,5,5v34c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5C0,2.2,2.2,0,5,0z"
      />
      <path
        fill="none"
        stroke="#FFBD3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19,16l-0.6,0.1
		c0.1,0.2,0.1,0.5,0,0.7c0,0.2-0.1,0.5-0.2,0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.6,0.3c-0.5,0.1-0.9,0-1.3-0.2
		c-0.4-0.3-0.7-0.7-0.8-1.1l-1.1,0.2c-0.2,0-0.3,0.1-0.4,0.2s-0.2,0.2-0.3,0.4C13.1,17.8,13,18,13,18.2c0,0.2,0,0.3,0,0.5
		c0,0,0.5,2.5,1.1,5.3"
      />
      <path
        fill="none"
        stroke="#FFBD3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M30.9,15.3
		c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.4-0.7,0.5c-0.3,0.1-0.5,0.2-0.8,0.2c-0.3,0-0.6,0-0.8-0.2c-0.3-0.1-0.5-0.3-0.7-0.5
		c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-0.8c0-0.3,0.1-0.6,0.2-0.8l-1.3-0.6c-0.3-0.1-0.7-0.1-1.1,0
		c-0.3,0.1-0.6,0.4-0.8,0.8l-5.2,12.8l-0.7,1.6c-0.1,0.3-0.1,0.7,0,1.1c0.1,0.4,0.4,0.6,0.7,0.8l6.3,2.8c0.3,0.1,0.7,0.1,1.1,0
		c0.3-0.1,0.6-0.4,0.8-0.8l5.9-14.4c0.1-0.3,0.1-0.7,0-1c-0.1-0.3-0.4-0.6-0.7-0.8L30.9,15.3z"
      />
    </svg>
  );
}

function CardTransactionGift() {
  return (
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-transaction-gift"
    >
      <path
        fill="#81C105"
        fillOpacity="0.1"
        d="M5,0h34c2.8,0,5,2.2,5,5v34c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5C0,2.2,2.2,0,5,0z"
      />
      <path
        fill="none"
        stroke="#62B422"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M30.3,30.2V21H13.7v9.2
		c0,0.9,0.7,1.6,1.6,1.6h13.4C29.6,31.8,30.3,31.1,30.3,30.2z"
      />
      <path
        fill="none"
        stroke="#62B422"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22,31.8V21"
      />
      <path
        fill="none"
        stroke="#62B422"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M31.6,18.5v0.9
		c0,0.9-0.7,1.6-1.6,1.6H13.9c-0.9,0-1.6-0.7-1.6-1.6v-0.9c0-0.9,0.7-1.6,1.6-1.6h16.1C30.9,17,31.6,17.7,31.6,18.5z"
      />
      <path
        fill="none"
        stroke="#62B422"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22,17
		c0-1.4-1.6-4.6-4-4.6c-3.9,0-2.5,4.6-0.6,4.6"
      />
      <path
        fill="none"
        stroke="#62B422"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22,17
		c0-1.4,1.6-4.6,4-4.6c3.9,0,2.5,4.6,0.6,4.6"
      />
    </svg>
  );
}

function CardTransactionMeal() {
  return (
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-transaction-meal"
    >
      <path
        fill="#31B39C"
        fillOpacity="0.1"
        d="M5,0h34c2.8,0,5,2.2,5,5v34c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5C0,2.2,2.2,0,5,0z"
      />
      <path
        fill="none"
        stroke="#00A184"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M25.2,33V11
	c6.9,3.4,7.8,12.7,7.8,16.1h-7.8"
      />
      <path
        fill="none"
        stroke="#00A184"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.9,11v22"
      />
      <path
        fill="none"
        stroke="#00A184"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.9,11v4.2
	c0,0.6-0.1,1.1-0.4,1.6c-0.2,0.5-0.6,1-1.1,1.4c-0.5,0.4-1,0.7-1.6,0.9c-0.6,0.2-1.2,0.3-1.9,0.3c-1.3,0-2.6-0.4-3.5-1.2
	c-0.9-0.8-1.4-1.9-1.4-3V11"
      />
    </svg>
  );
}

function CardTransactionVacation() {
  return (
    <svg
      width="44px"
      height="44px"
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-card-transaction-vacation"
    >
      <path
        fill="#0E8AFF"
        fillOpacity="0.1"
        d="M5,0h34c2.8,0,5,2.2,5,5v34c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5C0,2.2,2.2,0,5,0z"
      />
      <path
        fill="none"
        stroke="#0E8AFF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M31.9,31.9h-0.8
		c-0.8,0-1.6-0.3-2.2-1c-0.6-0.6-0.9-1.5-0.9-2.3c0,0.9-0.3,1.7-0.9,2.3c-0.6,0.6-1.3,1-2.2,1c-0.8,0-1.6-0.3-2.2-1
		c-0.6-0.6-0.9-1.5-0.9-2.3c0,0.9-0.3,1.7-0.9,2.3c-0.6,0.6-1.3,1-2.2,1c-0.8,0-1.6-0.3-2.2-1c-0.6-0.6-0.9-1.5-0.9-2.3
		c0,0.9-0.3,1.7-0.9,2.3c-0.6,0.6-1.3,1-2.2,1h-0.8"
      />
      <path
        fill="none"
        stroke="#0E8AFF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M26.4,25.3
		c-0.8-0.7-1.8-1.2-3-1.6c-1.1-0.4-2.4-0.6-3.6-0.6c-1.3,0-2.5,0.2-3.6,0.6c-1.1,0.4-2.1,0.9-3,1.6"
      />
      <path
        fill="none"
        stroke="#0E8AFF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.9,23.1
		c0.1-3.4,1.1-6.6,3.3-7.7"
      />
      <path
        fill="none"
        stroke="#0E8AFF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.8,12.2
		c1-0.2,1.9,0,2.8,0.6c0.8,0.6,1.4,1.5,1.6,2.6"
      />
      <path
        fill="none"
        stroke="#0E8AFF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M30.8,15.4
		c-0.8-0.6-2-1-3.2-1.1c-1.2-0.1-2.4,0.1-3.4,0.6"
      />
      <path
        fill="none"
        stroke="#0E8AFF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.7,16.5
		c0.6-1,1.5-1.7,2.6-2s2.2-0.3,3.2,0.2c1,0.3,1.9,0.9,2.4,1.9c0.6,0.9,0.7,2.1,0.5,3.2"
      />
    </svg>
  );
}

function Cashback() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-cashback b-icon-black"
    >
      <path
        d="M12 11C14.7614 11 17 8.76143 17 6C17 3.23858 14.7614 1 12 1C9.23858 1 7 3.23858 7 6C7 8.76143 9.23858 11 12 11Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7V5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 14L4.1102 16.4437C4.56766 16.8032 5.14429 17 5.73976 17H13.9394C14.5251 17 15 16.5523 15 16C15 14.8954 14.0503 14 12.8788 14H7.17819"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.77653 12.8085L5.72066 13.651C6.24209 14.1163 7.08751 14.1163 7.60893 13.651C8.13036 13.1857 8.13036 12.4313 7.60893 11.9659L6.14337 10.6581C5.6712 10.2367 5.03083 10 4.36309 10H1"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Check() {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-check b-icon-black"
    >
      <path
        d="M1 6.6483L3.30088 9.48051C3.37795 9.57623 3.47648 9.65416 3.58922 9.70853C3.70195 9.7629 3.826 9.79234 3.95221 9.79466C4.07842 9.79699 4.20356 9.77214 4.3184 9.72196C4.43323 9.67177 4.53483 9.59753 4.61568 9.50472L11.9566 1"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CheckDark() {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666504 2.99935L2.80192 5.33268L7.0803 0.666016"
        stroke="#0F172A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CheckAlt() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-check-alt"
    >
      <path
        d="M11.8291 0.888916H4.17097C2.35835 0.888916 0.888916 2.35835 0.888916 4.17097V11.8291C0.888916 13.6418 2.35835 15.1111 4.17097 15.1111H11.8291C13.6418 15.1111 15.1111 13.6418 15.1111 11.8291V4.17097C15.1111 2.35835 13.6418 0.888916 11.8291 0.888916Z"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5556 5.33337L6.81483 10.6667L4.44446 9.06671"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Checklist() {
  return (
    <svg
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-checklist"
    >
      <path
        fill="#000000"
        d="M222-200 80-342l56-56 85 85 170-170 56 57-225 226Zm0-320L80-662l56-56 85 85 170-170 56 57-225 226Zm298 240v-80h360v80H520Zm0-320v-80h360v80H520Z"
      />
    </svg>
  );
}

function ChevronLeft() {
  return (
    <svg
      width="8"
      height="16"
      viewBox="0 0 8 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 15L1.4882 9.23737C0.837267 8.55682 0.837267 7.44318 1.4882 6.76263L7 1"
        stroke="#334155"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ClearFilters() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 10.75C16.25 13.79 13.79 16.25 10.75 16.25C7.71 16.25 5.85999 13.19 5.85999 13.19M5.85999 15.94V13.19H8.34M5.25 10.75C5.25 7.71 7.69 5.25 10.75 5.25C14.42 5.25 16.25 8.31 16.25 8.31M13.81 8.31H16.25V5.56M7.75 20.75H13.75C18.75 20.75 20.75 18.75 20.75 13.75V7.75C20.75 2.75 18.75 0.75 13.75 0.75H7.75C2.75 0.75 0.75 2.75 0.75 7.75V13.75C0.75 18.75 2.75 20.75 7.75 20.75Z"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CloseDelete() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-close-delete b-icon-black"
    >
      <path
        d="M17.3569 0.642578L0.642578 17.3569"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.642578 0.642578L17.3569 17.3569"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CloseSquare() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M5.38156 9.1549L9.1549 5.38156M9.1549 9.1549L5.38156 5.38156M5.26823 13.9349H9.26823C12.6016 13.9349 13.9349 12.6016 13.9349 9.26823V5.26823C13.9349 1.9349 12.6016 0.601562 9.26823 0.601562H5.26823C1.9349 0.601562 0.601562 1.9349 0.601562 5.26823V9.26823C0.601562 12.6016 1.9349 13.9349 5.26823 13.9349Z"
        stroke="#64748B"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Cog() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-cog b-icon-black"
    >
      <path
        d="M6.92365 3.15385L7.42801 1.78769C7.51307 1.55639 7.66273 1.35743 7.85737 1.21688C8.05201 1.07632 8.28256 1.00073 8.51884 1H9.48064C9.71692 1.00073 9.94748 1.07632 10.1421 1.21688C10.3368 1.35743 10.4864 1.55639 10.5715 1.78769L11.0758 3.15385L12.7883 4.18769L14.1723 3.96615C14.4028 3.93333 14.6374 3.97313 14.8463 4.08052C15.0551 4.1879 15.2288 4.35801 15.3453 4.56923L15.8144 5.43077C15.9347 5.64535 15.9901 5.89314 15.9734 6.14144C15.9566 6.38974 15.8685 6.62687 15.7206 6.82154L14.8644 7.96615V10.0338L15.7441 11.1785C15.892 11.3731 15.9801 11.6103 15.9968 11.8586C16.0136 12.1069 15.9581 12.3546 15.8379 12.5692L15.3687 13.4308C15.2522 13.642 15.0785 13.8121 14.8698 13.9195C14.6609 14.0268 14.4263 14.0667 14.1958 14.0338L12.8117 13.8123L11.0993 14.8462L10.5949 16.2123C10.5099 16.4436 10.3602 16.6426 10.1656 16.7831C9.97094 16.9237 9.74038 16.9993 9.5041 17H8.51884C8.28256 16.9993 8.05201 16.9237 7.85737 16.7831C7.66273 16.6426 7.51307 16.4436 7.42801 16.2123L6.92365 14.8462L5.21117 13.8123L3.82711 14.0338C3.59665 14.0667 3.36209 14.0268 3.15324 13.9195C2.9444 13.8121 2.77069 13.642 2.65418 13.4308L2.185 12.5692C2.06478 12.3546 2.00939 12.1069 2.02614 11.8586C2.04289 11.6103 2.131 11.3731 2.27884 11.1785L3.13508 10.0338V7.96615L2.25538 6.82154C2.10754 6.62687 2.01943 6.38974 2.00268 6.14144C1.98593 5.89314 2.04132 5.64535 2.16155 5.43077L2.63072 4.56923C2.74723 4.35801 2.92094 4.1879 3.12978 4.08052C3.33863 3.97313 3.57319 3.93333 3.80365 3.96615L5.18771 4.18769L6.92365 3.15385ZM6.65388 9C6.65388 9.48684 6.79146 9.96276 7.04923 10.3676C7.307 10.7724 7.67337 11.0879 8.10202 11.2742C8.53068 11.4605 9.00235 11.5092 9.4574 11.4142C9.91245 11.3193 10.3304 11.0848 10.6585 10.7406C10.9866 10.3963 11.21 9.95771 11.3005 9.48022C11.391 9.00273 11.3446 8.5078 11.167 8.05801C10.9895 7.60822 10.6888 7.22378 10.303 6.9533C9.91726 6.68283 9.46371 6.53846 8.99974 6.53846C8.37758 6.53846 7.7809 6.7978 7.34097 7.25943C6.90104 7.72106 6.65388 8.34716 6.65388 9Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CopyIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4006_49564)">
        <path
          d="M8.26797 6.66797H21.068C21.9516 6.66797 22.668 7.38432 22.668 8.26797V21.068C22.668 21.9516 21.9516 22.668 21.068 22.668H8.26797C7.38429 22.668 6.66797 21.9516 6.66797 21.068V8.26797C6.66797 7.38432 7.38429 6.66797 8.26797 6.66797Z"
          stroke="black"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3359 1.33398H2.93594C2.51162 1.33398 2.10458 1.50256 1.80458 1.80261C1.50458 2.10267 1.33594 2.50963 1.33594 2.93398V17.334"
          stroke="black"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.668 10.668V18.668"
          stroke="black"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.668 14.668H18.668"
          stroke="black"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4006_49564">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
function CopyClipboardIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1M16 12.9C16 9.4 14.6 8 11.1 8M16 12.9V16H17.1C20.6 16 22 14.6 22 11.1V6.9C22 3.4 20.6 2 17.1 2H12.9C9.4 2 8 3.4 8 6.9V8H11.1"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function CopyIconSmall() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-copy-small b-icon-custom"
    >
      <path
        d="M6.2 5H15.8C16.4627 5 17 5.53726 17 6.2V15.8C17 16.4628 16.4627 17 15.8 17H6.2C5.53724 17 5 16.4628 5 15.8V6.2C5 5.53726 5.53724 5 6.2 5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 1H2.2C1.88176 1 1.57648 1.12643 1.35148 1.35147C1.12648 1.57652 1 1.88174 1 2.2V13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 8V14"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11H14"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Copy() {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-copy b-icon-custom"
    >
      <g>
        <path
          d="M11.2002 11H20.8002C21.463 11 22.0002 11.5373 22.0002 12.2V21.8C22.0002 22.4628 21.463 23 20.8002 23H11.2002C10.5375 23 10.0002 22.4628 10.0002 21.8V12.2C10.0002 11.5373 10.5375 11 11.2002 11Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.0002 7H7.20024C6.882 7 6.57672 7.12643 6.35172 7.35147C6.12672 7.57652 6.00024 7.88174 6.00024 8.2V19"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0002 14V20"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0002 17H19.0002"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        x="0.5"
        y="0.5"
        width="27"
        height="28"
        rx="4.5"
        stroke="#9747FF"
        strokeDasharray="10 5"
      />
    </svg>
  );
}

function Dashboard() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-dasboard b-icon-black"
    >
      <path
        d="M4.49976 8C6.43275 8 7.99976 6.43299 7.99976 4.5C7.99976 2.56701 6.43275 1 4.49976 1C2.56676 1 0.999756 2.56701 0.999756 4.5C0.999756 6.43299 2.56676 8 4.49976 8Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4998 8C15.4328 8 16.9998 6.43299 16.9998 4.5C16.9998 2.56701 15.4328 1 13.4998 1C11.5668 1 9.99976 2.56701 9.99976 4.5C9.99976 6.43299 11.5668 8 13.4998 8Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49976 17C6.43275 17 7.99976 15.433 7.99976 13.5C7.99976 11.567 6.43275 10 4.49976 10C2.56676 10 0.999756 11.567 0.999756 13.5C0.999756 15.433 2.56676 17 4.49976 17Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4998 17C15.4328 17 16.9998 15.433 16.9998 13.5C16.9998 11.567 15.4328 10 13.4998 10C11.5668 10 9.99976 11.567 9.99976 13.5C9.99976 15.433 11.5668 17 13.4998 17Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DashboardCircle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6 5C7.10457 5 8 4.10457 8 3C8 1.89543 7.10457 1 6 1C4.89543 1 4 1.89543 4 3C4 4.10457 4.89543 5 6 5Z"
        stroke="#6C7786"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5C13.1046 5 14 4.10457 14 3C14 1.89543 13.1046 1 12 1C10.8954 1 10 1.89543 10 3C10 4.10457 10.8954 5 12 5Z"
        stroke="#6C7786"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11C7.10457 11 8 10.1046 8 9C8 7.89543 7.10457 7 6 7C4.89543 7 4 7.89543 4 9C4 10.1046 4.89543 11 6 11Z"
        stroke="#6C7786"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 17C7.10457 17 8 16.1046 8 15C8 13.8954 7.10457 13 6 13C4.89543 13 4 13.8954 4 15C4 16.1046 4.89543 17 6 17Z"
        stroke="#6C7786"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
        stroke="#6C7786"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
        stroke="#6C7786"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DashedSeparator() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 355 1"
      fill="none"
      preserveAspectRatio="none"
      width="100%"
      height="1px"
      className="dashed-line"
    >
      <path
        d="M0.5 0.5L354.5 0.500031"
        stroke="currentColor"
        strokeLinecap="round"
        strokeDasharray="4 4"
      />
    </svg>
  );
}

function Delete() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-delete b-icon-black"
    >
      <path
        d="M2 5H16"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5H15V15.8C15 16.1182 14.8595 16.4235 14.6095 16.6485C14.3595 16.8735 14.0203 17 13.6667 17H4.33333C3.97971 17 3.64057 16.8735 3.39052 16.6485C3.14048 16.4235 3 16.1182 3 15.8V5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 5V4.33333C6 3.44928 6.31607 2.60143 6.87868 1.97631C7.44128 1.35119 8.20435 1 9 1C9.79565 1 10.5587 1.35119 11.1213 1.97631C11.6839 2.60143 12 3.44928 12 4.33333V5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8V13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 8V13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DeleteAccount() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99935 8.00065C9.8403 8.00065 11.3327 6.50827 11.3327 4.66732C11.3327 2.82637 9.8403 1.33398 7.99935 1.33398C6.1584 1.33398 4.66602 2.82637 4.66602 4.66732C4.66602 6.50827 6.1584 8.00065 7.99935 8.00065Z"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.27344 14.6667C2.27344 12.0867 4.84012 10 8.00012 10C8.64012 10 9.26013 10.0867 9.84013 10.2467"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6673 12.444C14.6673 12.6573 14.6407 12.864 14.5873 13.064C14.5273 13.3307 14.4206 13.5907 14.2806 13.8173C13.8206 14.5907 12.974 15.1107 12.0007 15.1107C11.314 15.1107 10.694 14.8507 10.2273 14.424C10.0273 14.2507 9.854 14.044 9.72066 13.8173C9.474 13.4173 9.33398 12.944 9.33398 12.444C9.33398 11.724 9.62065 11.064 10.0873 10.584C10.574 10.084 11.254 9.77734 12.0007 9.77734C12.7873 9.77734 13.5006 10.1174 13.9806 10.664C14.4073 11.1374 14.6673 11.764 14.6673 12.444Z"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9925 12.4316H11.0059"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DeleteButton() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-delete-button b-icon-main"
    >
      <path
        d="M9.00042 1L1 9.00042"
        stroke="#ff220d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1L9.00042 9.00042"
        stroke="#ff220d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DeleteSmall() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-delete-small b-icon-main"
    >
      <path
        d="M1.33398 3.3335H10.6673"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3.3335H10V10.5335C10 10.7457 9.90631 10.9492 9.73965 11.0992C9.57298 11.2492 9.34685 11.3335 9.11111 11.3335H2.88889C2.65314 11.3335 2.42705 11.2492 2.26035 11.0992C2.09365 10.9492 2 10.7457 2 10.5335V3.3335Z"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 3.33341V2.88897C4 2.2996 4.21071 1.73437 4.58578 1.31762C4.96086 0.900874 5.46957 0.666748 6 0.666748C6.53043 0.666748 7.03914 0.900874 7.41422 1.31762C7.78929 1.73437 8 2.2996 8 2.88897V3.33341"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66797 5.3335V8.66683"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33398 5.3335V8.66683"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DialogBenefitTip() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-benefit-tip-dialog"
    >
      <g clipPath="url(#clip0_12034_132681)">
        <path
          d="M18.0128 17.078C17.1855 18.0191 16.1785 18.793 15.0455 19.3512V22.5655C15.0455 22.8497 14.9327 23.1222 14.7317 23.323C14.5308 23.524 14.2583 23.637 13.9741 23.637H7.54552C7.26138 23.637 6.98885 23.524 6.78791 23.323C6.58698 23.1222 6.47409 22.8497 6.47409 22.5655V19.3512C4.9322 18.5861 3.62319 17.4223 2.68295 15.9805C1.74272 14.5388 1.20554 12.8716 1.12719 11.1521C1.04883 9.43264 1.43216 7.72354 2.23736 6.20222C3.04258 4.68092 4.24031 3.40285 5.70624 2.50075C7.17217 1.59864 8.85286 1.10536 10.5738 1.07211C12.0095 1.04437 13.4296 1.33768 14.7317 1.92621"
          stroke="url(#paint0_linear_12034_132681)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.47266 28.9258H15.0441"
          stroke="url(#paint1_linear_12034_132681)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8452 8.42878C15.0933 8.29796 15.0933 7.21843 15.8452 7.08761C18.5696 6.61365 20.7364 4.53859 21.3277 1.83729L21.3731 1.63022C21.5357 0.887011 22.594 0.882384 22.7631 1.62415L22.8182 1.86545C23.4315 4.554 25.5987 6.61155 28.3157 7.08418C29.0715 7.21568 29.0715 8.3007 28.3157 8.43218C25.5987 8.90483 23.4315 10.9624 22.8182 13.6509L22.7631 13.8922C22.594 14.634 21.5357 14.6294 21.3731 13.8862L21.3277 13.6791C20.7364 10.9778 18.5696 8.90273 15.8452 8.42878Z"
          stroke="url(#paint2_linear_12034_132681)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_12034_132681"
          x1="5.43496"
          y1="17.9953"
          x2="17.4688"
          y2="6.92085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12034_132681"
          x1="8.66313"
          y1="29.6758"
          x2="8.7638"
          y2="28.6151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_12034_132681"
          x1="18.7571"
          y1="11.1021"
          x2="25.74"
          y2="2.37426"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <clipPath id="clip0_12034_132681">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function DialogFunds() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-funds-dialog"
    >
      <path
        d="M25.7151 22.5V26.7857C25.7151 27.354 25.4893 27.8991 25.0875 28.3009C24.6857 28.7027 24.1406 28.9286 23.5723 28.9286H3.21512C2.64679 28.9286 2.10176 28.7027 1.69989 28.3009C1.29803 27.8991 1.07227 27.354 1.07227 26.7857V10.7143C1.07227 7.16388 3.95044 4.28571 7.50084 4.28571H21.4294V9.64285"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8566 16.0714H20.3566C19.7649 16.0714 19.2852 16.5511 19.2852 17.1428V21.4286C19.2852 22.0202 19.7649 22.5 20.3566 22.5H27.8566C28.4482 22.5 28.928 22.0202 28.928 21.4286V17.1428C28.928 16.5511 28.4482 16.0714 27.8566 16.0714Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7143 16.0714V11.7857C25.7143 11.2174 25.4884 10.6723 25.0866 10.2705C24.6849 9.86862 24.1397 9.64285 23.5714 9.64285H7.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DialogEdenredCards() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8459 2.40241C13.9921 1.874 14.553 1.56042 15.0986 1.70194L28.0734 5.06728C28.6193 5.20885 28.9432 5.75224 28.7969 6.28084L23.8183 24.2669C23.672 24.7953 23.1112 25.1088 22.5655 24.9673L9.59063 21.6019C9.0448 21.4604 8.72086 20.917 8.86717 20.3884L13.8459 2.40241Z"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1663 15L20.4996 16.6667"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M5.5 21.668L8.78798 20.7764"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M12.166 6.66797L2.85997 9.4535C2.36069 9.58767 2.06439 10.1021 2.19811 10.6026L6.74979 27.639C6.88356 28.1395 7.39699 28.4366 7.89645 28.3024L13.8327 26.7073"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DialogCreditCard() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.5795 5H3.42167C2.25896 5 1.31641 5.94257 1.31641 7.10526V22.8947C1.31641 24.0574 2.25896 25 3.42167 25H26.5795C27.7423 25 28.6848 24.0574 28.6848 22.8947V7.10526C28.6848 5.94257 27.7423 5 26.5795 5Z"
        stroke="black"
        strokeWidth="2.36"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.31641 12.3672H28.6848"
        stroke="black"
        strokeWidth="2.36"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2634 19.7383H23.4213"
        stroke="black"
        strokeWidth="2.36"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DownloadComputer() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-download-computer b-icon-black"
    >
      <path
        d="M9 1V8"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 6L9 8L11 6"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0769 3H16.3846C16.7244 3 17 3.27361 17 3.61111V13.3889C17 13.7263 16.7244 14 16.3846 14H1.61538C1.27552 14 1 13.7263 1 13.3889V3.61111C1 3.27361 1.27552 3 1.61538 3H5.92308"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14L7 17"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14L11 17"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 17H13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DownloadFile() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-download-file b-icon-black"
    >
      <path
        d="M16 15.7692C16 16.0956 15.8659 16.4087 15.6272 16.6395C15.3886 16.8703 15.0648 17 14.7273 17H3.27273C2.93517 17 2.61146 16.8703 2.37277 16.6395C2.13409 16.4087 2 16.0956 2 15.7692V2.23077C2 1.90434 2.13409 1.5913 2.37277 1.36048C2.61146 1.12967 2.93517 1 3.27273 1H11.5455L16 5.30769V15.7692Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10L9 13L6 10"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 13V6"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Drag() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-drag b-icon-black"
    >
      <path
        id="Vector"
        d="M6 5C7.10457 5 8 4.10457 8 3C8 1.89543 7.10457 1 6 1C4.89543 1 4 1.89543 4 3C4 4.10457 4.89543 5 6 5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M12 5C13.1046 5 14 4.10457 14 3C14 1.89543 13.1046 1 12 1C10.8954 1 10 1.89543 10 3C10 4.10457 10.8954 5 12 5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M6 11C7.10457 11 8 10.1046 8 9C8 7.89543 7.10457 7 6 7C4.89543 7 4 7.89543 4 9C4 10.1046 4.89543 11 6 11Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3_2"
        d="M6 17C7.10457 17 8 16.1046 8 15C8 13.8954 7.10457 13 6 13C4.89543 13 4 13.8954 4 15C4 16.1046 4.89543 17 6 17Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4_2"
        d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Edit() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-edit"
    >
      <path
        d="M4.36049 10.2996L0.666992 11.3334L1.70117 7.64137L8.46438 0.913604C8.5408 0.835458 8.63215 0.773367 8.73286 0.730976C8.83365 0.688585 8.94191 0.666748 9.05124 0.666748C9.16057 0.666748 9.26883 0.688585 9.36962 0.730976C9.47033 0.773367 9.56168 0.835458 9.63809 0.913604L11.0909 2.37402C11.1678 2.45029 11.2288 2.54104 11.2705 2.64101C11.3122 2.74099 11.3337 2.84824 11.3337 2.95655C11.3337 3.06485 11.3122 3.1721 11.2705 3.27208C11.2288 3.37206 11.1678 3.4628 11.0909 3.53907L4.36049 10.2996Z"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function EditBig() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-edit-big"
    >
      <path
        d="M6.90273 16.3077L1.05469 17.9446L2.69214 12.0988L13.4006 1.44652C13.5215 1.32279 13.6662 1.22448 13.8256 1.15736C13.9852 1.09024 14.1566 1.05566 14.3297 1.05566C14.5028 1.05566 14.6743 1.09024 14.8338 1.15736C14.9933 1.22448 15.1379 1.32279 15.2589 1.44652L17.5592 3.75884C17.6809 3.8796 17.7776 4.02329 17.8436 4.18158C17.9097 4.33989 17.9436 4.50969 17.9436 4.68118C17.9436 4.85267 17.9097 5.02247 17.8436 5.18077C17.7776 5.33907 17.6809 5.48275 17.5592 5.60351L6.90273 16.3077Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function EditInvoicing() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-edit-invoicing"
    >
      <path
        d="M9.64 3.63908C10.07 6.39908 12.31 8.50908 15.09 8.78908M0.75 20.5891H18.75M11.01 2.18908L2.8 10.8791C2.49 11.2091 2.19 11.8591 2.13 12.3091L1.76 15.5491C1.63 16.7191 2.47 17.5191 3.63 17.3191L6.85 16.7691C7.3 16.6891 7.93 16.3591 8.24 16.0191L16.45 7.32908C17.87 5.82908 18.51 4.11908 16.3 2.02908C14.1 -0.040916 12.43 0.689084 11.01 2.18908Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Employees() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-employees b-icon-black"
    >
      <path
        d="M6.73243 8.36916C8.49123 8.36916 9.91702 6.94338 9.91702 5.18458C9.91702 3.42579 8.49123 2 6.73243 2C4.97364 2 3.54785 3.42579 3.54785 5.18458C3.54785 6.94338 4.97364 8.36916 6.73243 8.36916Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 17.2857H12.4645V16.5951C12.4544 15.6242 12.1983 14.6717 11.7202 13.8266C11.2422 12.9814 10.5577 12.2712 9.73076 11.7624C8.90381 11.2535 7.96138 10.9625 6.9915 10.9166C6.90503 10.9125 6.81859 10.9103 6.73225 10.9102C6.64591 10.9103 6.55947 10.9125 6.473 10.9166C5.50311 10.9625 4.56068 11.2535 3.73373 11.7624C2.9068 12.2712 2.22233 12.9814 1.74426 13.8266C1.2662 14.6717 1.01014 15.6242 1 16.5951V17.2857Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.28 8.36916C13.0388 8.36916 14.4646 6.94338 14.4646 5.18458C14.4646 3.42579 13.0388 2 11.28 2"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4649 17.2864H17.0126V16.5958C17.0024 15.6249 16.7464 14.6723 16.2683 13.8272C15.7902 12.982 15.1058 12.2719 14.2788 11.763C13.7443 11.4341 13.1614 11.1962 12.5542 11.0566"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Favorite() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-favorite b-icon-black"
    >
      <defs>
        <linearGradient
          id="favorite-heart-gradient"
          x1="0.75"
          y1="9.82445"
          x2="20.75"
          y2="9.82445"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72717" />
          <stop offset="1" stopColor="#FF007D" />
        </linearGradient>
      </defs>
      <path
        d="M11.37 18.46C11.03 18.58 10.47 18.58 10.13 18.46C7.23 17.47 0.75 13.34 0.75 6.34C0.75 3.25 3.24 0.75 6.31 0.75C8.13 0.75 9.74 1.63 10.75 2.99C11.76 1.63 13.38 0.75 15.19 0.75C18.26 0.75 20.75 3.25 20.75 6.34C20.75 13.34 14.27 17.47 11.37 18.46Z"
        className="favorite-path"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Gift() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-gift b-icon-black"
    >
      <g>
        <path
          d="M15.7692 4H2.23077C1.55103 4 1 4.55965 1 5.25V7.75C1 8.44035 1.55103 9 2.23077 9H15.7692C16.449 9 17 8.44035 17 7.75V5.25C17 4.55965 16.449 4 15.7692 4Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 9V15.7692C16 16.0956 15.8659 16.4087 15.6272 16.6395C15.3886 16.8703 15.0648 17 14.7273 17H3.27273C2.93517 17 2.61146 16.8703 2.37277 16.6395C2.13409 16.4087 2 16.0956 2 15.7692V9"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 4V17"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 1L9 4L6 1"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

function Heart() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-heart b-icon-black"
    >
      <path
        d="M9.00525 16L2.21535 9.55149C-1.47483 5.68235 3.94972 -1.74639 9.00525 4.26366C14.0607 -1.74639 19.4608 5.70815 15.7952 9.55149L9.00525 16Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function HeartButton() {
  return (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-heart-button b-icon-main"
    >
      <path
        d="M10.3386 16.1904L2.51862 9.10608C-1.73137 4.85608 4.51577 -3.30535 10.3386 3.29751C16.1615 -3.30535 22.3815 4.88323 18.1601 9.10608L10.3386 16.1904Z"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Help() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-help b-icon-black"
    >
      <path
        d="M10.75 11.75V11.5167C10.75 10.7612 11.2561 10.3611 11.7621 10.0389C12.2561 9.7278 12.75 9.32782 12.75 8.59448C12.75 7.57226 11.8585 6.75 10.75 6.75C9.64155 6.75 8.75 7.57226 8.75 8.59448M10.7455 15.25H10.7545M10.75 20.75C16.25 20.75 20.75 16.25 20.75 10.75C20.75 5.25 16.25 0.75 10.75 0.75C5.25 0.75 0.75 5.25 0.75 10.75C0.75 16.25 5.25 20.75 10.75 20.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Home() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-home b-icon-black"
    >
      <path
        d="M10.75 16.7226V13.7226M7.77 1.57258L2.38 5.77258C1.48 6.47258 0.75 7.96258 0.75 9.09258V16.5026C0.75 18.8226 2.64 20.7226 4.96 20.7226H16.54C18.86 20.7226 20.75 18.8226 20.75 16.5126V9.23258C20.75 8.02258 19.94 6.47258 18.95 5.78258L12.77 1.45258C11.37 0.472584 9.12 0.522584 7.77 1.57258Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Info() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-info b-icon-main"
    >
      <svg x="4.5" y="4.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="#ff220d"
          strokeWidth="1.0714"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function InfoBlue() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-info-blue"
    >
      <svg x="2.5" y="2.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="#0060DF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function InfoDashboard() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-info-dashboard"
    >
      <rect width="36" height="36" rx="7" fill="#F6F8FA" />
      <svg x="10.5" y="10.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="#64748B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function InfoSummary() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <svg x="0.5" y="0.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="#64748B"
          strokeWidth="1.594"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function InfoSmall() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-infos b-icon-main"
    >
      <svg x="0.5" y="0.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="black"
          strokeWidth="1.594"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function InfoMedium() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-infom b-icon-main"
    >
      <svg x="2.5" y="2.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="black"
          strokeWidth="1.275"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function Invisible() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-invisible b-icon-black"
    >
      <path
        d="M4.66602 4.66001C5.9424 3.8306 7.42138 3.21436 8.99994 3.21436C12.5871 3.21436 15.66 6.39654 17.01 8.03103C17.2232 8.29681 17.3412 8.64211 17.3412 9.00015C17.3412 9.35818 17.2232 9.70348 17.01 9.96927C16.2658 10.8702 14.9981 12.2415 13.4095 13.2908M10.9285 14.4897C10.3083 14.6773 9.66291 14.7859 8.99994 14.7859C5.4128 14.7859 2.33994 11.6038 0.989942 9.96927C0.776719 9.70348 0.658691 9.35818 0.658691 9.00015C0.658691 8.64211 0.776719 8.29681 0.989942 8.03103C1.41766 7.51317 2.01832 6.83995 2.75349 6.16182"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8187 10.8184C11.8229 9.8142 11.8229 8.18606 10.8187 7.18186C9.81446 6.17766 8.18634 6.17766 7.18213 7.18186"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3574 17.3571L0.643066 0.642822"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Invoice() {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-invoice"
    >
      <path
        d="M17.748 20.167H17.7555M20.0833 20.167H24.6667M17.748 16.8337H17.7555M20.0833 16.8337H24.6667M16.6096 27.417C17.293 26.6837 18.3346 26.742 18.9346 27.542L19.7763 28.667C20.4513 29.5587 21.543 29.5587 22.218 28.667L23.0596 27.542C23.6596 26.742 24.7013 26.6837 25.3846 27.417C26.868 29.0003 28.0763 28.4753 28.0763 26.2587V16.867C28.0846 13.5087 27.3013 12.667 24.1513 12.667H17.8513C14.7013 12.667 13.918 13.5087 13.918 16.867V26.2503C13.918 28.4753 15.1346 28.992 16.6096 27.417Z"
        stroke="#FF220D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Language() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-language b-icon-black"
    >
      <path
        d="M2.75 16.75L3.75 13.5H4.83C5.05808 13.5008 5.28325 13.4488 5.48795 13.3482C5.69264 13.2476 5.8713 13.1011 6.01 12.92C6.15286 12.7431 6.25181 12.5349 6.29874 12.3124C6.34567 12.09 6.33925 11.8595 6.28 11.64L5.53 8.64C5.45141 8.31477 5.26563 8.02546 5.0026 7.81867C4.73957 7.61187 4.41459 7.49962 4.08 7.5H1.75M18.75 4.75H14.8969C14.5773 4.74962 14.2668 4.86187 14.0155 5.06867C13.7642 5.27546 13.5868 5.56477 13.5117 5.89L12.7952 8.89C12.7399 9.1103 12.7353 9.34118 12.7818 9.56369C12.8283 9.7862 12.9245 9.994 13.0627 10.17C13.1952 10.3511 13.3659 10.4976 13.5614 10.5982C13.7569 10.6988 13.9721 10.7508 14.19 10.75H15.6994L16.4445 15.5C16.5004 15.8463 16.6707 16.1611 16.9256 16.3896C17.1804 16.618 17.5038 16.7455 17.8393 16.75H18.75M20.75 10.75C20.75 16.2728 16.2728 20.75 10.75 20.75C5.22715 20.75 0.75 16.2728 0.75 10.75C0.75 5.22715 5.22715 0.75 10.75 0.75C16.2728 0.75 20.75 5.22715 20.75 10.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Logout() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-logout b-icon-black"
    >
      <path
        d="M12.2143 13.4997V16.0712C12.2143 16.4121 12.0788 16.7392 11.8377 16.9803C11.5966 17.2214 11.2695 17.3569 10.9285 17.3569H1.92854C1.58754 17.3569 1.26052 17.2214 1.0194 16.9803C0.778281 16.7392 0.642822 16.4121 0.642822 16.0712V1.92829C0.642822 1.5873 0.778281 1.26027 1.0194 1.01915C1.26052 0.778037 1.58754 0.642578 1.92854 0.642578H10.9285C11.2695 0.642578 11.5966 0.778037 11.8377 1.01915C12.0788 1.26027 12.2143 1.5873 12.2143 1.92829V4.49972"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.35718 9H17.3572"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7856 6.42871L17.3571 9.00014L14.7856 11.5716"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Loading() {
  const clipPathId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 75.18 75.18"
    >
      <defs>
        <style>
          {`.cls-1 { fill: none; } .cls-2 { clip-path: url(#${clipPathId}); } .cls-3 { fill: #0f172a; }`}
        </style>
        <clipPath id={clipPathId} transform="translate(1 1)">
          <path
            className="cls-1"
            d="M36.59,73.19A36.59,36.59,0,0,1,2.77,22.64,36.73,36.73,0,0,1,22.45,2.85,36.52,36.52,0,0,1,36.38,0h.39A36.59,36.59,0,0,1,70.39,50.6,36.62,36.62,0,0,1,50.6,70.39a36.83,36.83,0,0,1-14,2.8ZM36.4,6.71A29.65,29.65,0,0,0,25.05,9,30,30,0,0,0,9,25.2,29.87,29.87,0,0,0,9,48,30.06,30.06,0,0,0,25.16,64.2,29.79,29.79,0,0,0,48,64.2,30.06,30.06,0,0,0,64.2,48a29.81,29.81,0,0,0,0-22.82,30.35,30.35,0,0,0-6.45-9.67,29.78,29.78,0,0,0-21-8.82H36.4Z"
          />
        </clipPath>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g className="cls-2">
            <image
              width="76"
              height="76"
              transform="translate(-0.26 -0.19)"
              xlinkHref="data:image/png;base64,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"
            />
            <path
              className="cls-3"
              d="M36.66,6.71A3.36,3.36,0,1,1,40,3.35,3.36,3.36,0,0,1,36.66,6.71Z"
              transform="translate(1 1)"
            />
            <path
              className="cls-3"
              d="M36.66,5.71A2.36,2.36,0,1,1,39,3.35,2.36,2.36,0,0,1,36.66,5.71Z"
              transform="translate(1 1)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function MarkAll() {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-markall b-icon-black"
    >
      <path
        d="M11.4436 12.2645C11.4436 12.5184 11.3392 12.7619 11.1536 12.9414C10.9679 13.1209 10.7162 13.2218 10.4537 13.2218H1.54458C1.28204 13.2218 1.03026 13.1209 0.844618 12.9414C0.65898 12.7619 0.554688 12.5184 0.554688 12.2645V1.73461C0.554688 1.48072 0.65898 1.23724 0.844618 1.05772C1.03026 0.878198 1.28204 0.777344 1.54458 0.777344H7.07393C7.33646 0.777344 7.58825 0.878198 7.77388 1.05772L11.1536 4.32603C11.3392 4.50555 11.4436 4.74904 11.4436 5.00291V12.2645Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.77734 6.22266H9.11068"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.77734 9.33203H9.11068"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.88867 9.44358L3.76367 10.1102L5.22201 8.55469"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.88867 6.33225L3.76367 6.99891L5.22201 5.44336"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Menu() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
      <path
        d="M1 1H19M1 7H13M1 13H17"
        stroke="#0F172A"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MessageQuestion() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 23.0377H16.75L11.1875 26.7376C10.3625 27.2876 9.25 26.7002 9.25 25.7002V23.0377C5.5 23.0377 3 20.5377 3 16.7877V9.2876C3 5.5376 5.5 3.0376 9.25 3.0376H21.75C25.5 3.0376 28 5.5376 28 9.2876V16.7877C28 20.5377 25.5 23.0377 21.75 23.0377Z"
        stroke="black"
        strokeWidth="1.875"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 14.1997V13.9373C15.5 13.0873 16.025 12.6372 16.55 12.2747C17.0625 11.9247 17.575 11.4747 17.575 10.6497C17.575 9.49975 16.65 8.57471 15.5 8.57471C14.35 8.57471 13.425 9.49975 13.425 10.6497"
        stroke="black"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4944 17.1875H15.5056"
        stroke="black"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Notification() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-notification b-icon-black"
    >
      <path
        d="M14.7202 9.65868V11.8718C14.7202 12.4362 14.9462 12.9776 15.3485 13.3767C15.7507 13.7757 16.4311 14 17 14H1C1.56891 14 2.24928 13.7757 2.65156 13.3767C3.05383 12.9776 3.27984 12.4362 3.27984 11.8718L3.27983 6.67522C3.27983 5.17006 3.88249 3.72655 4.95523 2.66224C6.02797 1.59793 7.48292 1 9 1"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.2798 9.65868V11.8718C3.2798 12.4362 3.05382 12.9776 2.65149 13.3767C2.24931 13.7757 1.56887 14 1 14H17C16.4311 14 15.7507 13.7757 15.3484 13.3767C14.9462 12.9776 14.7202 12.4362 14.7202 11.8718L14.7202 6.67522C14.7202 5.17006 14.1175 3.72655 13.0448 2.66224C11.972 1.59793 10.5171 1 9 1"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 17H10"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function NotificationsArrow({ color = '#0060DF' }: Readonly<IconProps>) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-notification-arrow b-icon-black"
    >
      <g clipPath="url(#clip0_12553_1080)">
        <path
          d="M1 6L11 6"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 11.001L11 6.00098L6 1.00098"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12553_1080">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(12) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function NotificationsClose() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-notification-close b-icon-black"
    >
      <path
        d="M1.69678 1.71385L10.2855 10.2861"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M10.2856 1.71385L1.69691 10.2861"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  );
}

function TutorialsClose() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1666 10.5L15.4435 16.9304C14.6495 17.6899 13.3503 17.6899 12.5563 16.9304L5.83325 10.5"
        stroke="white"
        strokeWidth="2.33333"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TutorialsVideoClock() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4733 10.1187L8.40658 8.88536C8.04658 8.67203 7.75325 8.1587 7.75325 7.7387V5.00536M14.6666 7.9987C14.6666 11.6787 11.6799 14.6654 7.99992 14.6654C4.31992 14.6654 1.33325 11.6787 1.33325 7.9987C1.33325 4.3187 4.31992 1.33203 7.99992 1.33203C11.6799 1.33203 14.6666 4.3187 14.6666 7.9987Z"
        stroke="#64748B"
        strokeWidth="1.04039"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TutorialslHelp() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0H28C36.8366 0 44 7.16344 44 16V28C44 36.8366 36.8366 44 28 44H16C7.16344 44 0 36.8366 0 28V16Z"
        fill="#E5F0FE"
      />
      <path
        d="M14.8997 14.93L18.4397 18.46M14.8997 29.07L18.4397 25.54M29.0497 29.07L25.5097 25.54M29.0497 14.93L25.5097 18.46M31.9697 22C31.9697 27.5228 27.4926 32 21.9697 32C16.4469 32 11.9697 27.5228 11.9697 22C11.9697 16.4772 16.4469 12 21.9697 12C27.4926 12 31.9697 16.4772 31.9697 22ZM26.4997 22C26.4997 24.4853 24.485 26.5 21.9997 26.5C19.5144 26.5 17.4997 24.4853 17.4997 22C17.4997 19.5147 19.5144 17.5 21.9997 17.5C24.485 17.5 26.4997 19.5147 26.4997 22Z"
        stroke="black"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TutorialsVideoPlay() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="50"
        height="50"
        rx="16"
        fill="url(#paint0_linear_26752_10971)"
        fillOpacity="0.7"
      />
      <path
        d="M15.9102 25V20.8466C15.9102 15.69 19.4651 13.5783 23.8151 16.1566L27.3246 18.2333L30.8341 20.31C35.184 22.8883 35.184 27.1116 30.8341 29.69L27.3246 31.7666L23.8151 33.8433C19.4651 36.4216 15.9102 34.31 15.9102 29.1533V25Z"
        stroke="white"
        strokeWidth="1.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_26752_10971"
          x1="12.7778"
          y1="37.5"
          x2="38.9731"
          y2="5.30157"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function NotificationsError() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 29 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-notification-error"
    >
      <path
        d="M14.1879 9.45031V16.0444M14.1807 20.0008H14.1925M14.1879 25.8168H6.19589C1.6196 25.8168 -0.292683 22.5461 1.92293 18.5501L6.03763 11.1384L9.91495 4.17505C12.2624 -0.0583495 16.1134 -0.0583495 18.4609 4.17505L26.4529 18.5633C28.6685 22.5593 26.743 25.83 22.1799 25.83H14.1879V25.8168Z"
        stroke="#BF410F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function NotificationsInfo() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-notification-info"
    >
      <svg x="2.5" y="2.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="#0060DF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function NotificationsRead() {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22.5" cy="22.5" r="22.5" fill="#F5F5F5"></circle>
      <path
        d="M22.5175 14.5463C19.6213 14.5463 17.2675 16.9 17.2675 19.7963V22.325C17.2675 22.8588 17.04 23.6725 16.7688 24.1275L15.7625 25.7988C15.1413 26.8313 15.57 27.9775 16.7075 28.3625C20.4788 29.6225 24.5475 29.6225 28.3188 28.3625C29.3775 28.0125 29.8413 26.7613 29.2638 25.7988L28.2575 24.1275C27.995 23.6725 27.7675 22.8588 27.7675 22.325V19.7963C27.7675 16.9088 25.405 14.5463 22.5175 14.5463Z"
        stroke="url(#paint0_linear_5135_32282)"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      ></path>
      <path
        d="M24.1362 14.8C23.865 14.7213 23.585 14.66 23.2962 14.625C22.4562 14.52 21.6512 14.5813 20.8987 14.8C21.1525 14.1525 21.7825 13.6975 22.5175 13.6975C23.2525 13.6975 23.8825 14.1525 24.1362 14.8Z"
        stroke="url(#paint1_linear_5135_32282)"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M25.1425 28.6775C25.1425 30.1212 23.9612 31.3025 22.5175 31.3025C21.8 31.3025 21.135 31.005 20.6625 30.5325C20.19 30.06 19.8925 29.395 19.8925 28.6775"
        stroke="url(#paint2_linear_5135_32282)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_5135_32282"
          x1="19.0646"
          y1="25.6172"
          x2="26.8681"
          y2="16.4959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72"></stop>
          <stop offset="1" stopColor="#F5261C"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_5135_32282"
          x1="21.7261"
          y1="14.5244"
          x2="22.0297"
          y2="13.4286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72"></stop>
          <stop offset="1" stopColor="#F5261C"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_5135_32282"
          x1="21.2342"
          y1="30.6462"
          x2="22.2147"
          y2="28.2358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72"></stop>
          <stop offset="1" stopColor="#F5261C"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

function NotificationsNonRead() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22.5" cy="25.5" r="22.5" fill="#F5F5F5"></circle>
      <path
        d="M22.5175 17.5463C19.6213 17.5463 17.2675 19.9 17.2675 22.7963V25.325C17.2675 25.8588 17.04 26.6725 16.7688 27.1275L15.7625 28.7988C15.1413 29.8313 15.57 30.9775 16.7075 31.3625C20.4788 32.6225 24.5475 32.6225 28.3188 31.3625C29.3775 31.0125 29.8413 29.7613 29.2638 28.7988L28.2575 27.1275C27.995 26.6725 27.7675 25.8588 27.7675 25.325V22.7963C27.7675 19.9088 25.405 17.5463 22.5175 17.5463Z"
        stroke="url(#paint0_linear_5135_32107)"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
      ></path>
      <path
        d="M24.1362 17.8C23.865 17.7213 23.585 17.66 23.2962 17.625C22.4562 17.52 21.6512 17.5813 20.8987 17.8C21.1525 17.1525 21.7825 16.6975 22.5175 16.6975C23.2525 16.6975 23.8825 17.1525 24.1362 17.8Z"
        stroke="url(#paint1_linear_5135_32107)"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M25.1425 31.6775C25.1425 33.1212 23.9612 34.3025 22.5175 34.3025C21.8 34.3025 21.135 34.005 20.6625 33.5325C20.19 33.06 19.8925 32.395 19.8925 31.6775"
        stroke="url(#paint2_linear_5135_32107)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      ></path>
      <circle
        cx="40"
        cy="8"
        r="6.25"
        fill="url(#paint3_linear_5135_32107)"
        stroke="white"
        strokeWidth="2.5"
      ></circle>
      <defs>
        <linearGradient
          id="paint0_linear_5135_32107"
          x1="19.0646"
          y1="28.6172"
          x2="26.8681"
          y2="19.4959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72"></stop>
          <stop offset="1" stopColor="#F5261C"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_5135_32107"
          x1="21.7261"
          y1="17.5244"
          x2="22.0297"
          y2="16.4286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72"></stop>
          <stop offset="1" stopColor="#F5261C"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_5135_32107"
          x1="21.2342"
          y1="33.6462"
          x2="22.2147"
          y2="31.2358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72"></stop>
          <stop offset="1" stopColor="#F5261C"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_5135_32107"
          x1="37.5556"
          y1="10.5"
          x2="42.7946"
          y2="4.06031"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72"></stop>
          <stop offset="1" stopColor="#F5261C"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

function NotificationsTip() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-notification-tip"
    >
      <path
        d="M11.6572 11.0972C11.1354 11.6908 10.5002 12.1789 9.78556 12.531V14.5585C9.78556 14.7377 9.71437 14.9097 9.58763 15.0363C9.46088 15.1631 9.28898 15.2343 9.10974 15.2343H5.05479C4.87557 15.2343 4.70366 15.1631 4.57692 15.0363C4.45018 14.9097 4.37897 14.7377 4.37897 14.5585V12.531C3.40639 12.0484 2.58071 11.3143 1.98763 10.4049C1.39457 9.49549 1.05573 8.44389 1.00631 7.3593C0.956883 6.2747 1.19867 5.19665 1.70657 4.23705C2.21448 3.27746 2.96997 2.4713 3.89463 1.90228C4.8193 1.33325 5.87942 1.0221 6.96494 1.00114C7.87056 0.983639 8.76631 1.16864 9.58763 1.53988"
        stroke="url(#paint0_linear_11471_59282)"
        strokeWidth="1.89231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.37891 18.5714H9.7855"
        stroke="url(#paint1_linear_11471_59282)"
        strokeWidth="1.89231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2903 5.64149C9.81599 5.55898 9.81599 4.87804 10.2903 4.79552C12.0087 4.49657 13.3755 3.18768 13.7485 1.48378L13.7771 1.35318C13.8797 0.884379 14.5472 0.881461 14.6539 1.34934L14.6886 1.50155C15.0755 3.1974 16.4425 4.49524 18.1563 4.79336C18.633 4.87631 18.633 5.56071 18.1563 5.64364C16.4425 5.94178 15.0755 7.23961 14.6886 8.93546L14.6539 9.08767C14.5472 9.55556 13.8797 9.55264 13.7771 9.08384L13.7485 8.95323C13.3755 7.24935 12.0087 5.94045 10.2903 5.64149Z"
        stroke="url(#paint2_linear_11471_59282)"
        strokeWidth="1.89231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11471_59282"
          x1="3.72352"
          y1="11.6758"
          x2="11.3141"
          y2="4.69034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11471_59282"
          x1="5.76059"
          y1="19.3214"
          x2="5.91806"
          y2="18.2749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11471_59282"
          x1="12.127"
          y1="7.32776"
          x2="16.5317"
          y2="1.82249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function NotificationsSuccess() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-notification-success"
    >
      <path
        d="M24 12.75C24 6.56421 18.9358 1.5 12.75 1.5C6.56421 1.5 1.5 6.56421 1.5 12.75C1.5 18.9358 6.56421 24 12.75 24C18.9358 24 24 18.9358 24 12.75ZM17.3203 8.82324C17.6135 8.53067 18.0882 8.53109 18.3809 8.82422C18.6734 9.11737 18.673 9.59215 18.3799 9.88477L11.5762 16.6768C11.2833 16.9691 10.8084 16.9693 10.5156 16.6768L7.12012 13.2803C6.82722 12.9874 6.82722 12.5126 7.12012 12.2197C7.41303 11.927 7.88784 11.9269 8.18066 12.2197L11.0459 15.085L17.3203 8.82324ZM25.5 12.75C25.5 19.7642 19.7642 25.5 12.75 25.5C5.73579 25.5 0 19.7642 0 12.75C0 5.73579 5.73579 0 12.75 0C19.7642 0 25.5 5.73579 25.5 12.75Z"
        fill="#007840"
      />
    </svg>
  );
}

function NotificationsWarning() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 29 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-notification-warning"
    >
      <path
        d="M14.1879 9.45031V16.0444M14.1807 20.0008H14.1925M14.1879 25.8168H6.19589C1.6196 25.8168 -0.292683 22.5461 1.92293 18.5501L6.03763 11.1384L9.91495 4.17505C12.2624 -0.0583495 16.1134 -0.0583495 18.4609 4.17505L26.4529 18.5633C28.6685 22.5593 26.743 25.83 22.1799 25.83H14.1879V25.8168Z"
        stroke="#BF410F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function OperationalServices() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-operational-services"
    >
      <path
        d="M6 9H12M6.75 13H11.25M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6ZM2 21C2 21.83 2.93998 22.3 3.59998 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.28998 22.29C8.67998 22.68 9.32002 22.68 9.71002 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H6C3 2 2 3.79 2 6V21Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Padlock() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-padlock b-icon-black"
    >
      <path
        d="M14.143 7.07129H3.85725C3.14717 7.07129 2.57153 7.64693 2.57153 8.357V16.0713C2.57153 16.7814 3.14717 17.357 3.85725 17.357H14.143C14.8531 17.357 15.4287 16.7814 15.4287 16.0713V8.357C15.4287 7.64693 14.8531 7.07129 14.143 7.07129Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0002 7V5.2C13.0002 4.08609 12.5789 3.0178 11.8287 2.23016C11.0785 1.4425 10.0611 1 9.00024 1C7.93938 1 6.92196 1.4425 6.17182 2.23016C5.42167 3.0178 5.00024 4.08609 5.00024 5.2V7"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00024 13C9.55252 13 10.0002 12.5523 10.0002 12C10.0002 11.4477 9.55252 11 9.00024 11C8.44796 11 8.00024 11.4477 8.00024 12C8.00024 12.5523 8.44796 13 9.00024 13Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PadlockOpen() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-padlock-open"
    >
      <path
        d="M12.5715 6.28546H3.42862C2.79745 6.28546 2.28577 6.79714 2.28577 7.42832V14.2855C2.28577 14.9167 2.79745 15.4283 3.42862 15.4283H12.5715C13.2027 15.4283 13.7143 14.9167 13.7143 14.2855V7.42832C13.7143 6.79714 13.2027 6.28546 12.5715 6.28546Z"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5143 1.9822C9.8475 1.28207 8.94313 0.888733 8.00014 0.888733C7.05714 0.888733 6.15277 1.28207 5.48598 1.9822C4.81918 2.68233 4.44458 3.63192 4.44458 4.62207V6.22207"
        stroke="#FF220D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00022 11.5554C8.49113 11.5554 8.88911 11.1575 8.88911 10.6665C8.88911 10.1756 8.49113 9.77765 8.00022 9.77765C7.5093 9.77765 7.11133 10.1756 7.11133 10.6665C7.11133 11.1575 7.5093 11.5554 8.00022 11.5554Z"
        fill="#FF220D"
        stroke="#FF220D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PasswordShow() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-password-show b-icon-black"
    >
      <path
        d="M16.682 8.07209C16.8864 8.32701 16.9996 8.65821 16.9996 9.00162C16.9996 9.34503 16.8864 9.67623 16.682 9.93116C15.3871 11.4989 12.4397 14.5511 8.99909 14.5511C5.55847 14.5511 2.61112 11.4989 1.31626 9.93116C1.11174 9.67623 0.998535 9.34503 0.998535 9.00162C0.998535 8.65821 1.11174 8.32701 1.31626 8.07209C2.61112 6.50436 5.55847 3.45215 8.99909 3.45215C12.4397 3.45215 15.3871 6.50436 16.682 8.07209Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99911 11.4689C10.3613 11.4689 11.4655 10.3647 11.4655 9.00253C11.4655 7.64038 10.3613 6.53613 8.99911 6.53613C7.63696 6.53613 6.53271 7.64038 6.53271 9.00253C6.53271 10.3647 7.63696 11.4689 8.99911 11.4689Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PasswordHide() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-password-hide b-icon-black"
    >
      <path
        d="M4.66602 4.65952C5.9424 3.83011 7.42138 3.21387 8.99994 3.21387C12.5871 3.21387 15.66 6.39605 17.01 8.03054C17.2232 8.29632 17.3412 8.64163 17.3412 8.99966C17.3412 9.35769 17.2232 9.703 17.01 9.96878C16.2658 10.8697 14.9981 12.241 13.4095 13.2903M10.9285 14.4892C10.3083 14.6768 9.66291 14.7854 8.99994 14.7854C5.4128 14.7854 2.33994 11.6033 0.989942 9.96878C0.776719 9.703 0.658691 9.35769 0.658691 8.99966C0.658691 8.64163 0.776719 8.29632 0.989942 8.03054C1.41766 7.51268 2.01832 6.83947 2.75349 6.16133"
        stroke="black"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8187 10.8184C11.8229 9.8142 11.8229 8.18606 10.8187 7.18186C9.81446 6.17766 8.18634 6.17766 7.18213 7.18186"
        stroke="black"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3574 17.3569L0.643066 0.642578"
        stroke="black"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PaymentOptions() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="white" />
      <svg x="8" y="8" width="16" height="16" viewBox="0 0 15 15">
        <path
          d="M0.5 0.5H1.68683C3.5 0.5 3.00325 3.12 2.94187 3.83333L2.37573 8.47333C2.28024 9.55999 3.16013 10.4933 4.27875 10.4933H11.543C12.5252 10.4933 13.3846 9.70667 13.4596 8.75334L13.8279 5.75334C13.9098 4.64667 13.0504 3.74666 11.9113 3.74666H3.10557M11.5 3.5L9.6667 2.00311C9.52514 1.89435 9.33394 1.83333 9.13471 1.83333C8.93547 1.83333 8.74428 1.89435 8.60272 2.00311L6.83333 3.5M8.21044 2.33498L6.41064 1.94092C6.31636 1.91909 6.21744 1.91199 6.11959 1.92002C6.02175 1.92805 5.92693 1.95105 5.84063 1.9877C5.75432 2.02435 5.67824 2.07391 5.6168 2.13352C5.55535 2.19313 5.50976 2.26161 5.48266 2.33498L4.83333 3.5M11.0723 13C11.0723 13.4602 10.6906 13.8333 10.2197 13.8333C9.74883 13.8333 9.36711 13.4602 9.36711 13C9.36711 12.5398 9.74883 12.1667 10.2197 12.1667C10.6906 12.1667 11.0723 12.5398 11.0723 13ZM5.61564 13C5.61564 13.4602 5.23391 13.8333 4.76303 13.8333C4.29215 13.8333 3.91043 13.4602 3.91043 13C3.91043 12.5398 4.29215 12.1667 4.76303 12.1667C5.23391 12.1667 5.61564 12.5398 5.61564 13Z"
          stroke="#0F172A"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function PartyEmoji() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.63088 10.6279C9.74281 10.6481 9.83919 10.7421 9.9669 10.7891C10.361 10.934 10.8841 10.9984 11.3054 10.975C11.3312 11.1048 11.3879 11.2738 11.4267 11.4054C12.149 11.49 13.5032 12.2366 14.0028 12.7597C13.8558 12.8472 13.7495 12.9152 13.6187 13.0267C13.5728 13.0658 13.4549 13.1809 13.4187 13.205C13.2772 13.3775 13.1054 13.5786 12.9829 13.7609C12.4591 14.5401 12.1716 15.4306 11.971 16.3394C12.3672 16.3522 12.7636 16.3613 13.16 16.3666C13.4388 15.6403 13.8895 14.8594 14.5532 14.4261C14.6926 14.3263 15.146 14.1652 15.3211 14.1586C16.0186 15.037 16.1846 15.7396 16.3903 16.7929C16.7778 16.9126 16.8959 16.9846 17.2277 17.1926C17.8858 17.6052 18.8962 18.7318 19.7454 18.316C20.0213 18.181 20.1809 17.7681 20.2547 17.4926C20.3421 17.1676 20.3975 16.7981 20.456 16.4617C20.5827 15.7348 20.7958 14.8959 21.3164 14.3459C21.542 14.1074 21.8708 13.8992 22.1565 13.7392C22.6283 13.4811 23.1417 13.3085 23.6736 13.2294C23.852 13.2019 24.0425 13.1926 24.2067 13.1673C24.2854 13.8017 24.3239 14.4482 24.3983 15.0839C24.4113 15.1944 24.4229 15.3103 24.4262 15.4213C23.894 15.3832 23.3319 15.4316 22.9118 15.8001C21.8769 16.7079 22.8666 19.251 20.8453 20.0833C20.4599 20.2419 20.067 20.3449 19.6463 20.321C18.708 20.2676 17.9482 19.799 17.2357 19.2235C16.9171 18.9661 16.6156 18.7031 16.2443 18.5223C16.061 19.3646 15.5271 20.3644 14.776 20.8149C14.1853 21.1695 13.5133 21.4314 12.8771 21.6982C12.5614 21.8311 12.2364 21.9822 11.9204 22.1106C11.5571 22.2688 11.0643 22.4883 10.696 22.6148C10.0142 22.9017 9.28093 23.1944 8.61244 23.5C8.29935 23.6526 7.84727 23.8286 7.51844 23.9519C7.02992 24.1682 6.54167 24.3533 6.06171 24.5908C5.75359 24.7412 5.50475 24.8534 5.18397 24.9733L5.17579 24.9625C5.10653 24.8711 4.7245 24.7501 4.58522 24.649C4.26723 24.4178 4.10751 24.2175 3.86568 23.9184L3.85923 23.9177C3.8604 23.922 3.44118 23.2349 3.42931 23.22L3.4389 23.1835C3.3239 23.0126 3.26868 22.7605 3.22996 22.5636C3.22393 22.533 3.19324 22.5279 3.16357 22.5127C3.26166 22.205 3.39685 21.8589 3.50857 21.5506C3.73372 20.9862 3.94582 20.3335 4.15516 19.7549C4.28151 19.3799 4.43612 18.9791 4.57335 18.6059L5.47335 16.221C5.64618 15.7514 5.85639 15.2579 6.04577 14.7921C7.02476 12.6696 7.3061 11.726 9.78557 11.2909C9.72558 11.1083 9.67199 10.8228 9.63088 10.6279Z"
        fill="#334155"
      />
      <path
        d="M16.3909 16.7916C16.7784 16.9113 16.8965 16.9833 17.2282 17.1913C17.8864 17.6039 18.8968 18.7305 19.746 18.3147C20.0218 18.1797 20.1814 17.7668 20.2553 17.4914C20.3426 17.1663 20.398 16.7968 20.4566 16.4605C20.5832 15.7335 20.7963 14.8946 21.3169 14.3446C21.5425 14.1061 21.8713 13.8979 22.1571 13.7379C22.6288 13.4798 23.1423 13.3072 23.6741 13.2281C23.8525 13.2007 24.0431 13.1913 24.2072 13.166C24.2859 13.8004 24.3245 14.4469 24.3988 15.0826C24.4118 15.1931 24.4235 15.309 24.4268 15.42C23.8946 15.382 23.3325 15.4303 22.9123 15.7989C21.8774 16.7067 22.8671 19.2497 20.8458 20.0821C20.4604 20.2406 20.0675 20.3436 19.6468 20.3197C18.7085 20.2663 17.9487 19.7977 17.2362 19.2222C16.9177 18.9648 16.6161 18.7019 16.2448 18.521C15.9641 18.4236 15.7808 18.454 15.4914 18.5096C13.9784 19.0272 13.0099 19.1599 11.4619 18.6379C11.5911 18.3737 11.8587 17.7222 11.9575 17.4476C12.2898 17.603 12.8218 17.6656 13.178 17.6261C14.0319 17.5317 14.7273 16.8355 15.5832 16.7348C15.8877 16.7158 16.0895 16.7334 16.3909 16.7916Z"
        fill="#2E90FA"
      />
      <path
        d="M4.57335 18.6026L5.47335 16.2178C5.58491 16.3192 5.5291 16.5272 5.56666 16.6789C5.64616 16.9998 5.74857 17.826 5.9132 18.0808L5.89581 18.1295C5.97667 18.2981 6.02607 18.5007 6.10154 18.6605C6.24713 18.9688 6.46719 19.5644 6.69029 19.8105L6.68181 19.8426L6.69336 19.8567C6.86341 20.0664 6.98384 20.3014 7.18361 20.5305C7.85804 21.3034 8.62575 21.8059 9.55775 22.1995C9.73843 22.2763 9.92229 22.3453 10.1088 22.4064C10.278 22.4606 10.5483 22.5183 10.6731 22.6053C10.6807 22.6074 10.6884 22.6095 10.696 22.6116C10.0142 22.8985 9.28093 23.1912 8.61244 23.4967C8.29935 23.6494 7.84727 23.8253 7.51844 23.9487C7.02992 24.1649 6.54167 24.3501 6.06171 24.5875C5.75359 24.738 5.50475 24.8502 5.18397 24.97L5.17579 24.9592C5.10653 24.8679 4.7245 24.7468 4.58522 24.6457C4.26723 24.4145 4.10751 24.2143 3.86568 23.9152L3.85923 23.9145C3.8604 23.9188 3.44118 23.2317 3.42931 23.2167L3.4389 23.1802C3.3239 23.0093 3.26868 22.7573 3.22996 22.5603C3.22393 22.5297 3.19324 22.5247 3.16357 22.5094C3.26166 22.2018 3.39685 21.8556 3.50857 21.5473C3.73372 20.983 3.94582 20.3302 4.15516 19.7516C4.28151 19.3766 4.43612 18.9759 4.57335 18.6026Z"
        fill="#FFBC5D"
      />
      <path
        d="M4.57335 18.6026L5.47335 16.2178C5.58491 16.3192 5.52911 16.5272 5.56666 16.6789C5.64616 16.9998 5.74857 17.826 5.9132 18.0808L5.89582 18.1295C5.97667 18.2981 6.02607 18.5007 6.10154 18.6605C6.24714 18.9688 6.46719 19.5644 6.69029 19.8105L6.68181 19.8426C6.36416 20.2486 6.01125 20.8027 5.70345 21.2381L5.69893 21.2479C5.53456 21.4843 5.3514 21.7662 5.18063 21.9928L5.17499 22.0121C4.93871 22.3078 4.57226 22.8789 4.33985 23.208L4.33714 23.2221C4.27296 23.3129 3.89211 23.8512 3.86568 23.9152L3.85923 23.9145C3.8604 23.9188 3.44118 23.2317 3.42931 23.2167L3.4389 23.1802C3.3239 23.0093 3.26868 22.7573 3.22996 22.5603C3.22393 22.5297 3.19324 22.5247 3.16357 22.5094C3.26166 22.2018 3.39685 21.8556 3.50857 21.5473C3.73372 20.983 3.94582 20.3302 4.15516 19.7516C4.28151 19.3766 4.43612 18.9759 4.57335 18.6026Z"
        fill="#FEDC84"
      />
      <path
        d="M4.15516 19.7529C4.24069 19.8202 4.23876 19.9779 4.26813 20.081C4.3366 20.3218 4.41117 20.6848 4.54825 20.8898L4.53646 20.9252L4.54539 20.9402C4.69445 21.1958 4.93817 21.7852 5.18063 21.9941L5.17499 22.0134C4.93871 22.3091 4.57226 22.8802 4.33985 23.2093L4.33714 23.2234C4.27296 23.3142 3.89211 23.8525 3.86568 23.9165L3.85923 23.9158C3.8604 23.9201 3.44118 23.233 3.42931 23.218L3.4389 23.1815C3.3239 23.0106 3.26868 22.7586 3.22996 22.5616C3.22393 22.531 3.19324 22.526 3.16357 22.5107C3.26166 22.2031 3.39685 21.8569 3.50857 21.5486C3.73372 20.9843 3.94582 20.3315 4.15516 19.7529Z"
        fill="#FEDC84"
      />
      <path
        d="M3.50857 21.5488C3.59922 21.6287 3.82529 22.2332 3.84469 22.3414L3.835 22.3897C3.95885 22.4936 4.12388 23.0114 4.33985 23.2095L4.33714 23.2236C4.27296 23.3145 3.89211 23.8527 3.86568 23.9167L3.85923 23.916C3.8604 23.9203 3.44118 23.2332 3.42931 23.2182L3.4389 23.1818C3.3239 23.0108 3.26868 22.7588 3.22996 22.5618C3.22393 22.5313 3.19324 22.5262 3.16357 22.5109C3.26166 22.2033 3.39685 21.8571 3.50857 21.5488Z"
        fill="#FFBC5D"
      />
      <path
        d="M3.50857 21.5488C3.59922 21.6287 3.82529 22.2332 3.84469 22.3414L3.835 22.3897C3.68923 22.6421 3.57578 22.9372 3.4389 23.1818C3.3239 23.0108 3.26868 22.7588 3.22996 22.5618C3.22393 22.5313 3.19324 22.5262 3.16357 22.5109C3.26166 22.2033 3.39685 21.8571 3.50857 21.5488Z"
        fill="#FA8F2A"
      />
      <path
        d="M4.15538 19.7529C4.24091 19.8202 4.23898 19.9779 4.26835 20.081C4.33682 20.3218 4.41139 20.6848 4.54847 20.8898L4.53668 20.9252C4.32273 21.3245 4.07249 21.9815 3.84491 22.3412C3.82551 22.233 3.59944 21.6285 3.50879 21.5486C3.73394 20.9843 3.94604 20.3315 4.15538 19.7529Z"
        fill="#FFBC5D"
      />
      <path
        d="M4.57347 18.6026L5.47346 16.2178C5.58503 16.3192 5.52922 16.5272 5.56677 16.6789C5.64627 16.9998 5.74869 17.826 5.91332 18.0808L5.89593 18.1295C5.74511 18.3964 5.12574 19.7888 5.02499 19.8944L5.01077 19.9547C4.90995 20.1572 4.61557 20.7099 4.54837 20.8885C4.41129 20.6835 4.33672 20.3205 4.26825 20.0797C4.23887 19.9766 4.2408 19.8188 4.15527 19.7516C4.28162 19.3766 4.43623 18.9759 4.57347 18.6026Z"
        fill="#FFBC5D"
      />
      <path
        d="M4.57347 18.6035C4.68486 18.6999 4.83054 19.6448 5.02499 19.8953L5.01077 19.9556C4.90995 20.1581 4.61557 20.7108 4.54837 20.8894C4.41129 20.6844 4.33672 20.3214 4.26825 20.0806C4.23887 19.9775 4.2408 19.8197 4.15527 19.7525C4.28162 19.3775 4.43623 18.9768 4.57347 18.6035Z"
        fill="#FA8F2A"
      />
      <path
        d="M4.54939 20.8908C4.6166 20.7123 4.91098 20.1596 5.01179 19.957C5.09709 20.1712 5.57023 21.1007 5.70458 21.2405L5.70007 21.2502C5.5357 21.4866 5.35253 21.7685 5.18177 21.9952C4.93931 21.7862 4.69559 21.1969 4.54653 20.9412L4.5376 20.9263L4.54939 20.8908Z"
        fill="#FFBC5D"
      />
      <path
        d="M5.17552 22.0137C5.66123 22.6678 6.13336 23.1491 6.83619 23.5773C6.98682 23.6692 7.43295 23.8769 7.51898 23.9502C7.03045 24.1665 6.54221 24.3516 6.06225 24.5891C5.75413 24.7395 5.50529 24.8517 5.1845 24.9716L5.17632 24.9608C5.10707 24.8694 4.72504 24.7484 4.58575 24.6473C4.26776 24.4161 4.10805 24.2158 3.86621 23.9167C3.89265 23.8528 4.2735 23.3145 4.33768 23.2236L4.34039 23.2096C4.57279 22.8804 4.93924 22.3093 5.17552 22.0137Z"
        fill="#FFBC5D"
      />
      <path
        d="M4.33768 23.2246C4.89382 23.9706 5.23898 24.1867 6.06225 24.59C5.75413 24.7405 5.50529 24.8527 5.1845 24.9725L5.17632 24.9618C5.10707 24.8704 4.72504 24.7493 4.58575 24.6482C4.26776 24.417 4.10805 24.2168 3.86621 23.9177C3.89265 23.8537 4.2735 23.3155 4.33768 23.2246Z"
        fill="#FA8F2A"
      />
      <path
        d="M5.69923 21.249L5.70696 21.2582C5.83098 21.408 5.96511 21.6298 6.0949 21.7951C6.52562 22.3468 7.07186 22.7975 7.69528 23.1156C7.83111 23.1852 7.9706 23.2474 8.11319 23.302C8.21579 23.3405 8.54017 23.4506 8.61274 23.4979C8.29965 23.6506 7.84757 23.8265 7.51875 23.9498C7.43271 23.8765 6.98659 23.6688 6.83596 23.5769C6.13313 23.1488 5.661 22.6674 5.17529 22.0133L5.18094 21.994C5.3517 21.7673 5.53486 21.4854 5.69923 21.249Z"
        fill="#FA8F2A"
      />
      <path
        d="M8.57267 17.125C9.54489 18.5095 10.7064 19.5933 12.4336 19.9175C13.1855 20.0587 14.1347 19.9817 14.7927 19.5508C15.1401 19.3234 15.3509 18.8979 15.4917 18.5105C15.7811 18.4549 15.9644 18.4245 16.2451 18.522C16.0618 19.3642 15.5279 20.364 14.7768 20.8146C14.1861 21.1691 13.5141 21.4311 12.8779 21.6979C12.5622 21.8307 12.2372 21.9819 11.9212 22.1102C11.5579 22.2685 11.0651 22.488 10.6968 22.6145C10.6892 22.6124 10.6815 22.6103 10.6739 22.6082C10.5491 22.5212 10.2788 22.4635 10.1096 22.4093C9.9231 22.3482 9.73924 22.2792 9.55856 22.2025C8.62655 21.8089 7.85884 21.3063 7.18441 20.5334C6.98464 20.3043 6.86422 20.0693 6.69417 19.8596L6.68262 19.8456L6.69109 19.8134C6.79408 19.7003 7.12516 19.1812 7.25342 19.0097L7.26417 18.9891L8.01925 17.8988C8.18736 17.6531 8.3852 17.3481 8.57267 17.125Z"
        fill="#FFBC5D"
      />
      <path
        d="M7.25342 19.0078C7.45536 19.2675 7.56932 19.5873 7.80771 19.8476C8.65729 20.7757 9.86725 21.4104 11.0377 21.8377C11.2565 21.916 11.8089 21.9994 11.9212 22.1083C11.5579 22.2665 11.0651 22.4861 10.6968 22.6126C10.6892 22.6105 10.6815 22.6084 10.6739 22.6063C10.5491 22.5193 10.2788 22.4616 10.1096 22.4074C9.9231 22.3463 9.73924 22.2773 9.55856 22.2005C8.62655 21.8069 7.85884 21.3044 7.18441 20.5315C6.98464 20.3024 6.86422 20.0674 6.69417 19.8577L6.68262 19.8436L6.69109 19.8115C6.79408 19.6984 7.12516 19.1793 7.25342 19.0078Z"
        fill="#FA8F2A"
      />
      <path
        d="M6.04654 14.7913C7.02553 12.6687 7.30687 11.7251 9.78635 11.29C9.84092 11.4739 9.95202 11.8254 9.97833 12.0034C9.57311 12.0265 9.01049 12.191 8.67196 12.3982C8.1443 12.7211 7.90065 13.4742 7.82664 14.0576C7.82096 14.1022 7.81537 14.2014 7.80366 14.2391C7.70773 15.2763 8.00133 16.2583 8.57264 17.1245C8.38517 17.3476 8.18732 17.6526 8.01922 17.8982L7.26414 18.9885L7.25339 19.0092C7.12513 19.1807 6.79405 19.6998 6.69106 19.8129C6.46796 19.5668 6.24791 18.9712 6.10231 18.6629C6.02684 18.5031 5.97744 18.3005 5.89659 18.1319L5.91397 18.0832C5.74934 17.8284 5.64693 17.0022 5.56743 16.6813C5.52988 16.5296 5.58569 16.3216 5.47412 16.2202C5.64695 15.7506 5.85716 15.2571 6.04654 14.7913Z"
        fill="#FFBC5D"
      />
      <path
        d="M6.5079 16.8142C6.57931 16.7027 6.71401 16.417 6.77583 16.2929C6.98868 15.8657 7.1944 15.435 7.39292 15.001C7.4887 14.7968 7.6671 14.4036 7.80356 14.2383C7.70763 15.2754 8.00123 16.2575 8.57253 17.1237C8.38506 17.3467 8.18722 17.6518 8.01912 17.8974L7.26404 18.9877L7.25329 19.0084C7.12503 19.1798 6.79394 19.699 6.69096 19.8121C6.46786 19.5659 6.2478 18.9703 6.10221 18.662C6.02674 18.5022 5.97734 18.2997 5.89648 18.131L5.91387 18.0824C6.09393 17.7202 6.29411 17.2443 6.48016 16.9029L6.5079 16.8142Z"
        fill="#FEDC84"
      />
      <path
        d="M6.48016 16.9014C6.54773 16.9875 6.63751 17.4198 6.69355 17.5739C6.84188 17.9819 7.04389 18.6244 7.26404 18.9862L7.25329 19.0069C7.12503 19.1783 6.79394 19.6975 6.69096 19.8106C6.46786 19.5644 6.2478 18.9688 6.10221 18.6605C6.02674 18.5007 5.97734 18.2982 5.89648 18.1295L5.91387 18.0809C6.09393 17.7187 6.29411 17.2428 6.48016 16.9014Z"
        fill="#FFBC5D"
      />
      <path
        d="M6.04654 14.791C6.09674 14.8228 6.11916 14.8277 6.13172 14.8942C6.15698 15.028 6.18647 15.2802 6.20344 15.4008C6.22755 15.5722 6.44068 16.6996 6.508 16.8148L6.48026 16.9035C6.29422 17.2449 6.09403 17.7208 5.91397 18.083C5.74934 17.8282 5.64693 17.002 5.56743 16.681C5.52988 16.5294 5.58569 16.3213 5.47412 16.2199C5.64695 15.7504 5.85716 15.2568 6.04654 14.791Z"
        fill="#FA8F2A"
      />
      <path
        d="M14.5542 14.4257C14.6935 14.326 15.147 14.1648 15.3221 14.1582C16.0196 15.0366 16.1855 15.7392 16.3913 16.7925C16.0899 16.7343 15.8882 16.7167 15.5837 16.7357C15.4574 16.1214 15.2581 15.5685 14.9361 15.0288C14.82 14.8342 14.6516 14.6228 14.5542 14.4257Z"
        fill="#FFBC5D"
      />
      <path
        d="M11.4268 11.4033C12.1491 11.4879 13.5033 12.2345 14.0029 12.7576C13.8559 12.8451 13.7496 12.9131 13.6187 13.0246C13.5729 13.0637 13.455 13.1788 13.4188 13.2029C12.9165 12.7526 12.2509 12.3691 11.6049 12.1794C11.5422 11.9417 11.4898 11.6543 11.4268 11.4033Z"
        fill="#FFBC5D"
      />
      <path
        d="M20.993 4.53704C21.1686 4.47529 21.615 4.28384 21.8007 4.20137C22.1345 4.05296 22.8414 3.79894 23.1178 3.62598C23.3052 4.01211 23.4482 4.41925 23.5951 4.82475C23.9304 5.75078 24.1402 6.65894 24.2072 7.64278C24.2802 8.71345 23.9225 9.86246 22.8804 10.3528C22.1432 10.6997 21.1738 10.7191 20.4109 10.4492C20.1378 10.3506 19.9068 10.2153 19.6513 10.076C19.1275 9.79034 18.4436 9.20579 17.8074 9.36982C17.5232 9.44306 17.7302 10.0176 17.7863 10.2073C18.0288 11.0252 18.5739 12.1465 18.0672 12.9603C17.8688 13.2516 17.5326 13.4649 17.219 13.6198C16.8112 13.8214 16.3621 13.9387 15.9223 14.0448C15.8271 14.0677 15.367 14.1352 15.3218 14.157C15.1467 14.1636 14.6933 14.3248 14.5539 14.4245C13.8902 14.8578 13.4395 15.6387 13.1607 16.365C12.7643 16.3597 12.3679 16.3506 11.9717 16.3379C12.1723 15.429 12.4599 14.5386 12.9836 13.7594C13.1061 13.5771 13.2779 13.3759 13.4194 13.2034C13.4556 13.1793 13.5735 13.0643 13.6194 13.0251C13.7502 12.9136 13.8565 12.8456 14.0035 12.7581C14.6637 12.5056 15.2973 12.4039 15.9878 12.2826C16.0426 12.273 16.1386 12.2371 16.1782 12.1989C16.4134 11.6277 15.0317 9.80418 16.0082 8.47482C16.2381 8.16189 16.5244 7.94392 16.8828 7.79586C17.634 7.48541 18.6239 7.60562 19.3606 7.91687C19.8299 8.11516 20.6018 8.73495 21.0293 8.79833C21.1736 8.81972 21.3219 8.7802 21.4548 8.72641C21.6871 8.63245 21.9568 8.48577 22.06 8.24311C22.3165 7.63884 21.7456 6.23302 21.4939 5.6553C21.3332 5.28649 21.1793 4.89193 20.993 4.53704Z"
        fill="#FF80A5"
      />
      <path
        d="M9.56474 9.4248C9.81663 9.57085 10.0428 9.91859 10.3434 10.0889C10.4474 10.1479 11.1593 10.5576 11.1754 10.5779C11.2178 10.7068 11.2611 10.8465 11.3059 10.9737C10.8846 10.9971 10.3615 10.9327 9.9674 10.7878C9.8397 10.7408 9.74332 10.6468 9.63139 10.6266C9.53926 10.1476 9.53947 9.91053 9.56474 9.4248Z"
        fill="#F72717"
      />
      <path
        d="M9.6311 10.6279C9.7429 10.6481 9.83956 10.742 9.96704 10.7891C10.3611 10.9339 10.8846 10.999 11.3059 10.9756C11.3317 11.1053 11.3883 11.2747 11.427 11.4062C11.49 11.6571 11.5431 11.9441 11.6057 12.1816C11.6027 12.2561 11.6107 12.3764 11.6155 12.4541C11.7044 13.8997 10.8597 15.1066 9.8313 16.0635C9.62481 15.8519 9.23448 15.5269 9.0022 15.3291C9.2768 14.9846 9.46508 14.8058 9.69067 14.4082C10.1355 13.6241 10.2114 12.8704 9.97778 12.0049C9.95147 11.8269 9.84095 11.4749 9.78638 11.291C9.7264 11.1084 9.67221 10.8227 9.6311 10.6279ZM12.7141 2.73926C12.8105 2.92905 12.9246 3.27529 13.0002 3.48438L13.4612 4.75977C12.6051 4.74002 11.3246 4.81747 10.6653 5.4375C10.3442 5.73964 10.0614 6.36015 10.0735 6.80664C10.0824 7.13129 10.1324 7.30699 10.2424 7.60742C10.8391 6.90144 11.4966 6.3662 12.4602 6.2793C13.0292 6.22813 13.537 6.36932 13.9817 6.73926C14.8656 7.47482 15.1103 8.80502 14.3411 9.71387C13.9006 10.2339 13.0641 10.6401 12.3821 10.6865C12.1372 10.701 11.8775 10.6853 11.6331 10.6602C11.5164 10.6481 11.2714 10.5507 11.176 10.5771C11.2184 10.7058 11.2612 10.8456 11.3059 10.9727C10.8848 10.9961 10.362 10.9318 9.96802 10.7871C9.8404 10.7402 9.74294 10.6463 9.6311 10.626C9.53903 10.1472 9.53943 9.90945 9.5647 9.42383C9.53503 9.31774 9.21854 8.91885 9.13501 8.77539C8.43403 7.57121 8.37982 6.45584 8.99243 5.20898C9.79003 3.5861 10.9891 2.97182 12.7141 2.73926ZM12.5618 7.80273C12.0794 7.90892 11.6405 8.23483 11.3782 8.65039C11.3304 8.72766 11.2855 8.8072 11.2434 8.8877C11.5123 9.05789 11.6576 9.15022 11.9856 9.18262C12.4073 9.1816 13.2743 8.97156 13.262 8.4248C13.2586 8.24529 13.1816 8.07434 13.05 7.95215C12.9264 7.83888 12.7776 7.78993 12.6106 7.79883C12.5945 7.79971 12.5778 7.80147 12.5618 7.80273Z"
        fill="#F72717"
      />
      <path
        d="M5.18445 24.9723C5.1813 24.9739 5.17818 24.9756 5.175 24.9774C4.69747 25.2186 3.27136 25.788 2.77713 25.6237C2.66268 25.5856 2.5714 25.5106 2.52242 25.3994C2.28124 24.8523 2.95006 23.1118 3.16405 22.5117C3.19372 22.527 3.22441 22.532 3.23044 22.5626C3.26916 22.7596 3.32438 23.0116 3.43938 23.1825L3.42979 23.219C3.44166 23.234 3.86088 23.9211 3.85971 23.9168L3.86616 23.9175C4.10799 24.2166 4.26771 24.4168 4.5857 24.648C4.72498 24.7491 5.10701 24.8702 5.17627 24.9615L5.18445 24.9723Z"
        fill="#FFBC5D"
      />
      <path
        d="M3.42966 23.2178C3.44152 23.2327 3.86074 23.9199 3.85957 23.9155C3.75476 24.0666 3.66335 24.2037 3.54183 24.3423C3.47619 24.3604 3.39724 24.3741 3.32955 24.3878C2.82338 24.1391 3.1821 23.8052 3.3254 23.4359C3.35309 23.3647 3.39627 23.2876 3.42966 23.2178Z"
        fill="#FEDC84"
      />
      <path
        d="M5.28362 8.61523C5.43022 8.64068 6.54449 9.47954 6.84379 9.61361C6.67518 10.0167 6.42467 10.5971 6.29353 10.9969C6.21679 10.9525 6.12296 10.9068 6.04301 10.8656C5.5853 10.6174 4.777 10.2272 4.30762 10.0135C4.63478 9.56475 4.96494 9.07334 5.28362 8.61523Z"
        fill="#F72717"
      />
      <path
        d="M23.1595 22.6436C23.2477 22.708 23.4831 22.9585 23.5739 23.0448C23.9304 23.3837 24.2843 23.7702 24.6481 24.0965C24.3203 24.426 23.8763 24.8499 23.581 25.1919L22.0845 23.7276C22.2021 23.6362 22.3926 23.433 22.5012 23.3224C22.7226 23.0981 22.9422 22.8718 23.1595 22.6436Z"
        fill="#FF80A5"
      />
      <path
        d="M19.0327 21.1348L19.06 21.1438C19.4086 21.5541 19.7245 22.3536 19.785 22.8837C19.8103 23.1066 19.7911 23.3428 19.7968 23.5684C19.4847 23.5181 19.0902 23.4825 18.7722 23.4468C18.608 23.4253 18.4533 23.4045 18.2879 23.3927C18.2884 23.361 18.2884 23.3294 18.2877 23.2978C18.2808 22.9325 18.0702 22.2968 17.8076 22.0456C18.2113 21.7662 18.6311 21.4283 19.0327 21.1348Z"
        fill="#F72717"
      />
      <path
        d="M4.18956 4.30762C4.28513 4.32514 4.72119 4.66111 4.85954 4.73505C5.13233 4.88085 5.28791 4.94024 5.58214 5.0355C5.4987 5.50719 5.43884 6.03969 5.37796 6.51847C5.17374 6.50216 4.94208 6.4381 4.74987 6.37005C4.11643 6.11772 3.76087 5.85615 3.23096 5.44282C3.4326 5.23619 4.01808 4.5431 4.18956 4.30762Z"
        fill="#FF80A5"
      />
      <path
        d="M18.4419 3.06738L19.959 3.31695C19.8628 3.92072 19.4815 4.66443 19.0711 5.11755L18.8069 5.3963C18.741 5.30122 18.5689 5.12262 18.4853 5.03157L17.772 4.26843C18.175 3.87976 18.2858 3.58323 18.4419 3.06738Z"
        fill="#F72717"
      />
      <path
        d="M18.9299 14.0645C18.9927 14.1163 19.1048 14.2641 19.168 14.3304C19.4133 14.5867 19.8023 15.1205 20.0546 15.3238C19.7864 15.571 19.5008 15.8072 19.2281 16.0499C19.0853 16.1769 18.9167 16.3083 18.7923 16.4495C18.5483 16.1522 18.2773 15.8693 18.0296 15.5741C17.9163 15.4392 17.7923 15.2958 17.6655 15.1747C17.8001 15.089 18.8171 14.2038 18.9299 14.0645Z"
        fill="#F72717"
      />
    </svg>
  );
}

function Pension() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-pension b-icon-black"
    >
      <path
        d="M16.2765 7H1.72349C1.03401 7 0.738519 6.24816 1.28026 5.89072L8.55676 1.12083C8.69111 1.04172 8.84414 1 9 1C9.15587 1 9.3089 1.04172 9.44324 1.12083L16.7197 5.89072C17.2615 6.24816 16.966 7 16.2765 7Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3846 14H1.61538C1.27552 14 1 14.2687 1 14.6V16.4C1 16.7313 1.27552 17 1.61538 17H16.3846C16.7244 17 17 16.7313 17 16.4V14.6C17 14.2687 16.7244 14 16.3846 14Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7V14"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7V14"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 7V14"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7V14"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ProductAdd() {
  return (
    <svg
      width="30"
      height="36"
      viewBox="0 0 36 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className="b-icon b-icon-product-add"
    >
      <path
        fill="none"
        stroke="#0F172A"
        strokeWidth="2"
        strokeLinecap="round"
        d="M13,15h10"
      />
      <path
        fill="none"
        stroke="#0F172A"
        strokeWidth="2"
        strokeLinecap="round"
        d="M18,10v10"
      />
    </svg>
  );
}

function ProductRemove() {
  return (
    <svg
      width="30"
      height="36"
      viewBox="0 0 36 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className="b-icon b-icon-product-remove"
    >
      <path
        fill="none"
        stroke="#0F172A"
        strokeWidth="2"
        strokeLinecap="round"
        d="M13,15h10"
      />
    </svg>
  );
}

function Print() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      fill="none"
      className="b-icon b-icon-product-print"
    >
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="13.3333"
        d="
      M14,13.2h1c1.1,0,2-0.9,2-2v-4c0-1.1-0.9-2-2-2H3c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2h1"
      />
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="13.3333"
        d="
      M14.8,10.6H3.1"
      />
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="13.3333"
        d="
      M5,17h8.1c0.5,0,1-0.4,1-1v-5.4H4V16C4,16.6,4.4,17,5,17z"
      />
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="13.3333"
        d="
      M4.8,7.4H3.2"
      />
      <path
        fill="none"
        stroke="#000000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="13.3333"
        d="
      M5.9,1H12c1.1,0,2,0.9,2,2v2.3H4V3C4,1.9,4.8,1,5.9,1z"
      />
    </svg>
  );
}

function Report() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-report b-icon-black"
    >
      <path
        d="M16 15.7692C16 16.0956 15.8659 16.4087 15.6272 16.6395C15.3885 16.8703 15.0648 17 14.7273 17H3.27272C2.93517 17 2.61145 16.8703 2.37277 16.6395C2.13409 16.4087 2 16.0956 2 15.7692V2.23077C2 1.90434 2.13409 1.5913 2.37277 1.36048C2.61145 1.12967 2.93517 1 3.27272 1H10.3819C10.7194 1 11.0431 1.12967 11.2818 1.36048L15.6272 5.5626C15.8659 5.7934 16 6.10646 16 6.43287V15.7692Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8H13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12H13"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12.1429L6.125 13L8 11"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 8.14286L6.125 9L8 7"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ReportDone() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6663 11.6663V17.4997C25.6663 23.333 23.333 25.6663 17.4997 25.6663H10.4997C4.66634 25.6663 2.33301 23.333 2.33301 17.4997V10.4997C2.33301 4.66634 4.66634 2.33301 10.4997 2.33301H16.333M25.6663 11.6663H20.9997C17.4997 11.6663 16.333 10.4997 16.333 6.99967V2.33301M25.6663 11.6663L16.333 2.33301M8.52808 18.3163L10.2781 20.0663L14.9447 15.3996"
        stroke="#0F172A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ReportInProcess() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.333 2.33301H10.4997C4.66634 2.33301 2.33301 4.66634 2.33301 10.4997V17.4997C2.33301 23.333 4.66634 25.6663 10.4997 25.6663H13.4995M16.333 2.33301V6.99967C16.333 10.4997 17.4997 11.6663 20.9997 11.6663H25.6663M16.333 2.33301L25.6663 11.6663M25.6663 11.6663V15.1663"
        stroke="#0F172A"
        strokeWidth="1.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7812 19.5938V20.64C20.7812 21.0337 20.5788 21.405 20.23 21.6075L19.375 22.125M25 21C25 23.4853 22.9853 25.5 20.5 25.5C18.0147 25.5 16 23.4853 16 21C16 18.5147 18.0147 16.5 20.5 16.5C22.9853 16.5 25 18.5147 25 21Z"
        stroke="#0F172A"
        strokeWidth="1.6875"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ResendMail() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-resend-mail b-icon-main"
    >
      <path
        d="M12.2144 3.85718L9.00007 0.642891L5.78578 3.85718"
        stroke="#FF220D"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 8.35718L9 0.642891"
        stroke="#FF220D"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4286 5.78564C15.7696 5.78564 16.0967 5.92111 16.3378 6.16222C16.5788 6.40334 16.7143 6.73036 16.7143 7.07136V16.0714C16.7143 16.4123 16.5788 16.7394 16.3378 16.9805C16.0967 17.2216 15.7696 17.3571 15.4286 17.3571H2.57148C2.23048 17.3571 1.90346 17.2216 1.66234 16.9805C1.42123 16.7394 1.28577 16.4123 1.28577 16.0714V7.07136C1.28577 6.73036 1.42123 6.40334 1.66234 6.16222C1.90346 5.92111 2.23048 5.78564 2.57148 5.78564"
        stroke="#FF220D"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.28577 7.40576L9.00005 12.8572L16.7143 7.40576"
        stroke="#FF220D"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_8504_30846">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function Search() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-search b-icon-dark-gray"
    >
      <path
        d="M8.5 15C12.366 15 15.5 11.866 15.5 8C15.5 4.134 12.366 1 8.5 1C4.634 1 1.5 4.134 1.5 8C1.5 11.866 4.634 15 8.5 15Z"
        stroke="#6C7786"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 17L13.5 13"
        stroke="#6C7786"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SearchList() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-searclist b-icon-dark-gray"
    >
      <path
        d="M6.22179 11.6662C9.22868 11.6662 11.6662 9.22868 11.6662 6.22179C11.6662 3.2149 9.22868 0.777344 6.22179 0.777344C3.2149 0.777344 0.777344 3.2149 0.777344 6.22179C0.777344 9.22868 3.2149 11.6662 6.22179 11.6662Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2224 13.2215L10.1113 10.1104"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SearchMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="b-icon b-icon-search-m b-icon-dark-gray"
    >
      <path
        d="M10.6673 20.0002C15.822 20.0002 20.0007 15.8215 20.0007 10.6668C20.0007 5.51217 15.822 1.3335 10.6673 1.3335C5.51265 1.3335 1.33398 5.51217 1.33398 10.6668C1.33398 15.8215 5.51265 20.0002 10.6673 20.0002Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6673 22.6668L17.334 17.3335"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SearchNormal() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.4016 14.4016L12.4816 12.4816M12.2416 6.92156C12.2416 9.85972 9.85972 12.2416 6.92156 12.2416C3.98341 12.2416 1.60156 9.85972 1.60156 6.92156C1.60156 3.98341 3.98341 1.60156 6.92156 1.60156C9.85972 1.60156 12.2416 3.98341 12.2416 6.92156Z"
        stroke="#64748B"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Send() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-send b-icon-black"
    >
      <path
        d="M7.53719 13.9237L10.2197 16.592C10.3843 16.7605 10.5901 16.8832 10.8167 16.9479C11.0433 17.0127 11.2829 17.0171 11.5117 16.9609C11.742 16.9073 11.9547 16.7956 12.1292 16.6362C12.3038 16.4768 12.4344 16.2753 12.5084 16.051L16.9136 2.85694C17.0056 2.60972 17.0246 2.34133 16.9683 2.08366C16.912 1.82597 16.7829 1.58986 16.5964 1.40337C16.4098 1.21688 16.1734 1.08786 15.9156 1.03165C15.6577 0.975434 15.3891 0.994389 15.1418 1.08626L1.93838 5.48836C1.70611 5.56763 1.49925 5.70746 1.33917 5.89337C1.17909 6.07927 1.0716 6.30453 1.0278 6.54585C0.982586 6.76533 0.99265 6.99259 1.05708 7.20722C1.12152 7.42184 1.2383 7.61712 1.39695 7.77548L4.76854 11.1447L4.65779 15.4116L7.53719 13.9237Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 1.5L5 11"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SendMail() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-send-mail b-icon-custom"
    >
      <circle cx="20" cy="20" r="20" fill="#F2F8FF" />
      <g>
        <path
          d="M18.5372 24.9237L21.2197 27.592C21.3843 27.7605 21.5901 27.8832 21.8167 27.9479C22.0433 28.0127 22.2829 28.0171 22.5117 27.9609C22.742 27.9073 22.9547 27.7956 23.1292 27.6362C23.3038 27.4768 23.4344 27.2753 23.5084 27.051L27.9136 13.8569C28.0056 13.6097 28.0246 13.3413 27.9683 13.0837C27.912 12.826 27.7829 12.5899 27.5964 12.4034C27.4098 12.2169 27.1734 12.0879 26.9156 12.0316C26.6577 11.9754 26.3891 11.9944 26.1418 12.0863L12.9384 16.4884C12.7061 16.5676 12.4993 16.7075 12.3392 16.8934C12.1791 17.0793 12.0716 17.3045 12.0278 17.5458C11.9826 17.7653 11.9926 17.9926 12.0571 18.2072C12.1215 18.4218 12.2383 18.6171 12.3969 18.7755L15.7685 22.1447L15.6578 26.4116L18.5372 24.9237Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.5 12.5L16 22"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

function ShoppingCart() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-shopping-cart b-icon-black"
    >
      <path
        d="M0.75 0.75H2.53025C5.25 0.75 4.50488 4.68 4.4128 5.75L3.5636 12.71C3.42036 14.34 4.74019 15.74 6.41812 15.74H17.3144C18.7877 15.74 20.0769 14.56 20.1894 13.13L20.7419 8.63C20.8647 6.97 19.5755 5.62 17.8669 5.62H4.65836M17.25 5.25L14.5 3.00467C14.2877 2.84153 14.0009 2.75 13.7021 2.75C13.4032 2.75 13.1164 2.84153 12.9041 3.00467L10.25 5.25M12.3157 3.50247L9.61596 2.91138C9.47454 2.87864 9.32616 2.86798 9.17939 2.88003C9.03262 2.89207 8.89039 2.92658 8.76094 2.98155C8.63148 3.03652 8.51736 3.11087 8.4252 3.20029C8.33303 3.2897 8.26464 3.39241 8.22399 3.50247L7.25 5.25M16.6085 19.5C16.6085 20.1904 16.0359 20.75 15.3296 20.75C14.6232 20.75 14.0507 20.1904 14.0507 19.5C14.0507 18.8096 14.6232 18.25 15.3296 18.25C16.0359 18.25 16.6085 18.8096 16.6085 19.5ZM8.42346 19.5C8.42346 20.1904 7.85087 20.75 7.14455 20.75C6.43823 20.75 5.86564 20.1904 5.86564 19.5C5.86564 18.8096 6.43823 18.25 7.14455 18.25C7.85087 18.25 8.42346 18.8096 8.42346 19.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ShoppingCartCheck() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-shopping-cart-check b-icon-black"
    >
      <path
        d="M14.0733 17.2857C13.7183 17.2857 13.4304 16.9978 13.4304 16.6429C13.4304 16.2879 13.7183 16 14.0733 16C14.4284 16 14.7161 16.2879 14.7161 16.6429C14.7161 16.9978 14.4284 17.2857 14.0733 17.2857Z"
        fill="black"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.71634 17.2857C5.36131 17.2857 5.07349 16.9978 5.07349 16.6429C5.07349 16.2879 5.36131 16 5.71634 16C6.07139 16 6.3592 16.2879 6.3592 16.6429C6.3592 16.9978 6.07139 17.2857 5.71634 17.2857Z"
        fill="black"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.999756 1H4.08385L4.4085 4.15789M4.4085 4.15789L5.20124 11.8691C5.26732 12.512 5.79676 13 6.42809 13H14.2234C14.7895 13 15.283 12.6055 15.4203 12.0432L16.9623 5.72742C17.157 4.93018 16.568 4.15789 15.7654 4.15789H4.4085Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25439 8.67857L9.96869 9.96429L12.7812 6.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ShoppingCartMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="b-icon b-icon-shopping-cart-m b-icon-black"
    >
      <path
        d="M1 1.99707H4.75912L6.09836 16.5634C6.15403 16.965 6.34048 17.331 6.62336 17.594C6.90624 17.857 7.26648 17.9994 7.63772 17.9948H17.3357C17.6714 18.0139 18.0036 17.9124 18.2815 17.7056C18.5595 17.4988 18.7679 17.1982 18.8751 16.8497L20.9224 10.1138C20.9989 9.86058 21.0192 9.5911 20.9817 9.32759C20.9443 9.06407 20.8501 8.81408 20.7069 8.59823C20.5579 8.36867 20.3586 8.18365 20.1273 8.06009C19.8961 7.93653 19.6402 7.87838 19.383 7.89096H5.29789"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 23C16.7348 23 16.4804 22.8946 16.2929 22.7071C16.1054 22.5196 16 22.2652 16 22C16 21.7348 16.1054 21.4804 16.2929 21.2929C16.4804 21.1054 16.7348 21 17 21C17.2652 21 17.5196 21.1054 17.7071 21.2929C17.8946 21.4804 18 21.7348 18 22C18 22.2652 17.8946 22.5196 17.7071 22.7071C17.5196 22.8946 17.2652 23 17 23Z"
        fill="black"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 23C6.73478 23 6.48043 22.8946 6.29289 22.7071C6.10536 22.5196 6 22.2652 6 22C6 21.7348 6.10536 21.4804 6.29289 21.2929C6.48043 21.1054 6.73478 21 7 21C7.26522 21 7.51957 21.1054 7.70711 21.2929C7.89464 21.4804 8 21.7348 8 22C8 22.2652 7.89464 22.5196 7.70711 22.7071C7.51957 22.8946 7.26522 23 7 23Z"
        fill="black"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SolidSeparator() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="1px"
      viewBox="0 0 414 1"
      preserveAspectRatio="none"
      fill="none"
    >
      <path
        d="M0.5 0.5L413.5 0.500036"
        stroke="#C5C9CE"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SortAsc() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
    >
      <path
        d="M6.99989 19.0855C6.59156 19.0855 6.18322 18.928 5.87406 18.6189L2.07072 14.8155C1.90156 14.6464 1.90156 14.3664 2.07072 14.1972C2.23989 14.028 2.51989 14.028 2.68906 14.1972L6.49239 18.0005C6.77239 18.2805 7.22739 18.2805 7.50739 18.0005L11.3107 14.1972C11.4799 14.028 11.7599 14.028 11.9291 14.1972C12.0982 14.3664 12.0982 14.6464 11.9291 14.8155L8.12572 18.6189C7.81656 18.928 7.40822 19.0855 6.99989 19.0855Z"
        fill="#6C7786"
      />
      <path
        d="M7.00011 4.19964C7.40844 4.19964 7.81678 4.35714 8.12594 4.6663L11.9293 8.46964C12.0984 8.6388 12.0984 8.9188 11.9293 9.08797C11.7601 9.25714 11.4801 9.25714 11.3109 9.08797L7.50761 5.28464C7.22761 5.00464 6.77261 5.00464 6.49261 5.28464L2.68928 9.08797C2.52011 9.25713 2.24011 9.25713 2.07094 9.08797C1.90178 8.9188 1.90178 8.6388 2.07094 8.46963L5.87428 4.6663C6.18344 4.35714 6.59178 4.19964 7.00011 4.19964Z"
        fill="#6C7786"
        stroke="#64748B"
        strokeWidth="0.5"
      />
    </svg>
  );
}

function SortDefault() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
    >
      <path
        d="M6.99989 19.0855C6.59156 19.0855 6.18322 18.928 5.87406 18.6189L2.07072 14.8155C1.90156 14.6464 1.90156 14.3664 2.07072 14.1972C2.23989 14.028 2.51989 14.028 2.68906 14.1972L6.49239 18.0005C6.77239 18.2805 7.22739 18.2805 7.50739 18.0005L11.3107 14.1972C11.4799 14.028 11.7599 14.028 11.9291 14.1972C12.0982 14.3664 12.0982 14.6464 11.9291 14.8155L8.12572 18.6189C7.81656 18.928 7.40822 19.0855 6.99989 19.0855Z"
        fill="#6C7786"
      />
      <path
        d="M7.00011 4.19964C7.40844 4.19964 7.81678 4.35714 8.12594 4.6663L11.9293 8.46964C12.0984 8.6388 12.0984 8.9188 11.9293 9.08797C11.7601 9.25714 11.4801 9.25714 11.3109 9.08797L7.50761 5.28464C7.22761 5.00464 6.77261 5.00464 6.49261 5.28464L2.68928 9.08797C2.52011 9.25713 2.24011 9.25713 2.07094 9.08797C1.90178 8.9188 1.90178 8.6388 2.07094 8.46963L5.87428 4.6663C6.18344 4.35714 6.59178 4.19964 7.00011 4.19964Z"
        fill="#6C7786"
      />
    </svg>
  );
}

function SortDesc() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
    >
      <path
        d="M6.99989 19.0855C6.59156 19.0855 6.18322 18.928 5.87406 18.6189L2.07072 14.8155C1.90156 14.6464 1.90156 14.3664 2.07072 14.1972C2.23989 14.028 2.51989 14.028 2.68906 14.1972L6.49239 18.0005C6.77239 18.2805 7.22739 18.2805 7.50739 18.0005L11.3107 14.1972C11.4799 14.028 11.7599 14.028 11.9291 14.1972C12.0982 14.3664 12.0982 14.6464 11.9291 14.8155L8.12572 18.6189C7.81656 18.928 7.40822 19.0855 6.99989 19.0855Z"
        fill="#6C7786"
        stroke="#64748B"
        strokeWidth="0.5"
      />
      <path
        d="M7.00011 4.19964C7.40844 4.19964 7.81678 4.35714 8.12594 4.6663L11.9293 8.46964C12.0984 8.6388 12.0984 8.9188 11.9293 9.08797C11.7601 9.25714 11.4801 9.25714 11.3109 9.08797L7.50761 5.28464C7.22761 5.00464 6.77261 5.00464 6.49261 5.28464L2.68928 9.08797C2.52011 9.25713 2.24011 9.25713 2.07094 9.08797C1.90178 8.9188 1.90178 8.6388 2.07094 8.46963L5.87428 4.6663C6.18344 4.35714 6.59178 4.19964 7.00011 4.19964Z"
        fill="#6C7786"
      />
    </svg>
  );
}

function SortSingle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.99989 9.80036C6.59156 9.80036 6.18322 9.64286 5.87406 9.3337L2.07072 5.53036C1.90156 5.3612 1.90156 5.0812 2.07072 4.91203C2.23989 4.74286 2.51989 4.74286 2.68906 4.91203L6.49239 8.71536C6.77239 8.99536 7.22739 8.99536 7.50739 8.71536L11.3107 4.91203C11.4799 4.74286 11.7599 4.74286 11.9291 4.91203C12.0982 5.0812 12.0982 5.3612 11.9291 5.53036L8.12572 9.3337C7.81656 9.64286 7.40822 9.80036 6.99989 9.80036Z"
        fill="#6C7786"
      />
    </svg>
  );
}

function Statistic() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M1 1V16H16"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99999 5C7.10458 5 8 5.89543 8 7C8 8.10457 7.10458 9 5.99999 9C4.89542 9 4 8.10457 4 7C4 5.89543 4.89542 5 5.99999 5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0001 1C15.1045 1 16 1.89543 16 3C16 4.10457 15.1045 5 14.0001 5C12.8955 5 12 4.10457 12 3C12 1.89543 12.8955 1 14.0001 1Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 9C12.1046 9 13 9.89543 13 11C13 12.1046 12.1046 13 11 13C9.89542 13 9 12.1046 9 11C9 9.89543 9.89542 9 11 9Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 11L4 8"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8L9 10"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9L13 5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SubscriptionCashflow() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-subscription-cashflow b-icon-black"
    >
      <path
        d="M3 17V14H6"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8637 8C17.6208 11.8684 15.1568 15.7036 11.1339 16.7391C8.05496 17.5317 4.91337 16.4656 3 14.2565"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.13631 10C0.379143 6.1316 2.84321 2.29651 6.8662 1.26089C9.94504 0.468319 13.0865 1.53434 15 3.74307"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 1V4H12"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Subtract() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-substract b-icon-black"
    >
      <path
        d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5535 15.1553L5.44617 2.84507"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Tag() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.78025 10.1985L5.80025 13.2185C7.04026 14.4585 9.05359 14.4585 10.3003 13.2185L13.2269 10.2919C14.4669 9.05187 14.4669 7.03853 13.2269 5.7919L10.2003 2.77857C9.56693 2.14523 8.69359 1.80523 7.80026 1.8519L4.46692 2.0119C3.13359 2.0719 2.07359 3.1319 2.00692 4.45857L1.84692 7.79187C1.80692 8.69187 2.14692 9.5652 2.78025 10.1985Z"
        stroke="#64748B"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33366 7.99853C7.25413 7.99853 8.00033 7.25233 8.00033 6.33187C8.00033 5.41139 7.25413 4.6652 6.33366 4.6652C5.41319 4.6652 4.66699 5.41139 4.66699 6.33187C4.66699 7.25233 5.41319 7.99853 6.33366 7.99853Z"
        stroke="#64748B"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Ticket() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-ticket b-icon-black"
    >
      <path
        d="M1.16528 13.7312C1.16528 14.4413 1.74092 15.0169 2.451 15.0169H15.5493C16.2592 15.0169 16.835 14.4413 16.835 13.7312V11.3659C15.7932 11.0835 15.0269 10.1313 15.0269 9.00014C15.0269 7.86901 15.7932 6.91684 16.835 6.63443V4.26911C16.835 3.55904 16.2592 2.9834 15.5493 2.9834H2.451C1.74092 2.9834 1.16528 3.55904 1.16528 4.26911V6.62907C2.21727 6.90462 2.9934 7.86175 2.9934 9.00014C2.9934 10.1385 2.21727 11.0957 1.16528 11.3712V13.7312Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7122 2.99316V5.10255"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7122 7.94531V10.0547"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7122 12.9072V15.0166"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TimeWorked() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-time-worked b-icon-black"
    >
      <path
        d="M9 17C12.866 17 16 13.866 16 10C16 6.134 12.866 3 9 3C5.134 3 2 6.134 2 10C2 13.866 5.134 17 9 17Z"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 3C1.84274 2.18425 2.85999 1.50608 4 1"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 3C16.1572 2.18425 15.14 1.50608 14 1"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 7V10H12"
        stroke="black"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ToastActionArrow() {
  return (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-toast-arrow"
    >
      <path
        d="M1 10.3333L4.67453 6.49158C5.10849 6.03788 5.10849 5.29546 4.67453 4.84175L1 1"
        stroke="#0060DF"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function User() {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-user b-icon-black"
    >
      <path
        d="M8.75 10.75C11.5114 10.75 13.75 8.51142 13.75 5.75C13.75 2.98858 11.5114 0.75 8.75 0.75C5.98858 0.75 3.75 2.98858 3.75 5.75C3.75 8.51142 5.98858 10.75 8.75 10.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.75 17.8333C16.75 19.6176 13.3214 20.75 8.75 20.75C4.17857 20.75 0.75 19.6176 0.75 17.8333C0.75 15.2308 4.75 13.75 8.75 13.75C12.75 13.75 16.75 15.5 16.75 17.8333Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function UsersGroup() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-users-group b-icon-black"
    >
      <path
        d="M8.92498 7.54966C9.78251 7.54966 10.6049 7.20901 11.2113 6.60264C11.8176 5.99627 12.1583 5.17386 12.1583 4.31633C12.1583 3.4588 11.8176 2.63639 11.2113 2.03003C10.6049 1.42366 9.78251 1.08301 8.92498 1.08301C8.06744 1.08301 7.24504 1.42366 6.63867 2.03003C6.0323 2.63639 5.69165 3.4588 5.69165 4.31633C5.69165 5.17386 6.0323 5.99627 6.63867 6.60264C7.24504 7.20901 8.06744 7.54966 8.92498 7.54966Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.65015 17.2486H16.2001V16.4607C16.1897 15.5818 15.983 14.7137 15.5921 13.9081C15.2012 13.1025 14.6342 12.3758 13.9248 11.7712C13.2153 11.1666 12.3779 10.6965 11.4624 10.3887C10.5468 10.0809 9.57184 9.94186 8.59533 9.97972C6.73663 10.059 4.98198 10.7744 3.69077 11.9793C2.39956 13.1842 1.66951 14.7874 1.65015 16.4607V17.2486Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function UserMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="b-icon b-icon-user-m b-icon-black"
    >
      <path
        d="M11.899 10.066C13.0424 10.066 14.1389 9.61184 14.9474 8.80336C15.7559 7.99487 16.2101 6.89832 16.2101 5.75495C16.2101 4.61157 15.7559 3.51503 14.9474 2.70654C14.1389 1.89805 13.0424 1.44385 11.899 1.44385C10.7556 1.44385 9.65907 1.89805 8.85058 2.70654C8.04209 3.51503 7.58789 4.61157 7.58789 5.75495C7.58789 6.89832 8.04209 7.99487 8.85058 8.80336C9.65907 9.61184 10.7556 10.066 11.899 10.066Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.19922 22.9983H21.5992V21.9477C21.5854 20.7759 21.3097 19.6185 20.7885 18.5443C20.2673 17.4702 19.5113 16.5013 18.5654 15.6951C17.6194 14.889 16.5029 14.2621 15.2822 13.8518C14.0615 13.4414 12.7615 13.256 11.4595 13.3065C8.98119 13.4122 6.64166 14.366 4.92005 15.9726C3.19844 17.5791 2.22504 19.7168 2.19922 21.9477V22.9983Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Voucher() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-voucher b-icon-black"
    >
      <path
        d="M1 13.8C1 14.4628 1.55012 15 2.22871 15H15.7713C16.4498 15 17 14.4628 17 13.8V11.3592C15.9362 11.0776 15.1537 10.128 15.1537 9C15.1537 7.87196 15.9362 6.92242 17 6.64084V4.2C17 3.53726 16.4498 3 15.7713 3H2.22871C1.55012 3 1 3.53725 1 4.2V6.63556C2.07409 6.91039 2.86654 7.86481 2.86654 9C2.86654 10.1352 2.07409 11.0896 1 11.3644V13.8Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12L12 6"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7C6.77614 7 7 6.77614 7 6.5C7 6.22386 6.77614 6 6.5 6C6.22386 6 6 6.22386 6 6.5C6 6.77614 6.22386 7 6.5 7Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 12C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11C11.2239 11 11 11.2239 11 11.5C11 11.7761 11.2239 12 11.5 12Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Wallet() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-wallet"
    >
      <path
        d="M5.93 20C3.54 20 1.6 18.27 1.6 16.14V11.64C1.6 11.55 1.59 11.45 1.59 11.36C1.59 10.32 2.05 9.34 2.89 8.61C3.36 8.2 3.92 7.89 4.54 7.71C4.98 7.58 5.45 7.5 5.94 7.5C7.07 7.5 8.14 7.89 8.96 8.59C9.8 9.33 10.26 10.31 10.26 11.36V16.14C10.26 18.27 8.32 20 5.94 20H5.93ZM3.35 17.12C3.8 17.94 4.78 18.5 5.93 18.5C7.08 18.5 8.05 17.93 8.5 17.12C7.79 17.55 6.91 17.8 5.93 17.8C4.95 17.8 4.06 17.55 3.35 17.12ZM3.1 14.2C3.15 15.41 4.35 16.31 5.93 16.31C7.51 16.31 8.7 15.41 8.75 14.19C7.98 14.74 6.99 15.06 5.92 15.06C4.85 15.06 3.87 14.75 3.1 14.2ZM3.1 11.58C3.13 11.85 3.22 12.1 3.36 12.34C3.82 13.09 4.8 13.56 5.92 13.56C7.04 13.56 8.02 13.09 8.48 12.34C8.66 12.04 8.75 11.71 8.75 11.37C8.75 10.75 8.47 10.18 7.96 9.76C7.14 9.05 5.87 8.85 4.85 9.19C3.83 9.55 3.1 10.39 3.1 11.37V11.58ZM14.75 18.51H12.25C11.84 18.51 11.5 18.17 11.5 17.76C11.5 17.35 11.84 17.01 12.25 17.01H14.75C17.33 17.01 19 15.34 19 12.76V12.06H17.79C16.28 12.06 15 10.94 14.88 9.5C14.8 8.67 15.1 7.86 15.7 7.27C16.2 6.75 16.91 6.46 17.66 6.46H18.99V5.76C18.99 3.42 17.62 1.81 15.4 1.55C15.16 1.51 14.95 1.51 14.74 1.51H5.75C5.51 1.51 5.28 1.53 5.05 1.56C2.85 1.84 1.5 3.44 1.5 5.76V7.76C1.5 8.17 1.16 8.51 0.75 8.51C0.34 8.51 0 8.17 0 7.76V5.76C0 2.67 1.9 0.44 4.85 0.07C5.13 0.03 5.44 0 5.75 0H14.75C14.99 0 15.3 0 15.62 0.06C18.57 0.4 20.5 2.64 20.5 5.75V6.63C21.1 6.92 21.5 7.52 21.5 8.22V10.28C21.5 10.98 21.1 11.58 20.5 11.87V12.75C20.5 16.19 18.19 18.5 14.75 18.5V18.51ZM17.67 7.96C17.32 7.96 17 8.09 16.77 8.33C16.48 8.61 16.34 8.99 16.38 9.37C16.43 10.03 17.07 10.56 17.79 10.56H19.73C19.88 10.56 20 10.43 20 10.29V8.23C20 8.09 19.88 7.97 19.73 7.96H17.67Z"
        fill="url(#paint0_linear_32088_1833)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_32088_1833"
          x1="-1.06452e-07"
          y1="10.196"
          x2="21.5"
          y2="10.196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72717" />
          <stop offset="1" stopColor="#FF007D" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function HelpCardBudget() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-help-card-budget"
    >
      <path
        d="M9.50159 14.1104V16.1404C9.50159 17.8604 7.90158 19.2504 5.93158 19.2504C3.96158 19.2504 2.35156 17.8604 2.35156 16.1404V14.1104M9.50159 14.1104C9.50159 15.8204 7.90158 17.0504 5.93158 17.0504M9.50159 14.1104V11.36C9.50159 10.5 9.10161 9.71997 8.46161 9.15997C7.81161 8.59997 6.92158 8.25 5.93158 8.25C3.95158 8.25 2.35156 9.63999 2.35156 11.36V14.1104M9.50159 14.1104C9.50159 15.8304 7.90158 17.0504 5.93158 17.0504M2.35156 14.1104C2.35156 15.8304 3.95158 17.0504 5.93158 17.0504M2.35156 14.1104C2.35156 15.8204 3.96158 17.0504 5.93158 17.0504M19.75 11.3C20.31 11.28 20.75 10.83 20.75 10.28V8.21997C20.75 7.66997 20.31 7.22001 19.75 7.20001M19.75 11.3H17.79C16.71 11.3 15.72 10.51 15.63 9.42999C15.57 8.79999 15.81 8.20999 16.23 7.79999C16.6 7.41999 17.11 7.20001 17.67 7.20001H19.75M19.75 11.3L19.75 12.75C19.75 15.75 17.75 17.75 14.75 17.75H12.25M19.75 7.20001L19.75 5.75C19.75 3.01 18.08 1.09999 15.5 0.799988C15.26 0.759988 15.01 0.75 14.75 0.75H5.75C5.47 0.75 5.2 0.769998 4.94 0.809998C2.39 1.13 0.75 3.03 0.75 5.75V7.75M9.5 11.36C9.5 11.86 9.36 12.32 9.12 12.72C8.53 13.69 7.31998 14.3 5.91998 14.3C4.51998 14.3 3.30997 13.68 2.71997 12.72C2.47997 12.32 2.34003 11.86 2.34003 11.36C2.34003 10.5 2.74 9.72998 3.38 9.16998C4.03 8.59998 4.91997 8.26001 5.90997 8.26001C6.89997 8.26001 7.79 8.60998 8.44 9.16998C9.1 9.71998 9.5 10.5 9.5 11.36Z"
        stroke="url(#paint0_linear_32527_7375)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_32527_7375"
          x1="0.75"
          y1="10.1815"
          x2="20.75"
          y2="10.1815"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72717" />
          <stop offset="1" stopColor="#FF007D" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function HelpCardAccount() {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-help-card-account"
    >
      <path
        d="M8.75 10.75C11.5114 10.75 13.75 8.51142 13.75 5.75C13.75 2.98858 11.5114 0.75 8.75 0.75C5.98858 0.75 3.75 2.98858 3.75 5.75C3.75 8.51142 5.98858 10.75 8.75 10.75Z"
        stroke="url(#paint0_linear_32527_138)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.75 17.8333C16.75 19.6176 13.3214 20.75 8.75 20.75C4.17857 20.75 0.75 19.6176 0.75 17.8333C0.75 15.2308 4.75 13.75 8.75 13.75C12.75 13.75 16.75 15.5 16.75 17.8333Z"
        stroke="url(#paint1_linear_32527_138)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_32527_138"
          x1="0.75"
          y1="10.946"
          x2="16.75"
          y2="10.946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72717" />
          <stop offset="1" stopColor="#FF007D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_32527_138"
          x1="0.75"
          y1="10.946"
          x2="16.75"
          y2="10.946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72717" />
          <stop offset="1" stopColor="#FF007D" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function HelpCardSpecialEvents() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-help-card-special-events"
    >
      <path
        d="M5.75 0.75V3.75M13.75 0.75V3.75M1.25 7.84H18.25M13.4447 12.45H13.4537M13.4447 15.45H13.4537M9.74548 12.45H9.75447M9.74548 15.45H9.75447M6.04431 12.45H6.05329M6.04431 15.45H6.05329M18.75 7.25V15.75C18.75 18.75 17.25 20.75 13.75 20.75H5.75C2.25 20.75 0.75 18.75 0.75 15.75V7.25C0.75 4.25 2.25 2.25 5.75 2.25H13.75C17.25 2.25 18.75 4.25 18.75 7.25Z"
        stroke="url(#paint0_linear_32527_4585)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_32527_4585"
          x1="0.75"
          y1="10.946"
          x2="18.75"
          y2="10.946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72717" />
          <stop offset="1" stopColor="#FF007D" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function HelpCardVouchers() {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-help-card-vouchers"
    >
      <path
        d="M7.75 11.5L13.75 5.5M13.7445 11.5H13.7535M7.74451 6H7.75349M18.25 9.25C18.25 7.87 19.37 6.75 20.75 6.75V5.75C20.75 1.75 19.75 0.75 15.75 0.75H5.75C1.75 0.75 0.75 1.75 0.75 5.75V6.25C2.13 6.25 3.25 7.37 3.25 8.75C3.25 10.13 2.13 11.25 0.75 11.25V11.75C0.75 15.75 1.75 16.75 5.75 16.75H15.75C19.75 16.75 20.75 15.75 20.75 11.75C19.37 11.75 18.25 10.63 18.25 9.25Z"
        stroke="url(#paint0_linear_32527_11918)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_32527_11918"
          x1="0.75"
          y1="8.90681"
          x2="20.75"
          y2="8.90681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F72717" />
          <stop offset="1" stopColor="#FF007D" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function WeChat() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-wechat"
    >
      <path
        d="M20.9768 12.5883V17.255C20.9768 17.5583 20.9652 17.85 20.9302 18.13C20.6618 21.28 18.8068 22.8433 15.3885 22.8433H14.9218C14.6302 22.8433 14.3502 22.9833 14.1752 23.2167L12.7752 25.0833C12.1568 25.9117 11.1535 25.9117 10.5352 25.0833L9.13515 23.2167C8.98348 23.0183 8.64517 22.8433 8.3885 22.8433H7.92184C4.20017 22.8433 2.3335 21.9217 2.3335 17.255V12.5883C2.3335 9.17001 3.90851 7.31501 7.04684 7.04668C7.32684 7.01168 7.61851 7 7.92184 7H15.3885C19.1102 7 20.9768 8.86668 20.9768 12.5883Z"
        stroke="url(#paint0_linear_13690_49612)"
        strokeWidth="1.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6435 7.92233V12.589C25.6435 16.019 24.0685 17.8623 20.9302 18.1307C20.9652 17.8507 20.9769 17.559 20.9769 17.2557V12.589C20.9769 8.86733 19.1102 7.00065 15.3885 7.00065H7.92188C7.61854 7.00065 7.32688 7.01233 7.04688 7.04733C7.31521 3.90899 9.17021 2.33398 12.5885 2.33398H20.0552C23.7769 2.33398 25.6435 4.20066 25.6435 7.92233Z"
        stroke="url(#paint1_linear_13690_49612)"
        strokeWidth="1.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7446 15.4583H15.7551"
        stroke="url(#paint2_linear_13690_49612)"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6616 15.4583H11.6721"
        stroke="url(#paint3_linear_13690_49612)"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.57808 15.4583H7.58858"
        stroke="url(#paint4_linear_13690_49612)"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13690_49612"
          x1="7.09791"
          y1="21.0284"
          x2="16.9039"
          y2="9.01476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13690_49612"
          x1="11.7994"
          y1="14.1815"
          x2="19.7062"
          y2="2.74005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13690_49612"
          x1="15.4647"
          y1="15.75"
          x2="16.0759"
          y2="14.9987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_13690_49612"
          x1="11.3816"
          y1="15.75"
          x2="11.9929"
          y2="14.9987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_13690_49612"
          x1="7.29815"
          y1="15.75"
          x2="7.90937"
          y2="14.9987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
      </defs>
    </svg>
  );
}

// Microillustrations ****************************************************************************************************************

function Dislike() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-dislike"
    >
      <g clipPath="url(#clip0_2595_54572)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.44 1.78074C15.864 1.50568 15.2338 1.36277 14.5954 1.36245L5.43086 1.36245C4.40891 1.36246 3.42059 1.72766 2.64418 2.39216C1.86777 3.05667 1.35436 3.97675 1.19657 4.98645L0.123432 11.8487C0.0466748 12.338 0.0768072 12.838 0.211758 13.3145C0.346709 13.791 0.583271 14.2325 0.905175 14.6089C1.22708 14.9852 1.62668 15.2873 2.07649 15.4944C2.5263 15.7015 3.01565 15.8088 3.51086 15.8087L9.13886 15.8087L9.13886 19.8493C9.13805 20.4663 9.34212 21.0662 9.71905 21.5547C10.096 22.0432 10.6244 22.3927 11.2215 22.5485C11.8185 22.7042 12.4504 22.6573 13.0179 22.4152C13.5854 22.173 14.0565 21.7493 14.3571 21.2105L17.9177 14.8505C18.1326 14.4665 18.2453 14.0339 18.2451 13.5939L18.2451 4.26474C18.2452 3.77907 18.1078 3.30332 17.8487 2.89254C17.5896 2.48176 17.2195 2.15275 16.7811 1.94359L16.4383 1.78074L16.44 1.78074ZM22.2103 14.535C22.4347 14.5352 22.6569 14.4912 22.8642 14.4055C23.0716 14.3198 23.26 14.1941 23.4187 14.0355C23.5775 13.877 23.7034 13.6887 23.7893 13.4814C23.8752 13.2741 23.9194 13.052 23.9194 12.8276L23.9194 4.06416C23.9194 3.61087 23.7394 3.17614 23.4188 2.85562C23.0983 2.53509 22.6636 2.35502 22.2103 2.35502L21.36 2.35502C21.1327 2.35502 20.9147 2.44533 20.7539 2.60607C20.5932 2.76682 20.5029 2.98484 20.5029 3.21216L20.5029 13.6796C20.5029 13.9069 20.5932 14.1249 20.7539 14.2857C20.9147 14.4464 21.1327 14.5367 21.36 14.5367L22.2103 14.5367L22.2103 14.535Z"
          fill="#FF5447"
        />
      </g>
      <defs>
        <clipPath id="clip0_2595_54572">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(24 24) rotate(180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function HelpRed() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-help"
    >
      <g clipPath="url(#clip0_1545_34587)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.9888 0.262941C45.928 0.261246 51.7921 1.59091 57.1498 4.15415C62.5074 6.71739 67.2224 10.449 70.9478 15.0745C74.6733 19.7001 77.3145 25.1019 78.6772 30.8827C80.0399 36.6635 80.0895 42.6762 78.8222 48.4787C77.555 54.2812 75.0032 59.7258 71.3545 64.4121C67.7058 69.0984 63.053 72.9072 57.7383 75.5585C52.4236 78.2097 46.5823 79.6358 40.6438 79.732C34.7053 79.8282 28.8208 78.592 23.4231 76.1144L3.61736 79.6972C3.12068 79.7859 2.60937 79.7416 2.1354 79.5686C1.66144 79.3956 1.24173 79.1002 0.918961 78.7124C0.596189 78.3246 0.381862 77.8583 0.297774 77.3608C0.213685 76.8633 0.262833 76.3524 0.440221 75.8801L6.12022 60.7601C2.43077 54.7384 0.412733 47.8423 0.27384 40.7816C0.134948 33.7209 1.88022 26.7508 5.33 20.5887C8.77978 14.4266 13.8094 9.29513 19.9012 5.7226C25.993 2.15007 32.9267 0.265519 39.9888 0.262941ZM37.8231 25.4001C38.5995 25.0802 39.4372 24.9364 40.2759 24.9788C41.1146 25.0212 41.9334 25.2489 42.6737 25.6455C43.4139 26.042 44.0571 26.5976 44.557 27.2724C45.0569 27.9471 45.4012 28.7242 45.5651 29.5478C45.7289 30.3714 45.7083 31.2211 45.5047 32.0358C45.3011 32.8505 44.9196 33.61 44.3875 34.2597C43.8554 34.9093 43.1861 35.4331 42.4275 35.7933C41.6689 36.1535 40.84 36.3412 40.0002 36.3429C39.053 36.3429 38.1446 36.7192 37.4748 37.389C36.8051 38.0588 36.4288 38.9672 36.4288 39.9144V46.0858C36.4288 47.033 36.8051 47.9414 37.4748 48.6112C38.1446 49.281 39.053 49.6572 40.0002 49.6572C40.9474 49.6572 41.8558 49.281 42.5256 48.6112C43.1954 47.9414 43.5717 47.033 43.5717 46.0858V42.9715C45.8606 42.3081 47.9195 41.0201 49.5174 39.2521C51.1154 37.4841 52.1893 35.306 52.6188 32.9618C53.0482 30.6177 52.8162 28.2003 51.9488 25.9806C51.0813 23.7609 49.6127 21.8268 47.7076 20.395C45.8026 18.9632 43.5363 18.0903 41.163 17.8743C38.7896 17.6583 36.4031 18.1077 34.2708 19.172C32.1385 20.2364 30.3449 21.8736 29.091 23.9002C27.8371 25.9268 27.1725 28.2627 27.1716 30.6458C27.1716 31.593 27.5479 32.5014 28.2177 33.1712C28.8875 33.841 29.7959 34.2172 30.7431 34.2172C31.6903 34.2172 32.5987 33.841 33.2685 33.1712C33.9382 32.5014 34.3145 31.593 34.3145 30.6458C34.3147 29.5217 34.6481 28.4228 35.2726 27.4881C35.8971 26.5534 36.7846 25.8248 37.8231 25.3944V25.4001ZM40.0002 65.0858C38.6438 65.0843 37.3436 64.544 36.3855 63.5838C35.4275 62.6236 34.8901 61.3222 34.8917 59.9658C34.8932 58.6094 35.4334 57.3092 36.3936 56.3511C37.3538 55.3931 38.6553 54.8557 40.0117 54.8572H40.0231C41.3795 54.8587 42.6797 55.399 43.6378 56.3592C44.5958 57.3194 45.1332 58.6208 45.1316 59.9772C45.1301 61.3336 44.5899 62.6339 43.6297 63.5919C42.6695 64.5499 41.368 65.0873 40.0117 65.0858H40.0002Z"
          fill="url(#paint0_linear_1545_34587)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1545_34587"
          x1="39.9975"
          y1="0.262939"
          x2="39.9975"
          y2="79.7417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF220E" />
          <stop offset="1" stopColor="#F02959" />
        </linearGradient>
        <clipPath id="clip0_1545_34587">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function WarningRed() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-warning"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.892 3.89122C51.5343 1.32798 45.6702 -0.00169188 39.731 1.61562e-06C32.6689 0.0025809 25.7351 1.88713 19.6434 5.45966C13.5516 9.03219 8.52197 14.1636 5.07219 20.3257C1.62241 26.4878 -0.122865 33.458 0.0160276 40.5187C0.15492 47.5794 2.17296 54.4755 5.86241 60.4972L0.182409 75.6171C0.00502074 76.0895 -0.0441276 76.6004 0.039961 77.0978C0.12405 77.5953 0.338376 78.0617 0.661148 78.4495C0.98392 78.8373 1.40363 79.1327 1.87759 79.3056C2.35155 79.4786 2.86287 79.523 3.35955 79.4343L23.1653 75.8514C28.563 78.3291 34.4475 79.5653 40.386 79.4691C46.3245 79.3729 52.1658 77.9467 57.4805 75.2955C62.7952 72.6443 67.448 68.8355 71.0966 64.1492C74.7454 59.4629 77.2972 54.0182 78.5644 48.2158C79.8316 42.4133 79.7821 36.4005 78.4194 30.6198C77.0566 24.839 74.4154 19.4371 70.69 14.8116C66.9645 10.1861 62.2496 6.45446 56.892 3.89122ZM36.168 62.0304C37.1494 63.0117 38.3227 63.5024 39.688 63.5024C41.0534 63.5024 42.2267 63.0117 43.208 62.0304C44.1894 61.049 44.68 59.8757 44.68 58.5104C44.68 57.145 44.1894 55.9717 43.208 54.9904C42.2267 54.009 41.0534 53.5184 39.688 53.5184C38.3227 53.5184 37.1494 54.009 36.168 54.9904C35.1867 55.9717 34.696 57.145 34.696 58.5104C34.696 59.8757 35.1867 61.049 36.168 62.0304ZM36.36 17.5504C35.5067 18.3184 35.08 19.385 35.08 20.7504V45.3904C35.08 46.7557 35.5067 47.8224 36.36 48.5904C37.256 49.3584 38.3654 49.7424 39.688 49.7424C40.968 49.7424 42.056 49.3584 42.952 48.5904C43.848 47.7797 44.296 46.713 44.296 45.3904V20.7504C44.296 19.4277 43.848 18.3824 42.952 17.6144C42.056 16.8037 40.968 16.3984 39.688 16.3984C38.3654 16.3984 37.256 16.7824 36.36 17.5504Z"
        fill="url(#paint0_linear_16154_121142)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16154_121142"
          x1="39.7397"
          y1="0"
          x2="39.7397"
          y2="79.4788"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF220E" />
          <stop offset="1" stopColor="#F02959" />
        </linearGradient>
      </defs>
    </svg>
  );
}
function CashbackToApply() {
  return (
    <svg
      width="36"
      height="48"
      viewBox="0 0 36 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="48" rx="8" fill="#E5F0FE" />
      <path
        d="M10.1704 27.3002L14.7004 31.8302C16.5604 33.6902 19.5804 33.6902 21.4504 31.8302L25.8404 27.4402C27.7004 25.5802 27.7004 22.5602 25.8404 20.6903L21.3004 16.1703C20.3504 15.2203 19.0404 14.7103 17.7004 14.7803L12.7004 15.0203C10.7004 15.1103 9.11038 16.7003 9.01038 18.6903L8.77038 23.6902C8.71038 25.0402 9.22038 26.3502 10.1704 27.3002Z"
        stroke="#0067F0"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5005 24.0002C16.8812 24.0002 18.0005 22.8809 18.0005 21.5002C18.0005 20.1195 16.8812 19.0002 15.5005 19.0002C14.1198 19.0002 13.0005 20.1195 13.0005 21.5002C13.0005 22.8809 14.1198 24.0002 15.5005 24.0002Z"
        stroke="#0067F0"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function CashbackApplyed() {
  return (
    <svg
      width="36"
      height="48"
      viewBox="0 0 36 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="48" rx="8" fill="#E5F0FE" />
      <path
        d="M13.75 23.9998L16.58 26.8298L22.25 21.1698M18 33.9998C23.5 33.9998 28 29.4998 28 23.9998C28 18.4998 23.5 13.9998 18 13.9998C12.5 13.9998 8 18.4998 8 23.9998C8 29.4998 12.5 33.9998 18 33.9998Z"
        stroke="#0067F0"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ApplyCashback() {
  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="101.0079"
      height="107.4321"
      viewBox="0 0 101.0079 107.4321"
    >
      <defs>
        <style>
          {`
            .cls-1 { fill: #f53635; }
            .cls-2 { fill: #dbe4ef; }
            .cls-3 { fill: url(#linear-gradient-2); }
            .cls-4 { fill: #afc3d8; }
            .cls-5 { fill: #cad6e7; }
            .cls-6 { fill: #98adca; }
            .cls-7 { fill: #d4deec; }
            .cls-8 { fill: #8ba1c1; }
            .cls-9 { fill: #f92e4a; }
            .cls-10 { fill: #fa2a65; }
            .cls-11 { fill: #f0f5fd; }
            .cls-12 { fill: #bb2a33; }
            .cls-13 { fill: url(#linear-gradient); }
          `}
        </style>
        <linearGradient
          id="linear-gradient"
          x1="71.7528"
          y1="40.8528"
          x2="74.2493"
          y2="101.1533"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#b7c7df" />
          <stop offset="1" stopColor="#99abce" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="41.7701"
          y1="43.8514"
          x2="60.4399"
          y2="12.4748"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".0811" stopColor="#f92e4a" />
          <stop offset="1" stopColor="#fa2a65" />
        </linearGradient>
      </defs>
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path
            className="cls-11"
            d="M47.9897,7.7753c.4464.7545,2.2046,2.5598,3.023,2.8346,1.9904.6683,2.3845-1.1641,2.3638-2.7l5.1175.5387c.2946,1.0198,1.1418,1.5391,2.1919,1.3155.3629-.0773.7254-.4936,1.0402-.5074.3353-.0147,1.805.4986,2.2579.6375,1.0583.3246,2.0948.7251,3.1289,1.1132-2.9745,2.5907-3.8457,6.9432,1.72,5.1541,1.1436-.3676,3.2973-1.5518,4.2055-2.3261,16.399,9.3181,25.7236,27.6471,23.5506,46.512-1.2185,10.578-6.5511,21.4954-14.391,28.7042-.1662.1528-.2769.3371-.5407.3341-.0085-.2754-.1239-.5327-.1347-.808-.0035-.0895.0027-.1797,0-.2693-.2138-7.2296-.5135-14.4581-.808-21.682-.386-9.4696-.774-18.963-1.3467-28.4155-.0278-.1445-.221-.2037-.2693-.2693-.0793-.1079-.0205-.2585-.2709-.4667-.8338-.6936-7.7015-2.1094-9.2627-2.4565-.4059-.0902-.8197-.1899-1.2401-.1743-.2157-.7018-.6815-1.6457-.9427-2.4241-.8945-2.6656-1.8985-5.2993-2.8281-7.9456-1.5493-4.4106-2.2-7.2001-6.6431-9.7194-5.9534-3.3757-9.7734-1.2057-15.4429.6964-3.0132,1.0109-6.0751,1.9293-9.0229,3.0974-2.8246,1.1194-4.1719,2.0429-5.9255,4.5788-1.7999,2.6029-2.4355,5.1563-2.0201,8.3496.0221.17-.0294.3787,0,.5387-.7011.1269-1.3343.5455-1.99.7708-1.5492.5323-4.137.8185-5.4182,1.45-.3312.1632-.7127.445-.7969.8191-.6766,14.9964-1.2208,29.971-1.755,44.9757-.0792,2.2259-.3618,4.4218-.2749,6.6606-.344-.1252-.7672-.6577-1.0119-.9407C3.8969,73.7769.1738,57.5886,4.3948,42.2219,9.7629,22.6788,27.6323,8.3885,47.9897,7.7753Z"
          />
          <path
            className="cls-11"
            d="M20.5169,91.6751c9.6263,3.4179,19.4891,6.2863,29.1142,9.7377l.9173.4973c-2.8681,0-5.5376-.1261-8.3754-.5802-7.8284-1.2527-15.5164-4.6886-21.6562-9.6547Z"
          />
          <path
            className="cls-13"
            d="M67.6517,46.7127s1.886-6.5679,6.3295-7.8039,4.9939-1.2718,4.9939-1.2718l.372.5179.5834,10.4256.9092,21.1089,1.0988,25.6628-12.9401,11.81-2.5529-2.9764,1.2062-57.4732Z"
          />
          <path
            className="cls-10"
            d="M61.7262,9.2567c-.3147.0138-.6773.4302-1.0402.5074-1.0501.2237-1.8973-.2957-2.1919-1.3155-.5255-1.8191.3706-5.1054,1.2287-6.7842.9013-1.7632,2.2659-2.0422,4.0229-1.2282,1.8424.8536,1.6218,2.2339,1.0457,3.8727-.6475,1.8418-1.7352,3.5355-3.0652,4.9477Z"
          />
          <path
            className="cls-10"
            d="M53.3766,7.91c.0207,1.5358-.3734,3.3682-2.3638,2.7-.8184-.2748-2.5766-2.0802-3.023-2.8346-.0347-.0586-.0102-.3233-.105-.4946-1.0038-1.8146-2.5148-4.4383-.0709-5.8088.9958-.5584,2.3125-.8853,3.2657-.0859,1.2283,1.03,2.2756,4.9319,2.297,6.5239Z"
          />
          <path
            className="cls-10"
            d="M73.0385,13.8355c-.9082.7743-3.0619,1.9584-4.2055,2.3261-5.5657,1.7891-4.6945-2.5635-1.72-5.1541.5591-.4869,2.48-1.8211,3.1364-2.0481,1.3835-.4785,2.4778.0819,3.2233,1.2772.8293,1.3296.8186,2.5309-.4342,3.599Z"
          />
          <path
            className="cls-11"
            d="M1.0374,26.9854c-3.1484-2.9947,1.5795-7.9275,4.7378-4.6704,2.9457,3.0379-1.6126,7.6429-4.7378,4.6704Z"
          />
          <path
            className="cls-11"
            d="M93.606,101.6713c3.6354-.7481,4.4474,4.5009,1.1503,5.0543-3.5088.5889-4.0202-4.4637-1.1503-5.0543Z"
          />
          <path
            className="cls-11"
            d="M7.2883,14.6696c2.0157-.2721,3.076,2.4282,1.338,3.5031-2.7629,1.7086-4.2087-3.1155-1.338-3.5031Z"
          />
          <path
            className="cls-11"
            d="M97.7291,97.2425c1.9691-1.9688,4.8003,1.5581,2.2907,3.0314-1.9319,1.1342-3.851-1.4713-2.2907-3.0314Z"
          />
          <path
            className="cls-6"
            d="M29.9439,53.0246c-.4163.1219-.7421.0685-1.0774.1347-.2108.0416-.2643.0897-.404.1347-.1399.0451-.2805-.0484-.469.1324-.3998.3834-1.2175,3.1026-1.3559,3.7662-.8946,4.2907-.2582,9.286,1.9596,13.0699,2.0897,3.5654,5.6857,6.0193,9.7208,6.911,2.0765.4589,3.6459.6426,5.3623-.7161.5161-.4085.5265-.3455.9427-.9427,2.9682-4.259,2.8336-11.2253,4.7828-16.1584.1644-.4162.9465-1.7525.9729-1.9709.0356-.2952-.2518-.8417-.2375-1.3231.0741-2.5102,1.9733-3.3279,4.1781-2.6335.825.2598,2.2424,2.1789,2.3921,3.0622.1799,1.0611-.002,2.694-1.0454,3.2673-.4432.2435-1.0215.2102-1.4814.2693-.007-.3757.1336-.8931-.3411-.9508-1.39-.169-2.5124,3.254-2.8524,4.2889-1.3416,4.0839-2.6656,9.3646-4.9654,12.9458-1.1862,1.8471-2.5535,2.8302-4.4388,3.9107-.3029.2932-.3715.6711-.3306,1.0835-3.5986.0703-7.2871-1.4015-10.3061-3.2283-.6394-.3869-.9358-.7802-1.6796-1.0812-.0857-.4999-.3189-.3449-.5387-.5387-5.1233-4.5177-6.7999-11.4455-6.0602-18.0459.4171-.08.2287.2055.2854.4484.1701.7289.1853,1.4295.3383,2.0925.1165.5045.3978,1.1676.9907.8934.8408-.3889.6045-2.8971.7095-3.7365.1114-.8912,1.3193-3.9761,1.1611-4.4544-.4345-1.3134-2.2796,1.3253-2.8117,1.3897.2147-.7682.3195-1.3479.6499-2.1108.221-.5102,1.4401-2.388,1.467-2.5545.0433-.268-.1364-.9919-.0947-1.4611.2477-2.7893,3.115-3.0141,4.8497-1.217,1.3356,1.3836,1.9917,4.6603-.2732,5.3233ZM50.1431,62.3175c-.5066-.3568-1.6133,2.3007-1.6881,2.6868-.0954.4931-.2223,1.746.4302,1.8695,1.1909.2253,1.6337-3.8132,1.2579-4.5563ZM28.1934,73.495c-.3028.3053.7122,1.6624.9465,1.9483,1.1823,1.4427,2.6897,2.6047,4.5447,2.9968.5114.1081,3.1701.4548,1.9095-.5629-.5593-.4516-1.8139-.8032-2.5421-1.2286-1.0624-.6206-3.4459-2.9372-4.2846-3.1226-.1905-.0421-.3817-.0425-.5741-.031Z"
          />
          <path
            className="cls-8"
            d="M54.1846,60.0275c-.2468.0318-.5264-.0901-.7448.1307-.0462.0467-.5079,1.0405-.5624,1.1882-1.8414,4.9903-1.6459,11.6428-4.753,16.1883-.4957.7253-2.1881,2.2756-2.9628,2.6934-.9673.5218-2.8174,1.0561-3.9054,1.0774-.0409-.4124.0277-.7903.3306-1.0835,1.8854-1.0805,3.2527-2.0636,4.4388-3.9107,2.2998-3.5812,3.6238-8.8619,4.9654-12.9458.34-1.0348,1.4623-4.4579,2.8524-4.2889.4747.0577.3341.5751.3411.9508Z"
          />
          <path
            className="cls-3"
            d="M68.9984,38.6149c-.0401-.8909-.1672-2.1052-.404-2.9628-.0477-.1728-.1892-.5474-.2693-.808-.2157-.7018-.6815-1.6457-.9427-2.4241-.8945-2.6656-1.8985-5.2993-2.8281-7.9456-1.5493-4.4106-2.2-7.2-6.6431-9.7194-5.9534-3.3757-9.7734-1.2057-15.4429.6964-3.0132,1.0109-6.0751,1.9293-9.0229,3.0974-2.8246,1.1194-4.1719,2.0429-5.9255,4.5788-1.7999,2.6029-2.4355,5.1563-2.0201,8.3496.0221.17-.0294.3787,0,.5387.1078.5862.4942,1.5842.7074,2.188.4998,1.4154,1.2075,2.7655,1.7081,4.1821.0833.104,1.6123.6718,1.894.7674,3.3495,1.1369,6.8546,1.9169,10.235,2.9628-.2063-.7887-.5886-1.503-.808-2.2894-.0116-.0415.0107-.0924,0-.1347-.0919-.0369-.1765-.1022-.2693-.1347-1.357-.4743-1.2118-.8356-1.7507-1.8854-.7527-1.4661-2.0585-3.6213-.0476-4.8279.6778-.4067.5841.073.8556-.6936.2666-.7527.7597-1.9184,1.3467-2.4241.3346-.2883.604-.5242,1.0828-.4802.3611.0332,3.0301,1.2241,3.092,1.4229.4502-.0085.6224-.967.808-1.3467.3102-.6346.7061-1.6593,1.3467-1.8854.5512-.1945.6947-.1361,1.212,0,.6561.1727,2.1719.8362,2.4241,1.4814.0504-.0422,1.1417-.2658,1.2859-.274.3146-.0178.5757.0555.8688.1393.8027.2296,1.2823.8732,1.616,1.616.0956.2129.2185.578.2693.808.8666.2288,1.0046,1.8847.9409,2.6254-.033.384-.2187.7354-.2543,1.0933-.1148,1.1523.8294,2.8035,1.1988,3.9576.2325.7261.6411,1.9359.7933,2.6408.343,1.5881.1019,2.9417-1.332,3.8234,2.7695.5548,5.4943,1.1563,8.3496,1.4814,1.3267.1511,2.034.2081,3.3668.1347.3996-.63.8625-1.2228,1.212-1.8854,1.0968-2.0789,1.4526-4.1135,1.3467-6.4642Z"
          />
          <path
            className="cls-12"
            d="M38.6975,38.3455c-.0379.2088.0897.372.1347.5387.0598.2215.1271.441.1347.6734-1.357-.4743-1.2118-.8356-1.7507-1.8854.4931.3302.9193.5,1.4814.6734Z"
          />
          <path
            className="cls-2"
            d="M39.2362,39.8269c.3456-.0722.2765.1661.3655.3684.1132.257.778,1.8423.7111,1.9201l-.2687.0009c-.2063-.7887-.5886-1.503-.808-2.2894Z"
          />
          <path
            className="cls-2"
            d="M38.8321,38.8842c.473-.0823.333.5274.404.808-.0919-.0369-.1765-.1022-.2693-.1347-.0076-.2323-.0749-.4519-.1347-.6734Z"
          />
          <path
            className="cls-5"
            d="M43.5456,30.6693c.0406.1306.1165.996-.1856.9284-.9519-.2128-2.2358-1.3064-3.0437-1.5469-.4851-.1444-1.072.4183-.9455-.3242.3346-.2883.604-.5242,1.0828-.4802.3611.0332,3.0301,1.2241,3.092,1.4229Z"
          />
          <path
            className="cls-1"
            d="M52.1645,36.3255c.1334.3566.2739.7222.404,1.0774.3811,1.0404,1.5673,3.875,1.0623,4.7656-.5172.9119-4.1562,1.2996-5.1024,1.9679-2.2343-.4237-4.4168-.9828-6.5989-1.616-.3177-.9302-.6028-1.9088-.9427-2.8281.3578-1.0076,1.1738-.8568,2.0201-1.0774.2467.6104.6214,1.5619.9145,2.1154.1133.2138.5731.6045.5668.7127-.0025.0421-.2024.1692-.1194.4368.0762.2459.7568.82,1.0229.8811,1.5243.3502,1.5924-.5456,2.4851-.8248.8873-.2776,1.7335.2187,2.5305-.567,1.3931-1.3733-.6377-3.3887-.2396-4.5501.1852-.5403,1.5033-.6778,1.9969-.4935Z"
          />
          <path
            className="cls-12"
            d="M55.262,38.8842c.2325.7261.6411,1.9359.7933,2.6408.343,1.5881.1019,2.9417-1.332,3.8234-.8149-.1632-2.2108-.0471-2.9628-.5387.7086-.2183,1.4677-.4002,2.1176-.7712.3456-.1973.7607-.6915.9798-.9795.5684-.7475.633-1.1648.5387-2.1547-.0447-.4695-.2545-1.0906-.399-1.5537-.5787-1.8544-1.5109-3.6937-2.0251-5.5838.1427-.1375.5053-.8672.5387-1.0774.0777-.4889-.0295-1.0053-.1347-1.4814.8666.2288,1.0046,1.8847.9409,2.6254-.033.384-.2187.7354-.2543,1.0933-.1148,1.1523.8294,2.8035,1.1988,3.9576Z"
          />
          <path
            className="cls-7"
            d="M28.7318,76.4573c-.1074.5397.1989.4012.5387.5387-.0857-.4999-.3189-.3449-.5387-.5387Z"
          />
          <path
            className="cls-4"
            d="M26.1567,53.6549c-.4345-1.3134-2.2796,1.3253-2.8117,1.3897-.3597,1.2871-.5226,2.0216-.6734,3.3668.4171-.08.2287.2055.2854.4484.1701.7289.1853,1.4295.3383,2.0925.1165.5045.3979,1.1676.9907.8934.8408-.3889.6045-2.8971.7095-3.7365.1114-.8912,1.3193-3.9761,1.1611-4.4544Z"
          />
          <path
            className="cls-7"
            d="M78.8278,37.4748c-.8337-.6936-7.7014-2.1094-9.2627-2.4565-.4059-.0901-.8196-.1898-1.24-.1742.0801.2606.2216.6351.2693.808.2368.8577.3639,2.072.4041,2.9629.1057,2.3506-.25,4.3853-1.3467,6.4641-.3496.6626-.8125,1.2554-1.2122,1.8854-1.3326.0735-2.04.0164-3.3667-.1346-2.8553-.3251-5.5801-.9266-8.3496-1.4814-.8149-.1632-2.2107-.0471-2.9628-.5386-.1714-.1121-.2753-.1553-.2694-.4041-1.2034.2889-1.8274-.0541-2.9626-.2693-2.2344-.4238-4.4167-.9829-6.5989-1.6162-.325-.0942-.9015-.0398-1.1786-.3032-.493-.4689-1.0706-3.0522-1.6385-3.7881-.1184-.1534-.1978-.0544-.2803-.0834-.0393-.0138-.0931.0128-.1348,0-.0378.2089.0898.3719.1348.5387.473-.0823.333.5273.4041.808.0106.0422-.0117.0931,0,.1346.3455-.0721.2764.1663.3655.3684.1132.2571.778,1.8423.7112,1.9202l-.2687.0009c-3.3804-1.0458-6.8855-1.8258-10.235-2.9628-.2817-.0956-1.8108-.6633-1.894-.7673-.5005-1.4167-1.2083-2.7668-1.708-4.1821-.2133-.6039-.5996-1.6018-.7074-2.188-.701.1268-1.3344.5454-1.99.7708-1.5492.5322-4.1371.8185-5.4182,1.45-.3312.1633-.7128.4449-.7969.8191-.6766,14.9965-1.2208,29.9709-1.755,44.9758-.0792,2.2258-.3618,4.4219-.2749,6.6606.0573,1.475.0723,2.326,1.3435,3.3026.8223.6318,2.8567,1.3066,3.9087,1.6801,9.6262,3.418,19.489,6.2864,29.1143,9.7378l.9172.4973h.6733c4.9717,1.5166,10.0242,3.7585,15.0137,5.1196.5308.1448,1.2882.3909,1.8202.4019.5245.0107.5873-.1519.9427-.2693.0857-.4631-.3723-.58-.5051-.9092-.1804-.4473-.3215-1.6143-.3126-2.1201.3126-17.7673.0905-35.6599.0157-53.4707-.0037-.8702-.3022-2.8621.0714-3.5532.132-.2441.4928-.3893.5682-.6436.3376-1.1377-.1178-1.7109.7009-3.1372.0984-.1711.3677-.4515.4041-.5387.4631-.0446.6622-.5414.9426-.808.3003-.2855.3376-.4263.6735-.5387.1796-.0602.327.1495.2693-.2694.0961-.0415.2141-.1152.2694-.1345-.0667-.5435,1.1438-.3994,1.0774-.9429.0396-.0139.0936.0132.1345,0,.3052-.0977.7756-.033.6735-.4039.042-.0111.0931.0118.1346,0,1.6648-.4725,3.4653-.9663,4.9828-1.7507-.0792-.1078-.0205-.2584-.2709-.4667ZM55.6659,59.7581c-.4431.2435-1.0215.2101-1.4813.2694-.2467.0317-.5264-.0901-.7448.1306-.0463.0466-.5079,1.0405-.5625,1.1882-1.8413,4.9902-1.6459,11.6428-4.7529,16.1882-.4957.7253-2.1881,2.2756-2.9626,2.6935-.9674.5217-2.8175,1.056-3.9055,1.0773-3.5986.0704-7.2871-1.4014-10.3062-3.2283-.6394-.3868-.9358-.7802-1.6796-1.0811-.3398-.1376-.6461.001-.5387-.5388-5.1233-4.5176-6.7998-11.4453-6.0602-18.0458.1508-1.3452.3137-2.0797.6735-3.3668.2146-.7682.3193-1.3479.6499-2.1108.2209-.5103,1.4401-2.3879,1.467-2.5544.0432-.2679-.1365-.9918-.0947-1.4611.2478-2.7894,3.115-3.0142,4.8497-1.2169,1.3356,1.3835,1.9918,4.6602-.2732,5.3232-.4164.1218-.7421.0686-1.0773.1346.0204.1281.0203.2284.0048.2997.0155-.0713.0156-.1716-.0048-.2996-.2109.0415-.2644.0896-.4041.1345-.1399.0452-.2805-.0483-.469.1324-.3999.3834-1.2175,3.1027-1.356,3.7662-.8945,4.2906-.2583,9.2859,1.9596,13.0698,2.0897,3.5654,5.6857,6.0193,9.7208,6.911,2.0765.4589,3.6459.6427,5.3623-.7162.5161-.4084.5265-.3455.9426-.9426,2.9683-4.2589,2.8337-11.2253,4.783-16.1584.1643-.4161.9464-1.7524.9728-1.9709.0356-.2952-.2518-.8416-.2375-1.323.0741-2.5103,1.9734-3.3279,4.1781-2.6335.8251.2598,2.2424,2.179,2.3921,3.0621.1799,1.0612-.002,2.694-1.0454,3.2673ZM28.6901,59.9501c.0369.0801.0508.179.0544.2834-.0035-.1045-.0176-.2034-.0544-.2834Z"
          />
          <path
            className="cls-12"
            d="M51.0872,30.4c.312.3635.5462.7442.6734,1.212l-1.2486.0313c-1.7073,1.095-10.7557,3.0996-11.6058,4.1495-.1623.2005-.1451.4893-.3433.6673-.0515-.1211-.4197-.5126-.5618-.8519-.1216-.2904-.2471-.5755-.2462-.8989.0253-.0221-.02-.2419.2207-.3802.3497-.201,1.3635-.4404,1.8309-.5983,3.1241-1.0559,6.7734-2.3028,9.9352-3.1278.51-.1331.8077-.1955,1.3456-.2031Z"
          />
          <path
            className="cls-9"
            d="M51.7605,31.612c.3202,1.178-.011.9755-.9427,1.4814-.4524-.0276-1.1214.2439-1.5846.3681-1.008.2703-8.2005,2.4122-8.5157,2.7293l-.404.1347c-.404-.0116-.7214.2408-.9427.2693-.2464.0318-.5469-.0092-.808,0-.0142-.0417.0155-.0982,0-.1347.1982-.178.181-.4669.3433-.6673.8501-1.0498,9.8985-3.0545,11.6058-4.1495l1.2486-.0313Z"
          />
          <path
            className="cls-12"
            d="M46.9124,29.1879c.1472.0779.2847.3092.5384.271.1714.2127-1.4523.6069-1.6157.6717l.4051-1.212c.0476-.0428.5579.2088.6723.2693Z"
          />
          <path
            className="cls-12"
            d="M40.3135,30.9386c.2593.1859.6277.2597.8862.3921.102.0522.4319.0511.1913.2799-.0546.0519-1.2615.2581-1.4815.2706.029-.0423.3982-.8917.404-.9427Z"
          />
          <path
            className="cls-7"
            d="M52.7032,33.9014c-.0386.0096-.0883-.0047-.1347,0-.1168.0118-.2897.0143-.404,0-.0618-.0077-.1189-.072-.1347-.1347l.5387-.5387c.017.1289.2588.4123.1347.6734Z"
          />
          <path
            className="cls-7"
            d="M44.421,31.3426c.0874.0449.0874.0898,0,.1347v-.1347Z"
          />
          <path
            className="cls-12"
            d="M51.3565,34.5747c.3247.5152.594,1.1789.808,1.7507-.4936-.1843-1.8117-.0468-1.9969.4935-.398,1.1614,1.6327,3.1769.2396,4.5501-.797.7857-1.6432.2894-2.5305.567-.8927.2793-.9608,1.175-2.4851.8248-.266-.0611-.9467-.6352-1.0229-.8811-.0829-.2676.117-.3947.1194-.4368.6895.2277,1.515.2366,2.0892-.2675.2219-.1948.3935-.714.6992-.7897.6253-.155,1.3962.8759,2.4637-.2894.8691-.9488.4622-1.2729.1347-2.2894-.2736-.8492-.6844-1.6777-.808-2.5587.2911-.0631,2.2023-.5918,2.2894-.6734Z"
          />
          <path
            className="cls-12"
            d="M43.0069,38.6149c-.8462.2206-1.6623.0697-2.0201,1.0774-.1045-.2827-.8506-1.4888-.668-1.7426.3671-.2096,1.9797-.4738,2.1493-.6815.3603.335.3635.9132.5387,1.3467Z"
          />
          <path
            className="cls-12"
            d="M48.1244,37.9415c-1.1422-.6745-3.3592.066-2.4241,1.616-.032.0351-.0047.2453-.1307.3496-.1537.1273-.2451-.0799-.2734-.0802l-1.0716-3.0889c.3836-.1747,3.0039-.8154,3.0917-.9512.4226.6568.5937,1.4254.808,2.1547Z"
          />
          <path
            className="cls-4"
            d="M35.5941,77.8772c-.5593-.4515-1.8139-.8032-2.5421-1.2286-1.0624-.6206-3.4459-2.9372-4.2846-3.1226-.1905-.0421-.3817-.0425-.5741-.031-.3028.3053.7122,1.6624.9465,1.9483,1.1823,1.4427,2.6897,2.6047,4.5447,2.9968.5114.1081,3.1701.4548,1.9095-.5629Z"
          />
          <path
            className="cls-4"
            d="M50.1431,62.3175c-.5066-.3568-1.6133,2.3006-1.6881,2.6868-.0955.4931-.2223,1.746.4302,1.8695,1.1909.2253,1.6337-3.8132,1.2579-4.5563Z"
          />
          <path
            className="cls-5"
            d="M53.3766,31.208c-.0508-.23-.1737-.5952-.2693-.808-.3338-.7429-.8134-1.3865-1.616-1.616-.2932-.0838-.5542-.1571-.8688-.1393-.1442.0082-1.2355.2318-1.2859.274-.2522-.6451-1.768-1.3087-2.4241-1.4814-.5174-.1361-.6609-.1945-1.212,0l-.4033.942c.2704.0448.3555-.2351.6134-.2726.3298-.0479,2.0292.7795,2.3414,1.0213.2314.1792.5074.6873.6269.7162.2447.0592,1.1014-.5177,1.8503-.3608.208.0436.2759.2061.3581.2433-4.6131,1.1434-9.1031,2.7973-13.6493,4.1946-1.0256.5792-.8073,1.6806-.3249,2.5748.4171.7732,1.9357,1.5246,1.4498.0988-.0142-.0417.0155-.0982,0-.1347-.0515-.1211-.4197-.5126-.5618-.8519-.1216-.2904-.2471-.5755-.2463-.8989.0253-.0221-.02-.2419.2207-.3802.3497-.201,1.3635-.4404,1.8309-.5983,3.1241-1.0559,6.7734-2.3028,9.9352-3.1278.51-.1331.8077-.1955,1.3456-.2031.0187-.0003.0656-.1664.2573-.0764.1018.0477.404.374.4767.4871.1514.2353.6707,1.4584.7473,1.7441.0456.17-.027.4688,0,.6734.017.1289.2588.4123.1347.6734.0548-.0137.2347-.1013.2693-.1347.1427-.1375.5053-.8672.5387-1.0774.0777-.4889-.0295-1.0053-.1347-1.4814Z"
          />
          <path
            className="cls-2"
            d="M55.3966,40.9043c-.0447-.4695-.2545-1.0906-.399-1.5537-.5787-1.8544-1.5109-3.6937-2.0251-5.5838-.0347.0334-.2145.121-.2693.1347-.0386.0096-.0883-.0047-.1347,0-.1168.0118-.2897.0143-.404,0-.0618-.0077-.1189-.0719-.1347-.1347l.5387-.5387c-.027-.2046.0456-.5034,0-.6734-.0766-.2856-.5959-1.5087-.7473-1.7441-.0728-.1132-.3749-.4394-.4767-.4871-.1918-.09-.2386.0762-.2573.0764.312.3636.5462.7442.6734,1.212.3202,1.178-.0109.9755-.9427,1.4814-.4524-.0276-1.1214.2439-1.5846.3681-1.008.2703-8.2005,2.4122-8.5157,2.7293l-.404.1347c-.404-.0116-.7214.2408-.9427.2693-.2464.0318-.5469-.0092-.808,0,.4858,1.4257-1.0327.6744-1.4498-.0988-.4824-.8941-.7006-1.9955.3249-2.5748,4.5462-1.3973,9.0362-3.0511,13.6493-4.1946-.0822-.0372-.1501-.1997-.3581-.2433-.7489-.1569-1.6056.42-1.8503.3608-.1195-.0289-.3955-.5369-.6269-.7162-.3121-.2417-2.0115-1.0692-2.3414-1.0213-.2579.0375-.343.3174-.6134.2726l.4033-.942c-.6406.2261-1.0365,1.2508-1.3467,1.8854-.1856.3797-.3579,1.3382-.808,1.3467.0406.1306.1165.996-.1856.9284-.9519-.2128-2.2358-1.3064-3.0437-1.5469-.4851-.1444-1.072.4183-.9455-.3242-.587.5057-1.0801,1.6714-1.3467,2.4241-.2715.7666-.1779.2869-.8556.6936-2.0109,1.2066-.7051,3.3618.0476,4.8279.4931.3302.9193.5,1.4814.6734.0415.0128.0953-.0138.1347,0,.0825.029.1618-.07.2803.0834.568.7358,1.1455,3.3192,1.6386,3.7881.2771.2635.8537.2091,1.1786.3033-.3177-.9302-.6028-1.9088-.9427-2.8281-.1045-.2826-.8506-1.4888-.668-1.7426.3671-.2096,1.9797-.4738,2.1493-.6815.3603.335.3635.9132.5387,1.3467.2467.6104.6214,1.5619.9146,2.1154.1133.2138.5731.6045.5668.7127.6895.2277,1.515.2366,2.0892-.2675.2219-.1948.3935-.714.6992-.7898.6253-.155,1.3962.8759,2.4637-.2894.8691-.9488.4622-1.2729.1347-2.2894-.2736-.8492-.6844-1.6777-.808-2.5587.2911-.0631,2.2023-.5918,2.2894-.6734.3247.5152.594,1.1789.808,1.7507.1334.3566.2739.7222.404,1.0774.3811,1.0404,1.5673,3.875,1.0623,4.7656-.5172.9119-4.1562,1.2996-5.1024,1.9679,1.1352.2153,1.7593.5583,2.9628.2693-.0059.2488.0979.292.2693.404.7086-.2183,1.4677-.4002,2.1176-.7712.3456-.1973.7607-.6915.9798-.9795.5684-.7475.633-1.1648.5387-2.1547ZM46.2401,28.9186c.0476-.0428.5579.2088.6723.2693.1472.0779.2847.3092.5384.271.1714.2127-1.4523.6069-1.6158.6717l.4051-1.212ZM44.421,31.3426c.0874.0449.0874.0898,0,.1347v-.1347ZM40.3135,30.9386c.2593.1859.6277.2597.8862.3921.102.0522.4319.0511.1913.2799-.0545.0519-1.2615.2581-1.4815.2706.029-.0423.3982-.8917.404-.9427ZM48.1244,38.7495c-1.1048-.2148-1.6636-.0274-2.4241.808-.0319.0351-.0047.2453-.1307.3496-.1537.1273-.2451-.0799-.2734-.0802l-1.0716-3.0889c.3836-.1747,3.0039-.8154,3.0917-.9512.4226.6568.5937,1.4254.808,2.1547.0368.1254.0923.2654.1347.404.0601.0211.1186.0746.1347.1347.0206.0772-.0214.1941,0,.2693.0021.0072.0983.0008.1341.0664-.1042.2374-.3377-.0536-.4035-.0664Z"
          />
          <path
            className="cls-1"
            d="M48.1244,37.9415c.0368.1254.0923.2654.1347.404.0179.0588.0787.1079.1347.1347.0206.0772-.0214.1941,0,.2693h-.2693c-1.1048-.2148-1.6636-.0274-2.4241.808-.9351-1.5501,1.2819-2.2905,2.4241-1.616Z"
          />
          <path
            className="cls-12"
            d="M48.3938,38.7495c.002.0072.0983.0008.1341.0664-.1042.2374-.3377-.0536-.4034-.0664h.2693Z"
          />
          <path
            className="cls-12"
            d="M48.3938,38.4802c-.056-.0268-.1167-.0759-.1347-.1347.0601.0211.1186.0746.1347.1347Z"
          />
        </g>
      </g>
    </svg>
  );
}

function Like() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-like"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.55999 22.2193C8.13603 22.4943 8.76623 22.6372 9.40457 22.6376H18.5691C19.5911 22.6375 20.5794 22.2723 21.3558 21.6078C22.1322 20.9433 22.6456 20.0233 22.8034 19.0136L23.8766 12.1513C23.9533 11.662 23.9232 11.162 23.7882 10.6855C23.6533 10.209 23.4167 9.76747 23.0948 9.39115C22.7729 9.01484 22.3733 8.71272 21.9235 8.50559C21.4737 8.29846 20.9844 8.19122 20.4891 8.19126H14.8611V4.15069C14.8619 3.53367 14.6579 2.93384 14.281 2.44532C13.904 1.9568 13.3756 1.60725 12.7785 1.45152C12.1815 1.29578 11.5496 1.34268 10.9821 1.58485C10.4146 1.82701 9.94353 2.25074 9.64285 2.78955L6.08228 9.14955C5.86744 9.5335 5.7547 9.96615 5.75485 10.4061V19.7353C5.75478 20.2209 5.89224 20.6967 6.15133 21.1075C6.41042 21.5182 6.78054 21.8472 7.21885 22.0564L7.56171 22.2193H7.55999ZM1.78971 9.46498C1.56534 9.46475 1.34313 9.50875 1.13578 9.59446C0.928425 9.68016 0.739998 9.80589 0.581267 9.96447C0.422536 10.123 0.296614 10.3113 0.2107 10.5186C0.124787 10.7259 0.0805663 10.948 0.0805664 11.1724V19.9358C0.0805664 20.3891 0.260636 20.8239 0.581163 21.1444C0.901689 21.4649 1.33642 21.645 1.78971 21.645H2.64C2.86732 21.645 3.08534 21.5547 3.24609 21.3939C3.40683 21.2332 3.49714 21.0152 3.49714 20.7878V10.3204C3.49714 10.0931 3.40683 9.87506 3.24609 9.71432C3.08534 9.55357 2.86732 9.46326 2.64 9.46326H1.78971V9.46498Z"
        fill="#0DBA69"
      />
    </svg>
  );
}

function LocationPin() {
  return (
    <svg
      width="45"
      height="60"
      viewBox="0 0 45 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-location"
    >
      <path
        d="M45 22.4832C45 10.0671 34.9254 0 22.5 0C10.0746 0 0 10.0671 0 22.4832C0 34.8993 22.5 60 22.5 60C22.5 60 45 34.8993 45 22.4832Z"
        fill="url(#paint0_linear_3428_58547)"
      />
      <circle cx="22.375" cy="22.25" r="9.375" fill="white" />
      <defs>
        <linearGradient
          id="paint0_linear_3428_58547"
          x1="11.5"
          y1="45"
          x2="43.5"
          y2="15.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1D69" />
          <stop offset="1" stopColor="#F8241E" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function Success() {
  return (
    <svg
      width="85"
      height="84"
      viewBox="0 0 85 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-success"
    >
      <g clipPath="url(#clip0_1424_31938)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.25 0C15.6142 0 10.2091 2.21249 6.22398 6.15076C2.23883 10.089 0 15.4305 0 21L0 63C0 68.5695 2.23883 73.911 6.22398 77.8492C10.2091 81.7875 15.6142 84 21.25 84H63.75C69.3858 84 74.7909 81.7875 78.776 77.8492C82.7612 73.911 85 68.5695 85 63V21C85 15.4305 82.7612 10.089 78.776 6.15076C74.7909 2.21249 69.3858 0 63.75 0H21.25ZM63.7682 31.314C64.5242 30.3807 64.8741 29.1888 64.7409 28.0006C64.6077 26.8124 64.0023 25.7251 63.0579 24.978C62.1134 24.2309 60.9074 23.8851 59.705 24.0168C58.5027 24.1484 57.4024 24.7467 56.6464 25.68L35.1293 52.284L26.5139 45.9C26.0355 45.5454 25.4912 45.2874 24.9119 45.1408C24.3326 44.9941 23.7298 44.9617 23.1378 45.0452C22.5458 45.1288 21.9763 45.3268 21.4618 45.6279C20.9472 45.929 20.4977 46.3272 20.1389 46.8C19.7801 47.2728 19.5191 47.8107 19.3707 48.3832C19.2223 48.9556 19.1894 49.5514 19.274 50.1364C19.3585 50.7214 19.5589 51.2842 19.8636 51.7927C20.1682 52.3012 20.5713 52.7454 21.0496 53.1L33.1925 62.1C34.1387 62.8024 35.3245 63.1132 36.4987 62.9665C37.6728 62.8198 38.743 62.2271 39.4825 61.314L63.7682 31.314Z"
          fill="url(#paint0_linear_1424_31938)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1424_31938"
          x1="42.5"
          y1="0"
          x2="42.5"
          y2="84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF220D" />
          <stop offset="1" stopColor="#F02959" />
        </linearGradient>
        <clipPath id="clip0_1424_31938">
          <rect width="85" height="84" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function ToastError() {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-toast-error"
    >
      <rect width="54" height="54" rx="12" fill="#FFE3E0" />
      <svg x="14" y="14" width="26" height="26" viewBox="0 0 26 26">
        <path
          d="M13 14.2L13 8.2M13.0064 19L12.9957 19M13 0.999998C6.4 0.999997 1 6.4 1 13C1 19.6 6.4 25 13 25C19.6 25 25 19.6 25 13C25 6.4 19.6 0.999999 13 0.999998Z"
          stroke="#CA0E00"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function ToastInfo() {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-toast-info"
    >
      <rect width="54" height="54" rx="12" fill="#E0EAFF" />
      <svg x="14" y="14" width="26" height="26" viewBox="0 0 26 26">
        <path
          d="M13 11.8V17.8M12.9936 7H13.0043M13 25C19.6 25 25 19.6 25 13C25 6.4 19.6 1 13 1C6.4 1 1 6.4 1 13C1 19.6 6.4 25 13 25Z"
          stroke="#0060DF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function ToastShoppingCart() {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-toast-shopping-cart"
    >
      <rect width="54" height="54" rx="12" fill="#E1F4EB" />
      <svg x="16.5" y="16.5" width="21" height="21" viewBox="0 0 21 21">
        <path
          d="M5.84998 16.4521L8.95 18.8521C9.35 19.2521 10.25 19.4521 10.85 19.4521H14.65C15.85 19.4521 17.15 18.5521 17.45 17.3521L19.85 10.0521C20.35 8.65208 19.45 7.45205 17.95 7.45205H13.95C13.35 7.45205 12.85 6.95205 12.95 6.25205L13.45 3.05205C13.65 2.15205 13.05 1.15205 12.15 0.852049C11.35 0.552049 10.35 0.952049 9.95 1.55205L5.84998 7.65205M0.75 16.4521V6.6521C0.75 5.2521 1.35 4.7521 2.75 4.7521H3.75C5.15 4.7521 5.75 5.2521 5.75 6.6521V16.4521C5.75 17.8521 5.15 18.3521 3.75 18.3521H2.75C1.35 18.3521 0.75 17.8521 0.75 16.4521Z"
          stroke="#007840"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function ToastSuccess() {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-toast-success"
    >
      <rect width="54" height="54" rx="12" fill="#E1F4EB" />
      <svg x="16.5" y="16.5" width="21" height="21" viewBox="0 0 21 21">
        <path
          d="M5.84998 16.4521L8.95 18.8521C9.35 19.2521 10.25 19.4521 10.85 19.4521H14.65C15.85 19.4521 17.15 18.5521 17.45 17.3521L19.85 10.0521C20.35 8.65208 19.45 7.45205 17.95 7.45205H13.95C13.35 7.45205 12.85 6.95205 12.95 6.25205L13.45 3.05205C13.65 2.15205 13.05 1.15205 12.15 0.852049C11.35 0.552049 10.35 0.952049 9.95 1.55205L5.84998 7.65205M0.75 16.4521V6.6521C0.75 5.2521 1.35 4.7521 2.75 4.7521H3.75C5.15 4.7521 5.75 5.2521 5.75 6.6521V16.4521C5.75 17.8521 5.15 18.3521 3.75 18.3521H2.75C1.35 18.3521 0.75 17.8521 0.75 16.4521Z"
          stroke="#007840"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function ToastSmart() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-toast-smart"
    >
      <rect width="36" height="36" rx="7" fill="#F0F7FF" />
      <svg x="10.5" y="10.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="url(#paint0_linear_12902_33886)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_12902_33886"
            x1="0.5"
            y1="7.16667"
            x2="13.8333"
            y2="7.16667"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F01A72" />
            <stop offset="1" stopColor="#F5261C" />
          </linearGradient>
        </defs>
      </svg>
    </svg>
  );
}

function VideoPlay() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-video-play"
    >
      <rect
        width="40"
        height="40"
        rx="20"
        fill="url(#paint0_linear_12823_848)"
      />
      <g clipPath="url(#clip0_12823_848)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8458 26.591C17.1961 27.1217 16.2198 26.678 16.1922 25.8396L16.0005 20.0027V14.1226C16.0005 13.271 16.9873 12.7994 17.65 13.3343L24.9405 19.219C25.4411 19.623 25.4433 20.3851 24.9451 20.7921L17.8458 26.591Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_12823_848"
          x1="10.2222"
          y1="30"
          x2="31.1785"
          y2="4.24126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F01A72" />
          <stop offset="1" stopColor="#F5261C" />
        </linearGradient>
        <clipPath id="clip0_12823_848">
          <rect
            width="16"
            height="10"
            fill="white"
            transform="matrix(0 -1 1 0 16.0005 28.0039)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function CardBalanceInfo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-illustration b-illustration-card-balance-info"
    >
      <svg x="0.5" y="0.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="black"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

// Social media **********************************************************************************************************************

function Fb() {
  return (
    <svg
      width="11"
      height="21"
      viewBox="0 0 11 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-social b-icon-fb b-icon-main"
    >
      <path
        d="M9.25903 3.77678H11V0H8.38161C4.66877 0 2.90932 2.1989 2.90932 5.33165V8.2988H0V11.8824H2.9047V20.9954H7.26406V11.8824H10.1734L11 8.2988H7.26868V5.85148C7.26868 4.84863 7.81822 3.76758 9.26364 3.76758L9.25903 3.77678Z"
        fill="#0F172A"
      />
    </svg>
  );
}

function In() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-social b-icon-in b-icon-main"
    >
      <path
        d="M4.44379 2.22482C4.44379 3.44848 3.66511 4.44379 2.22482 4.44379C0.88993 4.44379 0 3.44262 0 2.33607C0 1.11241 0.88993 0 2.22482 0C3.55972 0 4.44379 1.00117 4.44379 2.22482Z"
        fill="#0F172A"
      />
      <path d="M4.44379 5.55469H0V19.9985H4.44379V5.55469Z" fill="#0F172A" />
      <path
        d="M15.1115 5.77733C12.7754 5.77733 11.4464 7.11223 10.8902 7.9963H10.7789L10.5564 6.1052H6.55762C6.55762 7.32886 6.66886 8.76914 6.66886 10.4378V19.9928H11.1127V12.1064C11.1127 11.6614 11.1127 11.3277 11.2239 10.994C11.5576 10.2153 12.1138 9.2141 13.3375 9.2141C14.8949 9.2141 15.5623 10.549 15.5623 12.323V19.9869H20.0061V11.7668C20.0061 7.65673 17.8925 5.76562 15.1173 5.76562L15.1115 5.77733Z"
        fill="#0F172A"
      />
    </svg>
  );
}

function Yt() {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-social b-icon-yt b-icon-main"
    >
      <path
        d="M13.75 8C13.7595 8.04696 13.7642 8.09862 13.7595 8.14558C13.769 8.09862 13.769 8.04696 13.75 8Z"
        fill="#0F172A"
      />
      <path
        d="M10 0C0.171791 0 0 0.906369 0 7.99765C0 15.0889 0.171791 15.9953 10 15.9953C19.8282 15.9953 20 15.0889 20 7.99765C20 0.906369 19.8282 0 10 0ZM13.1872 8.52363L8.67541 10.7872C8.31374 10.9704 7.88879 10.6933 7.88879 10.2753V5.84679C7.88879 5.43352 8.30018 5.15644 8.66184 5.3302L13.1736 7.49046C13.3499 7.57499 13.4494 7.72997 13.4765 7.89903C13.4946 7.94599 13.4946 7.99765 13.4855 8.04461C13.472 8.23716 13.377 8.42031 13.1826 8.51893L13.1872 8.52363Z"
        fill="#0F172A"
      />
    </svg>
  );
}

function Instagram() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-social b-icon-instagram b-icon-main"
    >
      <path
        d="M5.83333 0.833344H14.1667C17 0.833344 19.1667 3.00001 19.1667 5.83334V14.1667C19.1667 17 17 19.1667 14.1667 19.1667H5.83333C3.00001 19.1667 0.833344 17 0.833344 14.1667V5.83334C0.833344 3.00001 3.00001 0.833344 5.83333 0.833344ZM5.83333 2.50001C3.92501 2.50001 2.50001 3.92501 2.50001 5.83334V14.1667C2.50001 16.075 3.92501 17.5 5.83333 17.5H14.1667C16.075 17.5 17.5 16.075 17.5 14.1667V5.83334C17.5 3.92501 16.075 2.50001 14.1667 2.50001H5.83333Z"
        fill="#0F172A"
      />
      <path
        d="M10 6.66667C8.15905 6.66667 6.66667 8.15905 6.66667 10C6.66667 11.841 8.15905 13.3333 10 13.3333C11.841 13.3333 13.3333 11.841 13.3333 10C13.3333 8.15905 11.841 6.66667 10 6.66667ZM10 8.33334C10.9205 8.33334 11.6667 9.07953 11.6667 10C11.6667 10.9205 10.9205 11.6667 10 11.6667C9.07953 11.6667 8.33334 10.9205 8.33334 10C8.33334 9.07953 9.07953 8.33334 10 8.33334Z"
        fill="#0F172A"
      />
      <path
        d="M14.5833 6.25001C15.0436 6.25001 15.4167 5.87692 15.4167 5.41667C15.4167 4.95643 15.0436 4.58334 14.5833 4.58334C14.1231 4.58334 13.75 4.95643 13.75 5.41667C13.75 5.87692 14.1231 6.25001 14.5833 6.25001Z"
        fill="#0F172A"
      />
    </svg>
  );
}

function AppDownloadQR() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-app-download-qr"
    >
      <g clipPath="url(#clip0_32029_42475)">
        <rect width="80" height="80" rx="4.05518" fill="white" />
        <g clipPath="url(#clip1_32029_42475)">
          <path
            d="M26.043 3.72656V5.41852H27.7349V3.72656H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 3.72656V5.41852H32.8091V3.72656H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 3.72656V5.41852H35.3467V3.72656H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 3.72656V5.41852H37.8868V3.72656H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 3.72656V5.41852H40.4224V3.72656H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 3.72656V5.41852H53.1114V3.72656H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 3.72656V5.41852H55.6495V3.72656H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 6.26562V7.95758H25.1973V6.26562H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 6.26562V7.95758H27.7349V6.26562H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 6.26562V7.95758H30.2725V6.26562H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 6.26562V7.95758H35.3467V6.26562H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 6.26562V7.95758H40.4224V6.26562H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 6.26562V7.95758H45.4971V6.26562H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 6.26562V7.95758H50.5762V6.26562H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 6.26562V7.95758H53.1114V6.26562H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 8.79688V10.4888H27.7349V8.79688H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 8.79688V10.4888H40.4224V8.79688H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 8.79688V10.4888H45.4971V8.79688H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 8.79688V10.4888H48.0377V8.79688H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 8.79688V10.4888H50.5762V8.79688H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 11.3398V13.0318H27.7349V11.3398H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 11.3398V13.0318H32.8091V11.3398H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 11.3398V13.0318H35.3467V11.3398H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 11.3398V13.0318H40.4224V11.3398H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 11.3398V13.0318H42.9629V11.3398H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 11.3398V13.0318H55.6495V11.3398H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 13.875V15.567H35.3467V13.875H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 13.875V15.567H40.4224V13.875H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 13.875V15.567H45.4971V13.875H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 13.875V15.567H48.0377V13.875H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 13.875V15.567H50.5762V13.875H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 13.875V15.567H55.6495V13.875H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 16.4141V18.106H25.1973V16.4141H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 16.4141V18.106H27.7349V16.4141H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 16.4141V18.106H32.8091V16.4141H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 16.4141V18.106H37.8868V16.4141H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 16.4141V18.106H42.9629V16.4141H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 16.4141V18.106H45.4971V16.4141H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 16.4141V18.106H48.0377V16.4141H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 16.4141V18.106H53.1114V16.4141H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 16.4141V18.106H55.6495V16.4141H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 18.9531V20.6451H25.1973V18.9531H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 18.9531V20.6451H30.2725V18.9531H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 18.9531V20.6451H35.3467V18.9531H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 18.9531V20.6451H40.4224V18.9531H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 18.9531V20.6451H45.4971V18.9531H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 18.9531V20.6451H50.5762V18.9531H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 18.9531V20.6451H55.6495V18.9531H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 21.4883V23.1802H25.1973V21.4883H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 21.4883V23.1802H30.2725V21.4883H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 21.4883V23.1802H35.3467V21.4883H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 21.4883V23.1802H45.4971V21.4883H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 21.4883V23.1802H53.1114V21.4883H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M13.3511 24.0273V25.7193H15.043V24.0273H13.3511Z"
            fill="#0F172A"
          />
          <path
            d="M15.8892 24.0273V25.7193H17.5811V24.0273H15.8892Z"
            fill="#0F172A"
          />
          <path
            d="M18.4282 24.0273V25.7193H20.1202V24.0273H18.4282Z"
            fill="#0F172A"
          />
          <path
            d="M20.9658 24.0273V25.7193H22.6578V24.0273H20.9658Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 24.0273V25.7193H35.3467V24.0273H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 24.0273V25.7193H37.8868V24.0273H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 24.0273V25.7193H40.4224V24.0273H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 24.0273V25.7193H53.1114V24.0273H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 24.0273V25.7193H55.6495V24.0273H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M59.0347 24.0273V25.7193H60.7266V24.0273H59.0347Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 24.0273V25.7193H63.2642V24.0273H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 24.0273V25.7193H73.4171V24.0273H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 26.5625V28.2545H4.89313V26.5625H3.20117Z"
            fill="#0F172A"
          />
          <path
            d="M13.3511 26.5625V28.2545H15.043V26.5625H13.3511Z"
            fill="#0F172A"
          />
          <path
            d="M15.8892 26.5625V28.2545H17.5811V26.5625H15.8892Z"
            fill="#0F172A"
          />
          <path
            d="M20.9658 26.5625V28.2545H22.6578V26.5625H20.9658Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 26.5625V28.2545H25.1973V26.5625H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 26.5625V28.2545H27.7349V26.5625H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 26.5625V28.2545H40.4224V26.5625H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 26.5625V28.2545H45.4971V26.5625H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 26.5625V28.2545H48.0377V26.5625H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 26.5625V28.2545H50.5762V26.5625H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 26.5625V28.2545H53.1114V26.5625H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 26.5625V28.2545H63.2642V26.5625H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 26.5625V28.2545H65.8028V26.5625H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M69.1885 26.5625V28.2545H70.8804V26.5625H69.1885Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 26.5625V28.2545H73.4171V26.5625H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 26.5625V28.2545H75.9546V26.5625H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 29.1055V30.7974H4.89313V29.1055H3.20117Z"
            fill="#0F172A"
          />
          <path
            d="M13.3511 29.1055V30.7974H15.043V29.1055H13.3511Z"
            fill="#0F172A"
          />
          <path
            d="M18.4282 29.1055V30.7974H20.1202V29.1055H18.4282Z"
            fill="#0F172A"
          />
          <path
            d="M20.9658 29.1055V30.7974H22.6578V29.1055H20.9658Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 29.1055V30.7974H25.1973V29.1055H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 29.1055V30.7974H27.7349V29.1055H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 29.1055V30.7974H30.2725V29.1055H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 29.1055V30.7974H32.8091V29.1055H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 29.1055V30.7974H37.8868V29.1055H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 29.1055V30.7974H42.9629V29.1055H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 29.1055V30.7974H48.0377V29.1055H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 29.1055V30.7974H50.5762V29.1055H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 29.1055V30.7974H53.1114V29.1055H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 29.1055V30.7974H58.1866V29.1055H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 29.1055V30.7974H63.2642V29.1055H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M66.6499 29.1055V30.7974H68.3419V29.1055H66.6499Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 29.1055V30.7974H75.9546V29.1055H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 31.6406V33.3326H4.89313V31.6406H3.20117Z"
            fill="#0F172A"
          />
          <path
            d="M13.3511 31.6406V33.3326H15.043V31.6406H13.3511Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 31.6406V33.3326H25.1973V31.6406H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 31.6406V33.3326H27.7349V31.6406H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 31.6406V33.3326H32.8091V31.6406H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 31.6406V33.3326H37.8868V31.6406H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 31.6406V33.3326H42.9629V31.6406H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 31.6406V33.3326H45.4971V31.6406H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 31.6406V33.3326H53.1114V31.6406H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 31.6406V33.3326H55.6495V31.6406H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 31.6406V33.3326H58.1866V31.6406H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 31.6406V33.3326H63.2642V31.6406H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 31.6406V33.3326H65.8028V31.6406H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 31.6406V33.3326H73.4171V31.6406H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 31.6406V33.3326H75.9546V31.6406H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 34.1797V35.8716H4.89313V34.1797H3.20117Z"
            fill="#0F172A"
          />
          <path
            d="M10.813 34.1797V35.8716H12.5049V34.1797H10.813Z"
            fill="#0F172A"
          />
          <path
            d="M18.4282 34.1797V35.8716H20.1202V34.1797H18.4282Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 34.1797V35.8716H32.8091V34.1797H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 34.1797V35.8716H40.4224V34.1797H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 34.1797V35.8716H45.4971V34.1797H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 34.1797V35.8716H50.5762V34.1797H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 34.1797V35.8716H63.2642V34.1797H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M66.6499 34.1797V35.8716H68.3419V34.1797H66.6499Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 34.1797V35.8716H75.9546V34.1797H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M8.2749 36.7227V38.4146H9.96686V36.7227H8.2749Z"
            fill="#0F172A"
          />
          <path
            d="M10.813 36.7227V38.4146H12.5049V36.7227H10.813Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 36.7227V38.4146H27.7349V36.7227H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 36.7227V38.4146H30.2725V36.7227H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 36.7227V38.4146H35.3467V36.7227H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 36.7227V38.4146H40.4224V36.7227H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 36.7227V38.4146H48.0377V36.7227H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 36.7227V38.4146H50.5762V36.7227H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M59.0347 36.7227V38.4146H60.7266V36.7227H59.0347Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 36.7227V38.4146H65.8028V36.7227H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M69.1885 36.7227V38.4146H70.8804V36.7227H69.1885Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 36.7227V38.4146H75.9546V36.7227H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M10.813 39.2539V40.9459H12.5049V39.2539H10.813Z"
            fill="#0F172A"
          />
          <path
            d="M15.8892 39.2539V40.9459H17.5811V39.2539H15.8892Z"
            fill="#0F172A"
          />
          <path
            d="M18.4282 39.2539V40.9459H20.1202V39.2539H18.4282Z"
            fill="#0F172A"
          />
          <path
            d="M20.9658 39.2539V40.9459H22.6578V39.2539H20.9658Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 39.2539V40.9459H25.1973V39.2539H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 39.2539V40.9459H30.2725V39.2539H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 39.2539V40.9459H37.8868V39.2539H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 39.2539V40.9459H40.4224V39.2539H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 39.2539V40.9459H42.9629V39.2539H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 39.2539V40.9459H48.0377V39.2539H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 39.2539V40.9459H55.6495V39.2539H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 39.2539V40.9459H58.1866V39.2539H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 39.2539V40.9459H65.8028V39.2539H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 39.2539V40.9459H75.9546V39.2539H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 41.793V43.4849H4.89313V41.793H3.20117Z"
            fill="#0F172A"
          />
          <path
            d="M8.2749 41.793V43.4849H9.96686V41.793H8.2749Z"
            fill="#0F172A"
          />
          <path
            d="M10.813 41.793V43.4849H12.5049V41.793H10.813Z"
            fill="#0F172A"
          />
          <path
            d="M13.3511 41.793V43.4849H15.043V41.793H13.3511Z"
            fill="#0F172A"
          />
          <path
            d="M15.8892 41.793V43.4849H17.5811V41.793H15.8892Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 41.793V43.4849H27.7349V41.793H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 41.793V43.4849H35.3467V41.793H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 41.793V43.4849H40.4224V41.793H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 41.793V43.4849H42.9629V41.793H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 41.793V43.4849H48.0377V41.793H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 41.793V43.4849H58.1866V41.793H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 41.793V43.4849H63.2642V41.793H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M66.6499 41.793V43.4849H68.3419V41.793H66.6499Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 41.793V43.4849H73.4171V41.793H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 44.3281V46.0201H4.89313V44.3281H3.20117Z"
            fill="#0F172A"
          />
          <path
            d="M8.2749 44.3281V46.0201H9.96686V44.3281H8.2749Z"
            fill="#0F172A"
          />
          <path
            d="M10.813 44.3281V46.0201H12.5049V44.3281H10.813Z"
            fill="#0F172A"
          />
          <path
            d="M13.3511 44.3281V46.0201H15.043V44.3281H13.3511Z"
            fill="#0F172A"
          />
          <path
            d="M15.8892 44.3281V46.0201H17.5811V44.3281H15.8892Z"
            fill="#0F172A"
          />
          <path
            d="M18.4282 44.3281V46.0201H20.1202V44.3281H18.4282Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 44.3281V46.0201H27.7349V44.3281H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 44.3281V46.0201H35.3467V44.3281H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 44.3281V46.0201H40.4224V44.3281H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 44.3281V46.0201H45.4971V44.3281H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 44.3281V46.0201H50.5762V44.3281H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 44.3281V46.0201H53.1114V44.3281H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 44.3281V46.0201H55.6495V44.3281H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 44.3281V46.0201H58.1866V44.3281H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 44.3281V46.0201H63.2642V44.3281H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 44.3281V46.0201H65.8028V44.3281H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 46.8711V48.563H4.89313V46.8711H3.20117Z"
            fill="#0F172A"
          />
          <path
            d="M8.2749 46.8711V48.563H9.96686V46.8711H8.2749Z"
            fill="#0F172A"
          />
          <path
            d="M20.9658 46.8711V48.563H22.6578V46.8711H20.9658Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 46.8711V48.563H25.1973V46.8711H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 46.8711V48.563H37.8868V46.8711H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 46.8711V48.563H40.4224V46.8711H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 46.8711V48.563H42.9629V46.8711H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 46.8711V48.563H53.1114V46.8711H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 46.8711V48.563H55.6495V46.8711H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 46.8711V48.563H63.2642V46.8711H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 46.8711V48.563H65.8028V46.8711H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 46.8711V48.563H75.9546V46.8711H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M13.3511 49.4062V51.0982H15.043V49.4062H13.3511Z"
            fill="#0F172A"
          />
          <path
            d="M15.8892 49.4062V51.0982H17.5811V49.4062H15.8892Z"
            fill="#0F172A"
          />
          <path
            d="M18.4282 49.4062V51.0982H20.1202V49.4062H18.4282Z"
            fill="#0F172A"
          />
          <path
            d="M20.9658 49.4062V51.0982H22.6578V49.4062H20.9658Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 49.4062V51.0982H25.1973V49.4062H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 49.4062V51.0982H37.8868V49.4062H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 49.4062V51.0982H40.4224V49.4062H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 49.4062V51.0982H45.4971V49.4062H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 49.4062V51.0982H50.5762V49.4062H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 49.4062V51.0982H55.6495V49.4062H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 49.4062V51.0982H63.2642V49.4062H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M66.6499 49.4062V51.0982H68.3419V49.4062H66.6499Z"
            fill="#0F172A"
          />
          <path
            d="M69.1885 49.4062V51.0982H70.8804V49.4062H69.1885Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 49.4062V51.0982H75.9546V49.4062H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M8.2749 51.9414V53.6334H9.96686V51.9414H8.2749Z"
            fill="#0F172A"
          />
          <path
            d="M15.8892 51.9414V53.6334H17.5811V51.9414H15.8892Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 51.9414V53.6334H27.7349V51.9414H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 51.9414V53.6334H37.8868V51.9414H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 51.9414V53.6334H40.4224V51.9414H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 51.9414V53.6334H45.4971V51.9414H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 51.9414V53.6334H50.5762V51.9414H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 51.9414V53.6334H53.1114V51.9414H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 51.9414V53.6334H65.8028V51.9414H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 51.9414V53.6334H75.9546V51.9414H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 54.4844V56.1763H4.89313V54.4844H3.20117Z"
            fill="#0F172A"
          />
          <path
            d="M5.73779 54.4844V56.1763H7.42975V54.4844H5.73779Z"
            fill="#0F172A"
          />
          <path
            d="M8.2749 54.4844V56.1763H9.96686V54.4844H8.2749Z"
            fill="#0F172A"
          />
          <path
            d="M10.813 54.4844V56.1763H12.5049V54.4844H10.813Z"
            fill="#0F172A"
          />
          <path
            d="M13.3511 54.4844V56.1763H15.043V54.4844H13.3511Z"
            fill="#0F172A"
          />
          <path
            d="M15.8892 54.4844V56.1763H17.5811V54.4844H15.8892Z"
            fill="#0F172A"
          />
          <path
            d="M18.4282 54.4844V56.1763H20.1202V54.4844H18.4282Z"
            fill="#0F172A"
          />
          <path
            d="M20.9658 54.4844V56.1763H22.6578V54.4844H20.9658Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 54.4844V56.1763H25.1973V54.4844H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 54.4844V56.1763H27.7349V54.4844H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 54.4844V56.1763H30.2725V54.4844H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 54.4844V56.1763H35.3467V54.4844H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 54.4844V56.1763H45.4971V54.4844H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 54.4844V56.1763H50.5762V54.4844H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 54.4844V56.1763H53.1114V54.4844H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 54.4844V56.1763H55.6495V54.4844H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 54.4844V56.1763H58.1866V54.4844H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M59.0347 54.4844V56.1763H60.7266V54.4844H59.0347Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 54.4844V56.1763H63.2642V54.4844H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 54.4844V56.1763H65.8028V54.4844H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 54.4844V56.1763H73.4171V54.4844H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 57.0195V58.7115H25.1973V57.0195H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 57.0195V58.7115H32.8091V57.0195H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 57.0195V58.7115H35.3467V57.0195H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 57.0195V58.7115H48.0377V57.0195H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 57.0195V58.7115H50.5762V57.0195H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 57.0195V58.7115H55.6495V57.0195H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 57.0195V58.7115H65.8028V57.0195H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M69.1885 57.0195V58.7115H70.8804V57.0195H69.1885Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 57.0195V58.7115H75.9546V57.0195H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 59.5586V61.2505H25.1973V59.5586H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 59.5586V61.2505H35.3467V59.5586H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 59.5586V61.2505H37.8868V59.5586H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 59.5586V61.2505H40.4224V59.5586H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 59.5586V61.2505H48.0377V59.5586H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 59.5586V61.2505H53.1114V59.5586H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 59.5586V61.2505H55.6495V59.5586H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M59.0347 59.5586V61.2505H60.7266V59.5586H59.0347Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 59.5586V61.2505H65.8028V59.5586H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 59.5586V61.2505H75.9546V59.5586H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 62.0898V63.7818H25.1973V62.0898H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 62.0898V63.7818H30.2725V62.0898H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 62.0898V63.7818H32.8091V62.0898H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 62.0898V63.7818H42.9629V62.0898H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 62.0898V63.7818H45.4971V62.0898H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 62.0898V63.7818H50.5762V62.0898H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 62.0898V63.7818H53.1114V62.0898H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 62.0898V63.7818H55.6495V62.0898H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 62.0898V63.7818H65.8028V62.0898H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M66.6499 62.0898V63.7818H68.3419V62.0898H66.6499Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 62.0898V63.7818H73.4171V62.0898H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M23.5054 64.6367V66.3287H25.1973V64.6367H23.5054Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 64.6367V66.3287H27.7349V64.6367H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 64.6367V66.3287H30.2725V64.6367H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 64.6367V66.3287H35.3467V64.6367H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 64.6367V66.3287H37.8868V64.6367H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 64.6367V66.3287H40.4224V64.6367H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 64.6367V66.3287H42.9629V64.6367H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M46.3457 64.6367V66.3287H48.0377V64.6367H46.3457Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 64.6367V66.3287H53.1114V64.6367H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 64.6367V66.3287H55.6495V64.6367H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 64.6367V66.3287H58.1866V64.6367H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M59.0347 64.6367V66.3287H60.7266V64.6367H59.0347Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 64.6367V66.3287H63.2642V64.6367H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 64.6367V66.3287H65.8028V64.6367H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 64.6367V66.3287H73.4171V64.6367H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 64.6367V66.3287H75.9546V64.6367H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 67.1758V68.8677H40.4224V67.1758H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 67.1758V68.8677H45.4971V67.1758H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 67.1758V68.8677H63.2642V67.1758H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M66.6499 67.1758V68.8677H68.3419V67.1758H66.6499Z"
            fill="#0F172A"
          />
          <path
            d="M69.1885 67.1758V68.8677H70.8804V67.1758H69.1885Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 67.1758V68.8677H73.4171V67.1758H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 69.7109V71.4029H27.7349V69.7109H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M31.1172 69.7109V71.4029H32.8091V69.7109H31.1172Z"
            fill="#0F172A"
          />
          <path
            d="M36.1948 69.7109V71.4029H37.8868V69.7109H36.1948Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 69.7109V71.4029H40.4224V69.7109H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 69.7109V71.4029H42.9629V69.7109H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M43.8052 69.7109V71.4029H45.4971V69.7109H43.8052Z"
            fill="#0F172A"
          />
          <path
            d="M48.8843 69.7109V71.4029H50.5762V69.7109H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 69.7109V71.4029H53.1114V69.7109H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 69.7109V71.4029H55.6495V69.7109H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 69.7109V71.4029H58.1866V69.7109H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M69.1885 69.7109V71.4029H70.8804V69.7109H69.1885Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 69.7109V71.4029H73.4171V69.7109H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 69.7109V71.4029H75.9546V69.7109H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 72.25V73.942H35.3467V72.25H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 72.25V73.942H40.4224V72.25H38.7305Z"
            fill="#0F172A"
          />
          <path d="M41.271 72.25V73.942H42.9629V72.25H41.271Z" fill="#0F172A" />
          <path
            d="M48.8843 72.25V73.942H50.5762V72.25H48.8843Z"
            fill="#0F172A"
          />
          <path
            d="M51.4194 72.25V73.942H53.1114V72.25H51.4194Z"
            fill="#0F172A"
          />
          <path
            d="M59.0347 72.25V73.942H60.7266V72.25H59.0347Z"
            fill="#0F172A"
          />
          <path
            d="M61.5723 72.25V73.942H63.2642V72.25H61.5723Z"
            fill="#0F172A"
          />
          <path
            d="M66.6499 72.25V73.942H68.3419V72.25H66.6499Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 72.25V73.942H73.4171V72.25H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M74.2627 72.25V73.942H75.9546V72.25H74.2627Z"
            fill="#0F172A"
          />
          <path
            d="M26.043 74.7852V76.4771H27.7349V74.7852H26.043Z"
            fill="#0F172A"
          />
          <path
            d="M28.5806 74.7852V76.4771H30.2725V74.7852H28.5806Z"
            fill="#0F172A"
          />
          <path
            d="M33.6548 74.7852V76.4771H35.3467V74.7852H33.6548Z"
            fill="#0F172A"
          />
          <path
            d="M38.7305 74.7852V76.4771H40.4224V74.7852H38.7305Z"
            fill="#0F172A"
          />
          <path
            d="M41.271 74.7852V76.4771H42.9629V74.7852H41.271Z"
            fill="#0F172A"
          />
          <path
            d="M53.9575 74.7852V76.4771H55.6495V74.7852H53.9575Z"
            fill="#0F172A"
          />
          <path
            d="M56.4946 74.7852V76.4771H58.1866V74.7852H56.4946Z"
            fill="#0F172A"
          />
          <path
            d="M64.1108 74.7852V76.4771H65.8028V74.7852H64.1108Z"
            fill="#0F172A"
          />
          <path
            d="M66.6499 74.7852V76.4771H68.3419V74.7852H66.6499Z"
            fill="#0F172A"
          />
          <path
            d="M69.1885 74.7852V76.4771H70.8804V74.7852H69.1885Z"
            fill="#0F172A"
          />
          <path
            d="M71.7251 74.7852V76.4771H73.4171V74.7852H71.7251Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 5.32656V19.8921C3.20117 20.3164 3.36974 20.7234 3.6698 21.0234C3.96986 21.3235 4.37683 21.4921 4.80117 21.4921H19.3667C19.791 21.4921 20.198 21.3235 20.4981 21.0234C20.7981 20.7234 20.9667 20.3164 20.9667 19.8921V5.32656C20.9667 4.90222 20.7981 4.49525 20.4981 4.19519C20.198 3.89513 19.791 3.72656 19.3667 3.72656H4.80117C4.37683 3.72656 3.96986 3.89513 3.6698 4.19519C3.36974 4.49525 3.20117 4.90222 3.20117 5.32656ZM16.8288 18.9541H7.3391C6.91476 18.9541 6.50779 18.7856 6.20773 18.4855C5.90767 18.1855 5.7391 17.7785 5.7391 17.3541V7.86449C5.7391 7.44015 5.90767 7.03318 6.20773 6.73312C6.50779 6.43306 6.91476 6.26449 7.3391 6.26449H16.8288C17.2531 6.26449 17.6601 6.43306 17.9601 6.73312C18.2602 7.03318 18.4288 7.44015 18.4288 7.86449V17.3541C18.4288 17.7785 18.2602 18.1855 17.9601 18.4855C17.6601 18.7856 17.2531 18.9541 16.8288 18.9541Z"
            fill="#0F172A"
          />
          <path
            d="M3.20117 61.1586V75.7241C3.20117 76.1485 3.36974 76.5554 3.6698 76.8555C3.96986 77.1555 4.37683 77.3241 4.80117 77.3241H19.3667C19.791 77.3241 20.198 77.1555 20.4981 76.8555C20.7981 76.5554 20.9667 76.1485 20.9667 75.7241V61.1586C20.9667 60.7342 20.7981 60.3273 20.4981 60.0272C20.198 59.7272 19.791 59.5586 19.3667 59.5586H4.80117C4.37683 59.5586 3.96986 59.7272 3.6698 60.0272C3.36974 60.3273 3.20117 60.7342 3.20117 61.1586ZM16.8288 74.7862H7.3391C6.91476 74.7862 6.50779 74.6176 6.20773 74.3175C5.90767 74.0175 5.7391 73.6105 5.7391 73.1862V63.6965C5.7391 63.2722 5.90767 62.8652 6.20773 62.5652C6.50779 62.2651 6.91476 62.0965 7.3391 62.0965H16.8288C17.2531 62.0965 17.6601 62.2651 17.9601 62.5652C18.2602 62.8652 18.4288 63.2722 18.4288 63.6965V73.1862C18.4288 73.6105 18.2602 74.0175 17.9601 74.3175C17.6601 74.6176 17.2531 74.7862 16.8288 74.7862Z"
            fill="#0F172A"
          />
          <path
            d="M59.0347 5.32656V19.8921C59.0347 20.3164 59.2032 20.7234 59.5033 21.0234C59.8034 21.3235 60.2103 21.4921 60.6347 21.4921H75.2002C75.6245 21.4921 76.0315 21.3235 76.3316 21.0234C76.6316 20.7234 76.8002 20.3164 76.8002 19.8921V5.32656C76.8002 4.90222 76.6316 4.49525 76.3316 4.19519C76.0315 3.89513 75.6245 3.72656 75.2002 3.72656H60.6347C60.2103 3.72656 59.8034 3.89513 59.5033 4.19519C59.2032 4.49525 59.0347 4.90222 59.0347 5.32656ZM72.6623 18.9541H63.1726C62.7483 18.9541 62.3413 18.7856 62.0412 18.4855C61.7412 18.1855 61.5726 17.7785 61.5726 17.3541V7.86449C61.5726 7.44015 61.7412 7.03318 62.0412 6.73312C62.3413 6.43306 62.7483 6.26449 63.1726 6.26449H72.6623C73.0866 6.26449 73.4936 6.43306 73.7936 6.73312C74.0937 7.03318 74.2623 7.44015 74.2623 7.86449V17.3541C74.2623 17.7785 74.0937 18.1855 73.7936 18.4855C73.4936 18.7856 73.0866 18.9541 72.6623 18.9541Z"
            fill="#0F172A"
          />
          <path
            d="M12.0818 16.4107C14.1843 16.4107 15.8887 14.7063 15.8887 12.6038C15.8887 10.5013 14.1843 8.79688 12.0818 8.79688C9.97931 8.79688 8.2749 10.5013 8.2749 12.6038C8.2749 14.7063 9.97931 16.4107 12.0818 16.4107Z"
            fill="#0F172A"
          />
          <path
            d="M67.9177 16.4107C70.0202 16.4107 71.7246 14.7063 71.7246 12.6038C71.7246 10.5013 70.0202 8.79688 67.9177 8.79688C65.8152 8.79688 64.1108 10.5013 64.1108 12.6038C64.1108 14.7063 65.8152 16.4107 67.9177 16.4107Z"
            fill="#0F172A"
          />
          <path
            d="M12.0818 72.2505C14.1843 72.2505 15.8887 70.5461 15.8887 68.4436C15.8887 66.3411 14.1843 64.6367 12.0818 64.6367C9.97931 64.6367 8.2749 66.3411 8.2749 68.4436C8.2749 70.5461 9.97931 72.2505 12.0818 72.2505Z"
            fill="#0F172A"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_32029_42475">
          <rect width="80" height="80" rx="4.05518" fill="white" />
        </clipPath>
        <clipPath id="clip1_32029_42475">
          <rect
            width="80"
            height="80"
            fill="white"
            transform="translate(0 0.519531)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function MHome() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-home"
    >
      <path
        d="M8.26833 2.60389L3.32749 6.45389C2.5025 7.09556 1.83333 8.46139 1.83333 9.49722V16.2897C1.83333 18.4164 3.56583 20.1581 5.69249 20.1581H16.3075C18.4342 20.1581 20.1667 18.4164 20.1667 16.2989V9.62556C20.1667 8.51639 19.4242 7.09556 18.5167 6.46306L12.8517 2.49389C11.5683 1.59556 9.50583 1.64139 8.26833 2.60389Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 19.7992L11 13.1992"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MProducts() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-products"
    >
      <path
        d="M2.90591 6.81885L11.0001 11.503L19.0392 6.84632"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 19.8068V11.4927"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.10253 2.27228L4.20754 4.9948C3.09837 5.60897 2.19089 7.14895 2.19089 8.41395V13.5931C2.19089 14.8581 3.09837 16.3981 4.20754 17.0123L9.10253 19.7348C10.1475 20.3123 11.8617 20.3123 12.9067 19.7348L17.8017 17.0123C18.9109 16.3981 19.8184 14.8581 19.8184 13.5931V8.41395C19.8184 7.14895 18.9109 5.60897 17.8017 4.9948L12.9067 2.27228C11.8525 1.68561 10.1475 1.68561 9.10253 2.27228Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5833 12.1359V8.78094L6.88412 3.75757"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MStoreSettings() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-store-settings"
    >
      <path
        d="M2.75917 10.2849V14.4007C2.75917 18.5166 4.40917 20.1666 8.525 20.1666H13.4658C17.5817 20.1666 19.2317 18.5166 19.2317 14.4007V10.2849"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 10.9999C12.6775 10.9999 13.915 9.63409 13.75 7.95659L13.145 1.83325H8.86417L8.25001 7.95659C8.08501 9.63409 9.32251 10.9999 11 10.9999Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7842 10.9999C18.6358 10.9999 19.9925 9.49659 19.8092 7.65409L19.5525 5.13325C19.2225 2.74992 18.3058 1.83325 15.9042 1.83325H13.1083L13.75 8.25909C13.9058 9.77159 15.2717 10.9999 16.7842 10.9999Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.17 10.9999C6.6825 10.9999 8.04833 9.77159 8.195 8.25909L8.39667 6.23325L8.83667 1.83325H6.04083C3.63917 1.83325 2.7225 2.74992 2.3925 5.13325L2.145 7.65409C1.96167 9.49659 3.31833 10.9999 5.17 10.9999Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15.5833C9.46916 15.5833 8.70833 16.3441 8.70833 17.8749V20.1666H13.2917V17.8749C13.2917 16.3441 12.5308 15.5833 11 15.5833Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MInvoices() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-invoices"
    >
      <path
        d="M18.7219 6.70968V15.2897C18.7219 17.8637 17.4349 19.5797 14.4319 19.5797H7.56794C4.56494 19.5797 3.27794 17.8637 3.27794 15.2897V6.70968C3.27794 4.13568 4.56494 2.41968 7.56794 2.41968H14.4319C17.4349 2.41968 18.7219 4.13568 18.7219 6.70968Z"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1448 4.5625V6.2785C13.1448 7.2223 13.917 7.9945 14.8608 7.9945H16.5768"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.56787 11.8555H10.9999"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5679 15.2888H14.4319"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MNotifications() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-notifications"
    >
      <path
        d="M17.9914 11.8045V14.5094C17.9914 15.1993 18.2676 15.8609 18.7593 16.3488C19.2509 16.8365 20.0825 17.1106 20.7778 17.1106H1.22227C1.91761 17.1106 2.74917 16.8365 3.24085 16.3488C3.73251 15.8609 4.00875 15.1993 4.00875 14.5094L4.00873 8.15806C4.00873 6.31843 4.74531 4.55413 6.05644 3.2533C7.36757 1.95248 9.14585 1.22168 11.0001 1.22168"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.00869 11.8045V14.5094C4.00869 15.1993 3.7325 15.8609 3.24076 16.3488C2.74921 16.8365 1.91756 17.1106 1.22228 17.1106H20.7778C20.0825 17.1106 19.2509 16.8365 18.7593 16.3488C18.2676 15.8609 17.9914 15.1993 17.9914 14.5094L17.9914 8.15806C17.9914 6.31843 17.2548 4.55413 15.9437 3.2533C14.6325 1.95248 12.8543 1.22168 11.0001 1.22168"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77783 20.7773H12.2223"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MNotificationsUnread() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-notifications-unread"
    >
      <path
        d="M17.9914 11.8046V14.5096C17.9914 15.1994 18.2676 15.861 18.7593 16.3489C19.2509 16.8366 20.0825 17.1107 20.7778 17.1107H1.22227C1.91761 17.1107 2.74917 16.8366 3.24085 16.3489C3.73251 15.861 4.00875 15.1994 4.00875 14.5096L4.00873 8.15818C4.00873 6.31855 4.74531 4.55425 6.05644 3.25342C7.36757 1.9526 9.14585 1.2218 11.0001 1.2218"
        stroke="black"
      />
      <path
        d="M4.00869 11.8046V14.5096C4.00869 15.1994 3.7325 15.861 3.24076 16.3489C2.74921 16.8366 1.91756 17.1107 1.22228 17.1107H20.7778C20.0825 17.1107 19.2509 16.8366 18.7593 16.3489C18.2676 15.861 17.9914 15.1994 17.9914 14.5096L17.9914 8.15818C17.9914 6.31855 17.2548 4.55425 15.9437 3.25342C14.6325 1.9526 12.8543 1.2218 11.0001 1.2218"
        stroke="black"
      />
      <path d="M9.77783 20.7773H12.2223" stroke="black" />
      <path
        d="M17.1112 9.80514C19.8265 9.80514 22.0278 7.60387 22.0278 4.88847C22.0278 2.17307 19.8265 -0.0281984 17.1112 -0.0281984C14.3958 -0.0281984 12.1945 2.17307 12.1945 4.88847C12.1945 7.60387 14.3958 9.80514 17.1112 9.80514Z"
        fill="#E50202"
        stroke="white"
      />
    </svg>
  );
}

function MAnalytics() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-statistics"
    >
      <path
        d="M6.30667 16.638V14.7405"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 16.6368V12.8418"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.6933 16.6372V10.9355"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.6933 5.36328L15.2716 5.85828C12.9341 8.58995 9.79914 10.5241 6.30664 11.3949"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.0076 5.36328H15.6934V8.03995"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24998 20.1673H13.75C18.3333 20.1673 20.1666 18.334 20.1666 13.7507V8.25065C20.1666 3.66732 18.3333 1.83398 13.75 1.83398H8.24998C3.66665 1.83398 1.83331 3.66732 1.83331 8.25065V13.7507C1.83331 18.334 3.66665 20.1673 8.24998 20.1673Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MMembers() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-members"
    >
      <path
        d="M16.5 6.56203C16.445 6.55287 16.3809 6.55287 16.3259 6.56203C15.0609 6.5162 14.0526 5.48037 14.0526 4.19703C14.0526 2.8862 15.1067 1.83203 16.4175 1.83203C17.7284 1.83203 18.7825 2.89537 18.7825 4.19703C18.7734 5.48037 17.765 6.5162 16.5 6.56203Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5559 13.2355C16.8117 13.4463 18.1959 13.2263 19.1676 12.5755C20.4601 11.7138 20.4601 10.3022 19.1676 9.44051C18.1867 8.78968 16.7842 8.56967 15.5284 8.78967"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.47252 6.56203C5.52752 6.55287 5.59168 6.55287 5.64668 6.56203C6.91168 6.5162 7.92002 5.48037 7.92002 4.19703C7.92002 2.8862 6.86585 1.83203 5.55502 1.83203C4.24419 1.83203 3.19002 2.89537 3.19002 4.19703C3.19918 5.48037 4.20752 6.5162 5.47252 6.56203Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41667 13.2355C5.16084 13.4463 3.77667 13.2263 2.80501 12.5755C1.51251 11.7138 1.51251 10.3022 2.80501 9.44051C3.78584 8.78968 5.18834 8.56967 6.44417 8.78967"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 13.4097C10.945 13.4005 10.8809 13.4005 10.8259 13.4097C9.56087 13.3639 8.55254 12.328 8.55254 11.0447C8.55254 9.73386 9.6067 8.67969 10.9175 8.67969C12.2284 8.67969 13.2825 9.74302 13.2825 11.0447C13.2734 12.328 12.265 13.373 11 13.4097Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33253 16.2952C7.04003 17.1568 7.04003 18.5685 8.33253 19.4302C9.7992 20.411 12.2009 20.411 13.6675 19.4302C14.96 18.5685 14.96 17.1568 13.6675 16.2952C12.21 15.3235 9.7992 15.3235 8.33253 16.2952Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MMarketing() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-marketing"
    >
      <path
        d="M5.50004 3.66732C7.03087 2.52148 8.93754 1.83398 11 1.83398C16.06 1.83398 20.1667 5.94065 20.1667 11.0007C20.1667 16.0607 16.06 20.1673 11 20.1673C5.94004 20.1673 1.83337 16.0607 1.83337 11.0007C1.83337 9.34148 2.27336 7.78314 3.05253 6.43564L11 11.0007"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.26082 8.21333C5.77499 9.02916 5.5 9.9825 5.5 11C5.5 14.0342 7.96583 16.5 11 16.5C14.0342 16.5 16.5 14.0342 16.5 11C16.5 7.96583 14.0342 5.5 11 5.5C10.1658 5.5 9.36834 5.68334 8.66251 6.02251"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MSupport() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-support"
    >
      <path
        d="M10.9999 20.1673C16.0416 20.1673 20.1666 16.0423 20.1666 11.0007C20.1666 5.95898 16.0416 1.83398 10.9999 1.83398C5.95825 1.83398 1.83325 5.95898 1.83325 11.0007C1.83325 16.0423 5.95825 20.1673 10.9999 20.1673Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.91675 9.13682C8.91675 8.69758 9.04712 8.26822 9.29137 7.903C9.5356 7.5378 9.88277 7.25315 10.2889 7.08506C10.6951 6.91697 11.1421 6.873 11.5732 6.95869C12.0044 7.04437 12.4005 7.25588 12.7114 7.56648C13.0222 7.87706 13.2339 8.27277 13.3197 8.70356C13.4055 9.13436 13.3615 9.58088 13.1932 9.98668C13.025 10.3925 12.7401 10.7393 12.3745 10.9833C12.009 11.2274 11.5792 11.3576 11.1396 11.3576V12.8381"
        stroke="black"
        strokeWidth="1.5675"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1378 15.7439C10.9626 15.7439 10.8206 15.6019 10.8206 15.4266C10.8206 15.2514 10.9626 15.1094 11.1378 15.1094"
        stroke="black"
        strokeWidth="1.5675"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1384 15.7439C11.3136 15.7439 11.4557 15.6019 11.4557 15.4266C11.4557 15.2514 11.3136 15.1094 11.1384 15.1094"
        stroke="black"
        strokeWidth="1.5675"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MBrandSelect() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-m-brand-select"
    >
      <path
        d="M7.49996 18.3327H12.5C16.6666 18.3327 18.3333 16.666 18.3333 12.4993V7.49935C18.3333 3.33268 16.6666 1.66602 12.5 1.66602H7.49996C3.33329 1.66602 1.66663 3.33268 1.66663 7.49935V12.4993C1.66663 16.666 3.33329 18.3327 7.49996 18.3327Z"
        stroke="black"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.45837 9.99896L8.81671 12.3573L13.5417 7.64062"
        stroke="black"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MNavDown() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-nav-down"
    >
      <path
        d="M18.26 8.20312L12.2833 14.1798C11.5775 14.8856 10.4225 14.8856 9.71666 14.1798L3.73999 8.20312"
        stroke="#292D32"
        strokeWidth="1.375"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MNavUp() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-nav-up"
    >
      <path
        d="M3.7,14.7l6-6c0.7-0.7,1.9-0.7,2.6,0l6,6"
        stroke="#292D32"
        strokeWidth="1.375"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MFb() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-fb"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H10.1723V14.8237H7.67671V12.0006H10.1723V10.0415C10.1723 7.67619 11.2433 6.04009 13.9336 6.04009L15.1961 6.1128L16.0403 6.22786V8.64652H14.6743C13.6257 8.64652 13.2239 9.41627 13.2239 10.3207L13.2399 12.0006H15.9462L15.521 14.822H13.2274V21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6Z"
        fill="#0F172A"
      />
    </svg>
  );
}

function MYt() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-yt"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0428 6.38406C19.8138 6.59087 20.4217 7.19651 20.6292 7.96464C21.0147 9.36795 20.9999 12.2927 20.9999 12.2927C20.9999 12.2927 20.9999 15.2028 20.6292 16.6061C20.4217 17.3742 19.8138 17.9798 19.0428 18.1866C17.6342 18.5559 12 18.5559 12 18.5559C12 18.5559 6.38055 18.5559 4.95716 18.1719C4.18616 17.9651 3.57825 17.3594 3.37067 16.5913C3 15.2028 3 12.278 3 12.278C3 12.278 3 9.36795 3.37067 7.96464C3.57825 7.19651 4.20098 6.5761 4.95716 6.36929C6.36572 6 12 6 12 6C12 6 17.6342 6 19.0428 6.38406ZM10.206 14.9659V9.58904L14.8913 12.2775L10.206 14.9659Z"
        fill="#0F172A"
      />
    </svg>
  );
}

function MIn() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-in"
    >
      <path
        d="M8.13615 19H5.23302V9.6437H8.13615V19ZM6.68458 8.36888C5.75252 8.36888 5 7.61471 5 6.68444C5 5.75417 5.75252 5 6.68458 5C7.61282 5 8.36535 5.75417 8.36535 6.68444C8.36535 7.61088 7.61282 8.36888 6.68458 8.36888ZM19 19H16.1007V14.452C16.1007 13.3686 16.0816 11.9713 14.5918 11.9713C13.0829 11.9713 12.8538 13.1542 12.8538 14.3754V19H9.95825V9.6437H12.7392V10.9223H12.7774C13.1632 10.1873 14.1105 9.41017 15.5201 9.41017C18.4576 9.41017 19 11.3473 19 13.8663V19Z"
        fill="#0F172A"
      />
    </svg>
  );
}

function MExport() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-export"
    >
      <path
        d="M8.25 20.1654H13.75C18.3333 20.1654 20.1667 18.332 20.1667 13.7487V8.2487C20.1667 3.66536 18.3333 1.83203 13.75 1.83203H8.25C3.66667 1.83203 1.83334 3.66536 1.83334 8.2487V13.7487C1.83334 18.332 3.66667 20.1654 8.25 20.1654Z"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 10.5508L11 13.3008L13.75 10.5508"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 13.3021V5.96875"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 15.1367C9.06583 16.3284 12.9342 16.3284 16.5 15.1367"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MAddProduct() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-add-product"
    >
      <path
        d="M21.0833 16.4987C21.0833 17.1862 20.8908 17.837 20.5517 18.387C20.3592 18.717 20.1117 19.0104 19.8275 19.2487C19.1858 19.8262 18.3425 20.1654 17.4167 20.1654C16.2983 20.1654 15.2992 19.6612 14.6392 18.8729C14.6208 18.8454 14.5933 18.827 14.575 18.7995C14.465 18.6712 14.3642 18.5337 14.2817 18.387C13.9425 17.837 13.75 17.1862 13.75 16.4987C13.75 15.3437 14.2817 14.3079 15.125 13.6387C15.7575 13.1345 16.555 12.832 17.4167 12.832C18.3333 12.832 19.1583 13.162 19.8 13.7212C19.91 13.8037 20.0108 13.9046 20.1025 14.0054C20.7075 14.6654 21.0833 15.5362 21.0833 16.4987Z"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7825 16.4844H16.0508"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4167 15.1445V17.8854"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.90582 6.82031L11 11.5045L19.0392 6.84778"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 19.8103V11.4961"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8092 8.40453V13.5929C19.8092 13.6387 19.8092 13.6754 19.8 13.7212C19.1583 13.162 18.3333 12.832 17.4167 12.832C16.555 12.832 15.7575 13.1346 15.125 13.6387C14.2817 14.3079 13.75 15.3437 13.75 16.4987C13.75 17.1862 13.9425 17.837 14.2817 18.387C14.3642 18.5337 14.465 18.6712 14.575 18.7996L12.8975 19.7254C11.8525 20.3121 10.1475 20.3121 9.10249 19.7254L4.20749 17.012C3.09832 16.3979 2.19083 14.8579 2.19083 13.5929V8.40453C2.19083 7.13953 3.09832 5.59955 4.20749 4.98538L9.10249 2.27203C10.1475 1.68536 11.8525 1.68536 12.8975 2.27203L17.7925 4.98538C18.9017 5.59955 19.8092 7.13953 19.8092 8.40453Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MDataSearch() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-data-search"
    >
      <path
        d="M10.5418 19.2507C15.3513 19.2507 19.2502 15.3518 19.2502 10.5423C19.2502 5.73284 15.3513 1.83398 10.5418 1.83398C5.73235 1.83398 1.8335 5.73284 1.8335 10.5423C1.8335 15.3518 5.73235 19.2507 10.5418 19.2507Z"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1668 20.1673L18.3335 18.334"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MDataCloseSearch() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-search-close"
    >
      <line
        fill="none"
        stroke="#000000"
        strokeWidth="1.6364"
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="2"
        y1="2"
        x2="20"
        y2="20"
      />
      <line
        fill="none"
        stroke="#000000"
        strokeWidth="1.6364"
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="2"
        y1="20"
        x2="20"
        y2="2"
      />
    </svg>
  );
}

function MActionArrow() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-action-arrow"
    >
      <path
        d="M10.8226 4.44727L15.3751 8.99977L10.8226 13.5523"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.625 9H15.2475"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MHelpStepsCompany() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-steps-company"
    >
      <path
        d="M8.66656 23.8333H17.3332C21.6882 23.8333 22.4682 22.0892 22.6957 19.9658L23.5082 11.2992C23.8007 8.65583 23.0424 6.5 18.4166 6.5H7.58323C2.95739 6.5 2.19906 8.65583 2.49156 11.2992L3.30406 19.9658C3.53156 22.0892 4.31156 23.8333 8.66656 23.8333Z"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66675 6.49935V5.63268C8.66675 3.71518 8.66675 2.16602 12.1334 2.16602H13.8667C17.3334 2.16602 17.3334 3.71518 17.3334 5.63268V6.49935"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1666 14.0833V15.1667C15.1666 15.1775 15.1666 15.1775 15.1666 15.1883C15.1666 16.3692 15.1558 17.3333 12.9999 17.3333C10.8549 17.3333 10.8333 16.38 10.8333 15.1992V14.0833C10.8333 13 10.8333 13 11.9166 13H14.0833C15.1666 13 15.1666 13 15.1666 14.0833Z"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4542 11.916C20.9517 13.736 18.0917 14.8193 15.1667 15.1877"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.83838 12.209C5.27588 13.8773 8.02755 14.8848 10.8334 15.199"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MHelpStepsProducts() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-steps-products"
    >
      <path
        d="M24.9167 19.4993C24.9167 20.3118 24.6892 21.081 24.2883 21.731C24.0608 22.121 23.7683 22.4677 23.4325 22.7493C22.6742 23.4318 21.6775 23.8327 20.5833 23.8327C19.2617 23.8327 18.0808 23.2369 17.3008 22.3052C17.2792 22.2727 17.2467 22.251 17.225 22.2185C17.095 22.0669 16.9758 21.9043 16.8783 21.731C16.4775 21.081 16.25 20.3118 16.25 19.4993C16.25 18.1343 16.8783 16.9102 17.875 16.1194C18.6225 15.5235 19.565 15.166 20.5833 15.166C21.6667 15.166 22.6417 15.556 23.4 16.2168C23.53 16.3143 23.6492 16.4335 23.7575 16.5527C24.4725 17.3327 24.9167 18.3618 24.9167 19.4993Z"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1976 19.4785H18.9692"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5835 17.8965V21.1356"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.43408 8.0625L12.9999 13.5983L22.5008 8.09497"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9998 23.4137V13.5879"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4108 9.93547V16.0672C23.4108 16.1213 23.4108 16.1646 23.4 16.2188C22.6416 15.558 21.6666 15.168 20.5833 15.168C19.5649 15.168 18.6224 15.5255 17.8749 16.1213C16.8783 16.9122 16.2499 18.1363 16.2499 19.5013C16.2499 20.3138 16.4774 21.083 16.8783 21.733C16.9758 21.9063 17.0949 22.0688 17.2249 22.2205L15.2425 23.3147C14.0075 24.008 11.9924 24.008 10.7574 23.3147L4.97244 20.108C3.66161 19.3822 2.58911 17.5622 2.58911 16.0672V9.93547C2.58911 8.44047 3.66161 6.62049 4.97244 5.89466L10.7574 2.68797C11.9924 1.99464 14.0075 1.99464 15.2425 2.68797L21.0274 5.89466C22.3383 6.62049 23.4108 8.44047 23.4108 9.93547Z"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MHelpStepsNew() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-steps-new"
    >
      <path
        d="M18.4167 19.9662H14.0834L9.26257 23.1728C8.54757 23.6495 7.58341 23.1404 7.58341 22.2737V19.9662C4.33341 19.9662 2.16675 17.7995 2.16675 14.5495V8.04948C2.16675 4.79948 4.33341 2.63281 7.58341 2.63281H18.4167C21.6667 2.63281 23.8334 4.79948 23.8334 8.04948V14.5495C23.8334 17.7995 21.6667 19.9662 18.4167 19.9662Z"
        stroke="white"
        strokeWidth="1.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 12.3066V12.0792C13 11.3425 13.455 10.9525 13.91 10.6383C14.3542 10.335 14.7983 9.94501 14.7983 9.23001C14.7983 8.23334 13.9966 7.43164 13 7.43164C12.0033 7.43164 11.2017 8.23334 11.2017 9.23001"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.995 14.8952H13.0048"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MHelpStepsVouchers() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-steps-vouchers"
    >
      <path
        d="M21.125 13.5404C21.125 12.0454 22.3383 10.832 23.8333 10.832V9.7487C23.8333 5.41536 22.75 4.33203 18.4166 4.33203H7.58329C3.24996 4.33203 2.16663 5.41536 2.16663 9.7487V10.2904C3.66163 10.2904 4.87496 11.5037 4.87496 12.9987C4.87496 14.4937 3.66163 15.707 2.16663 15.707V16.2487C2.16663 20.582 3.24996 21.6654 7.58329 21.6654H18.4166C22.75 21.6654 23.8333 20.582 23.8333 16.2487C22.3383 16.2487 21.125 15.0354 21.125 13.5404Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 15.9805L16.25 9.48047"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2441 15.9792H16.2538"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.74409 10.0221H9.75382"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MHelpStepsInvoices() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-steps-invoices"
    >
      <path
        d="M22.75 7.58464V18.418C22.75 21.668 21.125 23.8346 17.3333 23.8346H8.66667C4.875 23.8346 3.25 21.668 3.25 18.418V7.58464C3.25 4.33464 4.875 2.16797 8.66667 2.16797H17.3333C21.125 2.16797 22.75 4.33464 22.75 7.58464Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7084 4.875V7.04167C15.7084 8.23333 16.6834 9.20833 17.875 9.20833H20.0417"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66663 14.082H13"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66663 18.418H17.3333"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MHelpStepsAnalytics() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-steps-analytics"
    >
      <path
        d="M7.45337 19.6624V17.4199"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
      />
      <path
        d="M13 19.6627V15.1777"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
      />
      <path
        d="M18.5466 19.6622V12.9238"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
      />
      <path
        d="M18.5467 6.33789L18.0484 6.92289C15.2859 10.1512 11.5809 12.4371 7.45337 13.4662"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
      />
      <path
        d="M15.3726 6.33789H18.5467V9.50122"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75008 23.8327H16.2501C21.6667 23.8327 23.8334 21.666 23.8334 16.2493V9.74935C23.8334 4.33268 21.6667 2.16602 16.2501 2.16602H9.75008C4.33341 2.16602 2.16675 4.33268 2.16675 9.74935V16.2493C2.16675 21.666 4.33341 23.8327 9.75008 23.8327Z"
        stroke="white"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MAddLocation() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-add-location"
    >
      <path
        d="M8.98047 10.583H14.0221"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
      />
      <path
        d="M11.5 13.1042V8.0625"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
      />
      <path
        d="M3.82018 8.28218C5.62602 0.343843 17.3868 0.35301 19.1835 8.29134C20.2377 12.948 17.341 16.8897 14.8018 19.328C12.9593 21.1063 10.0443 21.1063 8.19268 19.328C5.66268 16.8897 2.76602 12.9388 3.82018 8.28218Z"
        stroke="black"
        strokeWidth="1.63636"
      />
    </svg>
  );
}

function MLocationList() {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-location-list"
    >
      <path
        d="M10.9995 11.751C12.5073 11.751 13.7295 10.5288 13.7295 9.02102C13.7295 7.51328 12.5073 6.29102 10.9995 6.29102C9.49179 6.29102 8.26953 7.51328 8.26953 9.02102C8.26953 10.5288 9.49179 11.751 10.9995 11.751Z"
        stroke="#64748B"
        strokeWidth="1.8"
      />
      <path
        d="M3.66944 7.42875C5.39319 -0.148748 16.6194 -0.139998 18.3344 7.4375C19.3407 11.8825 16.5757 15.645 14.1519 17.9725C12.3932 19.67 9.61069 19.67 7.84319 17.9725C5.42819 15.645 2.66319 11.8738 3.66944 7.42875Z"
        stroke="#64748B"
        strokeWidth="1.8"
      />
    </svg>
  );
}

function MLocationEdit() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-location-edit"
    >
      <path
        d="M10.582 2.33301H8.7487C4.16536 2.33301 2.33203 4.16634 2.33203 8.74967V14.2497C2.33203 18.833 4.16536 20.6663 8.7487 20.6663H14.2487C18.832 20.6663 20.6654 18.833 20.6654 14.2497V12.4163"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2027 3.26881L7.9794 10.4921C7.7044 10.7671 7.4294 11.308 7.3744 11.7021L6.98023 14.4613C6.83357 15.4605 7.5394 16.1571 8.53857 16.0196L11.2977 15.6255C11.6827 15.5705 12.2236 15.2955 12.5077 15.0205L19.7311 7.79714C20.9777 6.55048 21.5644 5.10214 19.7311 3.26881C17.8977 1.43548 16.4494 2.02214 15.2027 3.26881Z"
        stroke="black"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.168 4.30371C14.7821 6.49454 16.4963 8.20871 18.6963 8.83204"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MLocationDelete() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-location-delete"
    >
      <path
        d="M19.75 5.98177C16.6975 5.67927 13.6267 5.52344 10.565 5.52344C8.75 5.52344 6.935 5.6151 5.12 5.79844L3.25 5.98177"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.29297 5.05551L8.49464 3.85467C8.6413 2.98384 8.7513 2.33301 10.3005 2.33301H12.7021C14.2513 2.33301 14.3705 3.02051 14.508 3.86384L14.7096 5.05551"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.781 8.87793L17.1852 18.1088C17.0843 19.5479 17.0018 20.6663 14.4443 20.6663H8.55932C6.00182 20.6663 5.91932 19.5479 5.81849 18.1088L5.22266 8.87793"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96875 15.625H13.0212"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.20703 11.958H13.7904"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MInfoTooltip() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-inf-tooltip"
    >
      <svg x="0.5" y="0.5" width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M7.16667 6.5V9.83333M7.16309 3.83333H7.16907M7.16667 13.8333C10.8333 13.8333 13.8333 10.8333 13.8333 7.16667C13.8333 3.5 10.8333 0.5 7.16667 0.5C3.5 0.5 0.5 3.5 0.5 7.16667C0.5 10.8333 3.5 13.8333 7.16667 13.8333Z"
          stroke="black"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

function MButtonAdd() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-button-add"
    >
      <path
        d="M7.3335 11H14.6668"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14.6654V7.33203"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25016 20.1654H13.7502C18.3335 20.1654 20.1668 18.332 20.1668 13.7487V8.2487C20.1668 3.66536 18.3335 1.83203 13.7502 1.83203H8.25016C3.66683 1.83203 1.8335 3.66536 1.8335 8.2487V13.7487C1.8335 18.332 3.66683 20.1654 8.25016 20.1654Z"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MDownloadCodes() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-download-codes"
    >
      <path
        d="M8.25 10.082V15.582L10.0833 13.7487"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24984 15.5833L6.4165 13.75"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1668 9.16536V13.7487C20.1668 18.332 18.3335 20.1654 13.7502 20.1654H8.25016C3.66683 20.1654 1.8335 18.332 1.8335 13.7487V8.2487C1.8335 3.66536 3.66683 1.83203 8.25016 1.83203H12.8335"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1668 9.16536H16.5002C13.7502 9.16536 12.8335 8.2487 12.8335 5.4987V1.83203L20.1668 9.16536Z"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MButtonReplace() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-button-replace"
    >
      <path
        d="M20.1663 10.9987C20.1663 16.0587 16.0597 20.1654 10.9997 20.1654C5.93967 20.1654 2.85051 15.0687 2.85051 15.0687M2.85051 15.0687H6.99384M2.85051 15.0687V19.652M1.83301 10.9987C1.83301 5.9387 5.90301 1.83203 10.9997 1.83203C17.1138 1.83203 20.1663 6.9287 20.1663 6.9287M20.1663 6.9287V2.34536M20.1663 6.9287H16.0963"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MButtonReplaceFile() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-button-replace-file"
    >
      <path
        d="M8.2513 15.584V10.084L6.41797 11.9173"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 10.084L10.0833 11.9173"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1654 9.16732V13.7507C20.1654 18.334 18.332 20.1673 13.7487 20.1673H8.2487C3.66536 20.1673 1.83203 18.334 1.83203 13.7507V8.25065C1.83203 3.66732 3.66536 1.83398 8.2487 1.83398H12.832"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1654 9.16732H16.4987C13.7487 9.16732 12.832 8.25065 12.832 5.50065V1.83398L20.1654 9.16732Z"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MCodesAdd() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-codes-add"
    >
      <path
        d="M10.9987 20.1673C16.0404 20.1673 20.1654 16.0423 20.1654 11.0007C20.1654 5.95898 16.0404 1.83398 10.9987 1.83398C5.95703 1.83398 1.83203 5.95898 1.83203 11.0007C1.83203 16.0423 5.95703 20.1673 10.9987 20.1673Z"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33203 11H14.6654"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14.6673V7.33398"
        stroke="black"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MCodesUploadFile() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-codes-upload-file"
    >
      <path
        d="M7.9987 14.166V9.16602L6.33203 10.8327"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.16602L9.66667 10.8327"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8346 8.33268V12.4993C18.8346 16.666 17.168 18.3327 13.0013 18.3327H8.0013C3.83464 18.3327 2.16797 16.666 2.16797 12.4993V7.49935C2.16797 3.33268 3.83464 1.66602 8.0013 1.66602H12.168"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8346 8.33268H15.5013C13.0013 8.33268 12.168 7.49935 12.168 4.99935V1.66602L18.8346 8.33268Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MDownloadTemplate() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-download-template"
    >
      <path
        d="M13.6997 7.41797C16.6997 7.6763 17.9247 9.21797 17.9247 12.593V12.7013C17.9247 16.4263 16.4331 17.918 12.7081 17.918H7.28307C3.55807 17.918 2.06641 16.4263 2.06641 12.7013V12.593C2.06641 9.24297 3.27474 7.7013 6.22474 7.4263"
        stroke="#E50202"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 1.66602V12.3993"
        stroke="#E50202"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7904 10.543L9.9987 13.3346L7.20703 10.543"
        stroke="#E50202"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MAddUser() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M11.0001 10.9999C13.5314 10.9999 15.5834 8.94789 15.5834 6.41659C15.5834 3.88528 13.5314 1.83325 11.0001 1.83325C8.46878 1.83325 6.41675 3.88528 6.41675 6.41659C6.41675 8.94789 8.46878 10.9999 11.0001 10.9999Z"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.12573 20.1667C3.12573 16.6192 6.6549 13.75 10.9999 13.75C11.8799 13.75 12.7324 13.8692 13.5299 14.0892"
        stroke="white"
        strokeWidth="1.63636"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1666 16.4999C20.1666 16.7933 20.1299 17.0774 20.0566 17.3524C19.9741 17.7191 19.8274 18.0766 19.6349 18.3882C19.0024 19.4516 17.8383 20.1666 16.4999 20.1666C15.5558 20.1666 14.7032 19.8091 14.0616 19.2224C13.7866 18.9841 13.5482 18.6999 13.3649 18.3882C13.0257 17.8382 12.8333 17.1874 12.8333 16.4999C12.8333 15.5099 13.2274 14.6024 13.8691 13.9424C14.5383 13.2549 15.4733 12.8333 16.4999 12.8333C17.5816 12.8333 18.5624 13.3008 19.2224 14.0524C19.8091 14.7033 20.1666 15.5649 20.1666 16.4999Z"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8659 16.4817H15.1343"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 15.1433V17.8841"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MSaveCode() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-save-code"
    >
      <path
        d="M16.084 19.2923H6.91732C4.16732 19.2923 2.33398 17.9173 2.33398 14.709V8.29232C2.33398 5.08398 4.16732 3.70898 6.91732 3.70898H16.084C18.834 3.70898 20.6673 5.08398 20.6673 8.29232V14.709C20.6673 17.9173 18.834 19.2923 16.084 19.2923Z"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7.83398V15.1673"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 7.83398V11.5007"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 14.25V15.1667"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 7.83398V8.75065"
        stroke="white"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 7.83398V15.1673"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 11.5V15.1667"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 7.83398V15.1673"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MWelcomeProducts() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-welcome-products"
    >
      <path
        d="M2.90601 6.81836L11.0002 11.5025L19.0393 6.84583"
        stroke="black"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 19.8064V11.4922"
        stroke="black"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.10257 2.27203L4.20757 4.99456C3.0984 5.60873 2.19092 7.14871 2.19092 8.41371V13.5929C2.19092 14.8579 3.0984 16.3979 4.20757 17.012L9.10257 19.7346C10.1476 20.3121 11.8617 20.3121 12.9067 19.7346L17.8018 17.012C18.9109 16.3979 19.8184 14.8579 19.8184 13.5929V8.41371C19.8184 7.14871 18.9109 5.60873 17.8018 4.99456L12.9067 2.27203C11.8526 1.68536 10.1476 1.68536 9.10257 2.27203Z"
        stroke="black"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5832 12.1362V8.78118L6.88403 3.75781"
        stroke="black"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MFlagRo() {
  return (
    <svg
      width="53"
      height="53"
      viewBox="0 0 53 53"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m13.97 3.15v46.7c-8.32-4.46-13.97-13.24-13.97-23.35s5.65-18.89 13.97-23.35z"
        fill="#14439e"
      />
      <path
        d="m39.03 3.15v46.7c-3.73 2.01-8 3.15-12.53 3.15s-8.8-1.14-12.53-3.15v-46.7c3.73-2.01 8-3.15 12.53-3.15s8.8 1.14 12.53 3.15z"
        fill="#fd0"
      />
      <path
        d="m53 26.5c0 10.11-5.65 18.89-13.97 23.35v-46.7c8.32 4.46 13.97 13.24 13.97 23.35z"
        fill="#f30040"
      />
    </svg>
  );
}

function MFlagUk() {
  return (
    <svg
      height="512"
      width="512"
      viewBox="0 0 480 480"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m480 240c0 132.51-107.39 239.94-239.89 240h-2.59a242.26 242.26 0 0 1 -34.74-2.87 236 236 0 0 1 -27.9-6.06 240.08 240.08 0 0 1 -174.88-231.07c0-132.53 107.42-240 240-240h.11a239.26 239.26 0 0 1 174.34 75.17 239.79 239.79 0 0 1 65.55 164.83z"
        fill="#fff"
      />
      <path
        d="m179.43 168.62v10.8h-34.89l-98-81.49a239 239 0 0 1 19.7-23.48z"
        fill="#c8102e"
      />
      <path
        d="m433.77 98.37-97.43 81h-35.77v-10.02l113.58-94.49.3.31a236.65 236.65 0 0 1 18.34 21.83z"
        fill="#c8102e"
      />
      <path
        d="m179.43 300.56v10.8l-113.19 94.19c-1-1-2-2.08-2.94-3.13a238.48 238.48 0 0 1 -16.75-20.35l98-81.51z"
        fill="#c8102e"
      />
      <path
        d="m433.78 381.62a240 240 0 0 1 -19.62 23.51l-113.59-94.5v-10.07h35.77z"
        fill="#c8102e"
      />
      <g fill="#012169">
        <path d="m95.85 179.42h-88.14a237.85 237.85 0 0 1 22-55.07z" />
        <path d="m93.86 300.56-64.86 53.94a238 238 0 0 1 -21.29-53.94z" />
        <path d="m179.43 351.28v121c-1.52-.39-3-.8-4.55-1.23a239.12 239.12 0 0 1 -86.09-44.68z" />
        <path d="m179.43 7.71v119.1l-89.29-74.28a239.16 239.16 0 0 1 89.29-44.82z" />
        <path d="m391.23 53.65-90.66 75.15v-121.08l1.37.35a239 239 0 0 1 89.29 45.58z" />
        <path d="m472.29 179.42h-86l64.71-53.84a238.17 238.17 0 0 1 21.29 53.84z" />
        <path d="m392 425.78a239.25 239.25 0 0 1 -91.38 46.51v-122.53z" />
        <path d="m472.29 300.56a238.61 238.61 0 0 1 -20.65 52.71l-63.35-52.71z" />
      </g>
      <path
        d="m480 237.49v4.79a242.25 242.25 0 0 1 -2.63 33.43h-201.66v201.65a242.45 242.45 0 0 1 -33.22 2.64h-5a240.78 240.78 0 0 1 -33.23-2.65v-201.64h-201.62a243 243 0 0 1 -2.64-33.26c0-1.57 0-3.15 0-4.73a242.4 242.4 0 0 1 2.63-33.44h201.66v-201.64a243.84 243.84 0 0 1 31.62-2.64h7.74a240.26 240.26 0 0 1 30.19 2.34l1.87.28v201.66h201.65a242.31 242.31 0 0 1 2.64 33.21z"
        fill="#c8102e"
      />
    </svg>
  );
}

function MNotificationArrow() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="b-icon b-icon-merchants b-icon-messages-arrow"
    >
      <path
        d="M8.16748 18.26L14.1441 12.2833C14.85 11.5775 14.85 10.4225 14.1441 9.71666L8.16748 3.73999"
        stroke="black"
        strokeWidth="1.63636"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
// My account side menu (new design) **************************************************************************************************

function AccountMenuDashboard() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 8.75H5.75C7.75 8.75 8.75 7.75 8.75 5.75V3.75C8.75 1.75 7.75 0.75 5.75 0.75H3.75C1.75 0.75 0.75 1.75 0.75 3.75V5.75C0.75 7.75 1.75 8.75 3.75 8.75Z"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 8.75H17.75C19.75 8.75 20.75 7.75 20.75 5.75V3.75C20.75 1.75 19.75 0.75 17.75 0.75H15.75C13.75 0.75 12.75 1.75 12.75 3.75V5.75C12.75 7.75 13.75 8.75 15.75 8.75Z"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 20.75H17.75C19.75 20.75 20.75 19.75 20.75 17.75V15.75C20.75 13.75 19.75 12.75 17.75 12.75H15.75C13.75 12.75 12.75 13.75 12.75 15.75V17.75C12.75 19.75 13.75 20.75 15.75 20.75Z"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 20.75H5.75C7.75 20.75 8.75 19.75 8.75 17.75V15.75C8.75 13.75 7.75 12.75 5.75 12.75H3.75C1.75 12.75 0.75 13.75 0.75 15.75V17.75C0.75 19.75 1.75 20.75 3.75 20.75Z"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuAttendance() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75 0.75V3.75M13.75 0.75V3.75M1.25 7.84H18.25M13.4447 12.45H13.4537M13.4447 15.45H13.4537M9.74548 12.45H9.75447M9.74548 15.45H9.75447M6.04431 12.45H6.05329M6.04431 15.45H6.05329M18.75 7.25V15.75C18.75 18.75 17.25 20.75 13.75 20.75H5.75C2.25 20.75 0.75 18.75 0.75 15.75V7.25C0.75 4.25 2.25 2.25 5.75 2.25H13.75C17.25 2.25 18.75 4.25 18.75 7.25Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuOrders() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 0.75H2.53025C5.25 0.75 4.50488 4.68 4.4128 5.75L3.5636 12.71C3.42036 14.34 4.74019 15.74 6.41812 15.74H17.3144C18.7877 15.74 20.0769 14.56 20.1894 13.13L20.7419 8.63C20.8647 6.97 19.5755 5.62 17.8669 5.62H4.65836M17.25 5.25L14.5 3.00467C14.2877 2.84153 14.0009 2.75 13.7021 2.75C13.4032 2.75 13.1164 2.84153 12.9041 3.00467L10.25 5.25M12.3157 3.50247L9.61596 2.91138C9.47454 2.87864 9.32616 2.86798 9.17939 2.88003C9.03262 2.89207 8.89039 2.92658 8.76094 2.98155C8.63148 3.03652 8.51736 3.11087 8.4252 3.20029C8.33303 3.2897 8.26464 3.39241 8.22399 3.50247L7.25 5.25M16.6085 19.5C16.6085 20.1904 16.0359 20.75 15.3296 20.75C14.6232 20.75 14.0507 20.1904 14.0507 19.5C14.0507 18.8096 14.6232 18.25 15.3296 18.25C16.0359 18.25 16.6085 18.8096 16.6085 19.5ZM8.42346 19.5C8.42346 20.1904 7.85087 20.75 7.14455 20.75C6.43823 20.75 5.86564 20.1904 5.86564 19.5C5.86564 18.8096 6.43823 18.25 7.14455 18.25C7.85087 18.25 8.42346 18.8096 8.42346 19.5Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuSubscriptions() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 10.75C16.25 13.79 13.79 16.25 10.75 16.25C7.71 16.25 5.85999 13.19 5.85999 13.19M5.85999 15.94V13.19H8.34M5.25 10.75C5.25 7.71 7.69 5.25 10.75 5.25C14.42 5.25 16.25 8.31 16.25 8.31M13.81 8.31H16.25V5.56M7.75 20.75H13.75C18.75 20.75 20.75 18.75 20.75 13.75V7.75C20.75 2.75 18.75 0.75 13.75 0.75H7.75C2.75 0.75 0.75 2.75 0.75 7.75V13.75C0.75 18.75 2.75 20.75 7.75 20.75Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuNotifications() {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.796 17.8702C11.796 19.5202 10.446 20.8702 8.796 20.8702C7.976 20.8702 7.216 20.5302 6.67602 19.9902C6.13602 19.4502 5.79602 18.6902 5.79602 17.8702M8.796 1.71997C5.48597 1.71997 2.79597 4.40997 2.79597 7.71997V10.61C2.79597 11.22 2.53597 12.15 2.22597 12.67L1.07597 14.58C0.365967 15.76 0.855967 17.07 2.15597 17.51C6.46597 18.95 11.116 18.95 15.426 17.51C16.636 17.11 17.166 15.68 16.506 14.58L15.356 12.67C15.056 12.15 14.796 11.22 14.796 10.61V7.71997C14.796 4.41997 12.096 1.71997 8.796 1.71997ZM10.646 2.01C10.336 1.92 10.016 1.85 9.686 1.81C8.726 1.69 7.806 1.76 6.946 2.01C7.236 1.27 7.956 0.75 8.796 0.75C9.636 0.75 10.356 1.27 10.646 2.01Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

function AccountMenuFavorite() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.37 18.46C11.03 18.58 10.47 18.58 10.13 18.46C7.23 17.47 0.75 13.34 0.75 6.34C0.75 3.25 3.24 0.75 6.31 0.75C8.13 0.75 9.74 1.63 10.75 2.99C11.76 1.63 13.38 0.75 15.19 0.75C18.26 0.75 20.75 3.25 20.75 6.34C20.75 13.34 14.27 17.47 11.37 18.46Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuVouchers() {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75 11.5L13.75 5.5M13.7445 11.5H13.7535M7.74451 6H7.75349M18.25 9.25C18.25 7.87 19.37 6.75 20.75 6.75V5.75C20.75 1.75 19.75 0.75 15.75 0.75H5.75C1.75 0.75 0.75 1.75 0.75 5.75V6.25C2.13 6.25 3.25 7.37 3.25 8.75C3.25 10.13 2.13 11.25 0.75 11.25V11.75C0.75 15.75 1.75 16.75 5.75 16.75H15.75C19.75 16.75 20.75 15.75 20.75 11.75C19.37 11.75 18.25 10.63 18.25 9.25Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuCards() {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 5.75H20.75M4.75 14.245H6.75M9.75 14.245H13.75M5.19 0.75H16.3C19.86 0.75 20.75 1.63 20.75 5.14V13.35C20.75 16.86 19.86 17.74 16.31 17.74H5.19C1.64 17.75 0.75 16.87 0.75 13.36V5.14C0.75 1.63 1.64 0.75 5.19 0.75Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuPreferences() {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 13.1899C12.4069 13.1899 13.75 11.8467 13.75 10.1899C13.75 8.53302 12.4069 7.18988 10.75 7.18988C9.09315 7.18988 7.75 8.53302 7.75 10.1899C7.75 11.8467 9.09315 13.1899 10.75 13.1899Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 11.0699V9.30988C0.75 8.26988 1.6 7.40988 2.65 7.40988C4.46 7.40988 5.2 6.12988 4.29 4.55988C3.77 3.65988 4.08 2.48988 4.99 1.96988L6.72 0.979878C7.51 0.509878 8.53 0.789878 9 1.57988L9.11 1.76988C10.01 3.33988 11.49 3.33988 12.4 1.76988L12.51 1.57988C12.98 0.789878 14 0.509878 14.79 0.979878L16.52 1.96988C17.43 2.48988 17.74 3.65988 17.22 4.55988C16.31 6.12988 17.05 7.40988 18.86 7.40988C19.9 7.40988 20.76 8.25988 20.76 9.30988V11.0699C20.76 12.1099 19.91 12.9699 18.86 12.9699C17.05 12.9699 16.31 14.2499 17.22 15.8199C17.74 16.7299 17.43 17.8899 16.52 18.4099L14.79 19.3999C14 19.8699 12.98 19.5899 12.51 18.7999L12.4 18.6099C11.5 17.0399 10.02 17.0399 9.11 18.6099L9 18.7999C8.53 19.5899 7.51 19.8699 6.72 19.3999L4.99 18.4099C4.08 17.8899 3.77 16.7199 4.29 15.8199C5.2 14.2499 4.46 12.9699 2.65 12.9699C1.6 12.9699 0.75 12.1099 0.75 11.0699Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuInfo() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.89 20.37C16.01 20.63 14.97 20.75 13.75 20.75H7.75C6.53 20.75 5.49 20.63 4.61 20.37M16.89 20.37C16.67 17.77 14 15.72 10.75 15.72C7.5 15.72 4.83 17.77 4.61 20.37M16.89 20.37C19.61 19.6 20.75 17.53 20.75 13.75V7.75C20.75 2.75 18.75 0.75 13.75 0.75H7.75C2.75 0.75 0.75 2.75 0.75 7.75V13.75C0.75 17.53 1.89 19.6 4.61 20.37M10.75 12.92C8.77 12.92 7.17 11.31 7.17 9.33002C7.17 7.35002 8.77 5.75 10.75 5.75C12.73 5.75 14.33 7.35002 14.33 9.33002C14.33 11.31 12.73 12.92 10.75 12.92Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuSecurity() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.64259 16.2325L7.94259 18.5325M18.5426 13.6725C16.4826 15.7225 13.5326 16.3525 10.9426 15.5425L6.23259 20.2425C5.89259 20.5925 5.22259 20.8025 4.74259 20.7325L2.56259 20.4325C1.84259 20.3325 1.17259 19.6525 1.06259 18.9325L0.762588 16.7525C0.692588 16.2725 0.922588 15.6025 1.25259 15.2625L5.95259 10.5625C5.15259 7.9625 5.77259 5.0125 7.83259 2.9625C10.7826 0.0125 15.5726 0.0125 18.5326 2.9625C21.4926 5.9125 21.4926 10.7225 18.5426 13.6725ZM14.7526 8.2425C14.7526 9.07093 14.081 9.7425 13.2526 9.7425C12.4242 9.7425 11.7526 9.07093 11.7526 8.2425C11.7526 7.41407 12.4242 6.7425 13.2526 6.7425C14.081 6.7425 14.7526 7.41407 14.7526 8.2425Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuLogout() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.15 5.82C7.46 2.22 9.31 0.75 13.36 0.75H13.49C17.96 0.75 19.75 2.54 19.75 7.01V13.53C19.75 18 17.96 19.79 13.49 19.79H13.36C9.34 19.79 7.49 18.34 7.16 14.8M13.25 10.26H1.87M4.1 6.91L0.75 10.26L4.1 13.61"
        stroke="#334155"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AccountMenuDemoAccount() {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 20.75C0.75 16.88 4.6 13.75 9.34 13.75C10.3 13.75 11.23 13.88 12.1 14.12M16.83 16.73H13.85M15.34 15.27V18.26M14.34 5.75C14.34 8.51142 12.1014 10.75 9.34 10.75C6.57857 10.75 4.34 8.51142 4.34 5.75C4.34 2.98858 6.57857 0.75 9.34 0.75C12.1014 0.75 14.34 2.98858 14.34 5.75ZM19.34 16.75C19.34 17.07 19.3 17.38 19.22 17.68C19.13 18.08 18.97 18.47 18.76 18.81C18.07 19.97 16.8 20.75 15.34 20.75C14.31 20.75 13.38 20.36 12.68 19.72C12.38 19.46 12.12 19.15 11.92 18.81C11.55 18.21 11.34 17.5 11.34 16.75C11.34 15.67 11.77 14.68 12.47 13.96C13.2 13.21 14.22 12.75 15.34 12.75C16.52 12.75 17.59 13.26 18.31 14.08C18.95 14.79 19.34 15.73 19.34 16.75Z"
        stroke="#334155"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Marchants *************************************************************************************************************************

interface IconProps {
  color?: string;
}

const Icons = {
  // Main icons
  Add,
  AddButton,
  AddButtonAlt,
  AddTransaction,
  Alert,
  Admin,
  ArrowBackMobile,
  ArrowBackPanel,
  ArrowButton,
  ArrowDown,
  ArrowDownMobileFilter,
  ArrowUp,
  ArrowUp2,
  ArrowDownMobile,
  ArrowRight,
  ArrowLeftMobile,
  ArrowRightMobile,
  ArrowFooter,
  AddressCar,
  CardAddress,
  CardDetails,
  CardFavorite,
  CarouselPrevious,
  CarouselNext,
  Calendar,
  CalendarEdit,
  BadgeConfetti,
  CardPlastic,
  CardVirtual,
  Cards,
  CardTransactionTopup,
  CardTransactionBlue,
  CardTransactionCultural,
  CardTransactionGift,
  CardTransactionMeal,
  CardTransactionVacation,
  Cashback,
  Check,
  CheckDark,
  CheckAlt,
  Checklist,
  ChevronLeft,
  ClearFilters,
  CloseDelete,
  CloseSquare,
  Cog,
  CopyIcon,
  CopyIconSmall,
  Copy,
  Dashboard,
  DashboardCircle,
  DashedSeparator,
  Delete,
  DeleteAccount,
  DeleteButton,
  DeleteSmall,
  DialogBenefitTip,
  DialogFunds,
  DialogEdenredCards,
  DialogCreditCard,
  DownloadComputer,
  DownloadFile,
  Drag,
  Edit,
  EditBig,
  EditInvoicing,
  Employees,
  Favorite,
  Gift,
  Heart,
  HeartButton,
  Help,
  Home,
  Info,
  InfoBlue,
  InfoDashboard,
  InfoSummary,
  InfoSmall,
  InfoMedium,
  Invisible,
  Invoice,
  Language,
  Logout,
  Loading,
  MarkAll,
  Menu,
  MessageQuestion,
  Notification,
  NotificationsArrow,
  NotificationsClose,
  NotificationsError,
  NotificationsInfo,
  NotificationsRead,
  NotificationsNonRead,
  NotificationsTip,
  NotificationsSuccess,
  NotificationsWarning,
  OperationalServices,
  Padlock,
  PadlockOpen,
  PasswordShow,
  PasswordHide,
  PaymentOptions,
  PartyEmoji,
  Pension,
  ProductAdd,
  ProductRemove,
  Print,
  Report,
  ReportDone,
  ReportInProcess,
  ResendMail,
  Search,
  SearchList,
  SearchMobile,
  SearchNormal,
  Send,
  SendMail,
  ShoppingCart,
  ShoppingCartCheck,
  ShoppingCartMobile,
  SolidSeparator,
  SortAsc,
  SortDefault,
  SortDesc,
  SortSingle,
  Statistic,
  SubscriptionCashflow,
  Subtract,
  Tag,
  Ticket,
  TimeWorked,
  ToastActionArrow,
  User,
  UsersGroup,
  UserMobile,
  Voucher,
  Wallet,
  WeChat,
  HelpCardBudget,
  HelpCardAccount,
  HelpCardSpecialEvents,
  HelpCardVouchers,
  // Microillustrations
  Dislike,
  HelpRed,
  WarningRed,
  Like,
  LocationPin,
  Success,
  ToastError,
  ToastInfo,
  ToastShoppingCart,
  ToastSuccess,
  ToastSmart,
  VideoPlay,
  CardBalanceInfo,
  // Social media
  Fb,
  In,
  Yt,
  Instagram,
  AppDownloadQR,
  // Merchants
  MHome,
  MProducts,
  MStoreSettings,
  MInvoices,
  MNotifications,
  MNotificationsUnread,
  MAnalytics,
  MMembers,
  MMarketing,
  MSupport,
  MBrandSelect,
  MNavDown,
  MNavUp,
  MFb,
  MYt,
  MIn,
  MExport,
  MAddProduct,
  MDataSearch,
  MDataCloseSearch,
  MActionArrow,
  MHelpStepsCompany,
  MHelpStepsProducts,
  MHelpStepsNew,
  MHelpStepsVouchers,
  MHelpStepsInvoices,
  MHelpStepsAnalytics,
  MAddLocation,
  MLocationList,
  MLocationEdit,
  MLocationDelete,
  MInfoTooltip,
  MButtonAdd,
  MDownloadCodes,
  MButtonReplace,
  MButtonReplaceFile,
  MCodesAdd,
  MCodesUploadFile,
  MDownloadTemplate,
  MAddUser,
  MSaveCode,
  MWelcomeProducts,
  MFlagRo,
  MFlagUk,
  MNotificationArrow,
  TutorialslHelp,
  TutorialsClose,
  TutorialsVideoClock,
  TutorialsVideoPlay,
  AccountMenuDashboard,
  AccountMenuAttendance,
  AccountMenuOrders,
  AccountMenuSubscriptions,
  AccountMenuNotifications,
  AccountMenuFavorite,
  AccountMenuVouchers,
  AccountMenuCards,
  AccountMenuPreferences,
  AccountMenuInfo,
  AccountMenuSecurity,
  AccountMenuLogout,
  AccountMenuDemoAccount,
  ApplyCashback,
  CashbackApplyed,
  CashbackToApply,
  CopyClipboardIcon,
};

export default Icons;
